// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/corporate-ambient.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/corporate-lattice.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/corporate-sheen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/corporate-ambient-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/corporate-lattice-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/corporate-sheen-dark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #101828;
  background-color: #f5f7fb;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f5f7fb;
}

.auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: radial-gradient(circle at top, rgba(79, 70, 229, 0.08), transparent),
    #f5f7fb;
}

.login-card {
  width: min(480px, 100%);
  background: white;
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login-card label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-weight: 600;
}

.login-card input {
  border-radius: 0.85rem;
  border: 1px solid #e4e7ec;
  padding: 0.85rem 1rem;
  font-size: 0.95rem;
  font-family: inherit;
}

.auth-footnote {
  border-top: 1px solid #f1f5f9;
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  color: #475467;
  font-size: 0.85rem;
}

.auth-footnote strong {
  color: #101828;
}

.app-shell {
  min-height: 100vh;
  padding: 2.5rem clamp(1.25rem, 4vw, 4rem) 3rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.app-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  color: #4f46e5;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.app-header h1 {
  margin: 0;
  font-size: clamp(1.9rem, 3vw, 2.8rem);
}

.subtitle {
  margin-top: 0.5rem;
  max-width: 720px;
  color: #5f6c89;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.btn {
  border: none;
  border-radius: 999px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
}

.btn.compact {
  padding: 0.45rem 1rem;
  font-size: 0.82rem;
}

.theme-toggle-corner {
  position: fixed;
  top: 0.75rem;
  right: 0.75rem;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid rgba(23, 42, 58, 0.22);
  background: rgba(255, 255, 255, 0.7);
  color: #35546a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 110;
  opacity: 0.3;
  backdrop-filter: blur(5px);
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.theme-toggle-corner:hover,
.theme-toggle-corner:focus-visible {
  opacity: 0.95;
  transform: translateY(-1px);
  border-color: rgba(23, 42, 58, 0.45);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.2);
}

.theme-toggle-corner span {
  font-size: 0.9rem;
  line-height: 1;
  pointer-events: none;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.btn.primary {
  background: linear-gradient(120deg, #4f46e5, #7c3aed);
  color: white;
  box-shadow: 0 10px 20px rgba(79, 70, 229, 0.2);
}

.btn.ghost {
  background: transparent;
  color: #4f46e5;
  border: 1px solid rgba(79, 70, 229, 0.3);
}

.btn.secondary {
  background: rgba(79, 70, 229, 0.08);
  color: #312e81;
  border: 1px solid rgba(79, 70, 229, 0.2);
  box-shadow: 0 6px 15px rgba(79, 70, 229, 0.15);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 1rem;
}

.filters {
  background: white;
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.view-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.pill-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.pill {
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: transparent;
  padding: 0.45rem 1rem;
  font-weight: 600;
  cursor: pointer;
}

.pill.active {
  background: #4f46e5;
  color: white;
  border-color: transparent;
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.25);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 1rem;
}

.summary-card {
  background: white;
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 10px 35px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: default;
}

.summary-card.active {
  border: 1px solid #4f46e5;
  box-shadow: 0 12px 30px rgba(79, 70, 229, 0.25);
  transform: translateY(-4px);
}

.summary-card.clickable {
  cursor: pointer;
}

.summary-card:focus {
  outline: 2px solid #4f46e5;
}

.summary-card .label {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.7rem;
  color: #94a3b8;
  margin: 0 0 0.25rem;
}

.summary-card h2 {
  margin: 0;
  font-size: 1.75rem;
}

.summary-card span {
  color: #475467;
  font-size: 0.9rem;
}

.content-grid {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: 1.5rem;
}

.content-grid.pulse-collapsed {
  grid-template-columns: minmax(0, 1fr);
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 3rem 1rem;
  z-index: 50;
  overflow-y: auto;
}

.overlay.activity-overlay {
  z-index: 60;
}

.overlay.upload-overlay {
  z-index: 70;
}

.overlay.notes-overlay {
  z-index: 80;
}

.airtable-modal {
  background: white;
  border-radius: 1.5rem;
  padding: 1.5rem;
  width: min(1100px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.modal-header h3 {
  margin: 0;
}

.modal-header p {
  margin: 0.35rem 0 0;
  color: #475467;
}

.airtable-frame {
  border-radius: 1rem;
  overflow: hidden;
  background: white;
}

.airtable-embed {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  background: transparent;
}

.automation-upload-card {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  width: min(640px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);
}

.activity-modal {
  background: white;
  border-radius: 1.25rem;
  padding: 1.25rem 1.5rem;
  width: min(960px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.35);
}

.activity-modal-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-modal-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-modal-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  align-items: stretch;
  width: 100%;
}

.activity-modal-row > * {
  flex: 1 1 min(280px, 100%);
}

.activity-modal-row .client-cell,
.activity-modal-row .activity-responsable {
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 0.85rem 1rem;
  background: #f8fafc;
  min-height: 100%;
}

.activity-modal-row .activity-chip.condensed {
  width: 100%;
}

.activity-chip.condensed .btn {
  margin-top: 0.4rem;
  align-self: flex-start;
}

@media (orientation: landscape) and (min-width: 1100px) {
  .activity-modal-row {
    flex-wrap: wrap;
  }
  .activity-modal-row .client-cell,
  .activity-modal-row .activity-responsable {
    flex: 1 1 240px;
  }
  .activity-modal-row .activity-chip.condensed {
    flex: 1 1 200px;
  }
}

.activity-detail {
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  background: #f8fafc;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #0f172a;
}

.whatsapp-modal {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  width: min(640px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.35);
}

.automation-upload-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.automation-upload-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-weight: 600;
}

.automation-upload-grid input[type="file"] {
  border: 1px dashed #cbd5f5;
  border-radius: 0.85rem;
  padding: 0.65rem;
  background: #f8fafc;
  font-family: inherit;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  background: #eef2ff;
  color: #312e81;
  font-size: 0.8rem;
}

.tax-upload-dialog {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  width: min(720px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.35);
}

.tax-upload-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.tax-upload-stepper {
  display: flex;
  gap: 0.75rem;
}

.tax-upload-step {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  border: 1px solid #e4e7ec;
  background: #f9fafb;
  font-size: 0.85rem;
  color: #475467;
}

.tax-upload-step span {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  background: #e0e7ff;
  color: #4338ca;
}

.tax-upload-step.active {
  border-color: #6366f1;
  background: #eef2ff;
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.2);
}

.tax-upload-step.active span {
  background: #4338ca;
  color: #fff;
}

.tax-upload-step-panel {
  display: block;
  width: 100%;
}

.tax-upload-step-panel.is-hidden {
  display: none;
}

.tax-note-summary {
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  background: linear-gradient(135deg, #f9fafb 0%, #eef2ff 100%);
  padding: 1rem;
  margin-bottom: 1rem;
}

.tax-note-summary-header {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin-bottom: 0.35rem;
}

.tax-note-summary-grid {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem;
}

.tax-note-summary-grid li {
  padding: 0.75rem 0.85rem;
  border-radius: 0.85rem;
  background: #fff;
  border: 1px solid #e4e7ec;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.tax-note-summary-grid .label {
  font-size: 0.8rem;
  color: #6b7280;
}

.note-summary-raw {
  margin: 0.35rem 0 0;
  padding: 0.75rem 0.85rem;
  background: #fff;
  border-radius: 0.85rem;
  border: 1px dashed #cbd5e1;
  color: #334155;
  font-size: 0.9rem;
  white-space: pre-wrap;
}

.tax-locked-card {
  border: 1px dashed #f59e0b;
  background: #fff7ed;
  border-radius: 1rem;
  padding: 0.85rem 0.95rem;
  margin-bottom: 1rem;
}

.tax-upload-step-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.tax-upload-step-panel-header .link-btn {
  font-size: 0.9rem;
  padding: 0;
}

.tax-legacy-upload-card {
  border: 1px solid #dbe3f0;
  border-radius: 1rem;
  padding: 0.95rem;
  background: linear-gradient(145deg, #f8fbff, #f2f7ff);
  display: grid;
  gap: 0.85rem;
}

.tax-legacy-upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.tax-legacy-upload-header small {
  display: block;
  color: #475467;
}

.info-toggle.compact {
  padding: 0.38rem 0.85rem;
  font-size: 0.82rem;
  white-space: nowrap;
}

@media (max-width: 760px) {
  .tax-legacy-upload-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.tax-dropzone {
  border: 1.5px dashed #cbd5f5;
  border-radius: 1rem;
  padding: 1.5rem;
  text-align: center;
  background: #f8fafc;
  position: relative;
}

.tax-dropzone input[type="file"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.tax-dropzone.dragging {
  border-color: #4f46e5;
  background: rgba(79, 70, 229, 0.05);
}

.tax-dropzone span {
  color: #4f46e5;
  font-weight: 600;
}

.tax-upload-file-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  background: #f9fafb;
}

.tax-upload-file-list li {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e4e7ec;
  font-size: 0.9rem;
}

.tax-upload-file-list li:last-child {
  border-bottom: none;
}

.tax-requirements {
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 1rem;
  background: #fff;
}

.tax-requirements ul {
  margin: 0.5rem 0 0;
  padding-left: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #475467;
}

.notes-modal {
  background: #fff;
  border-radius: 1.5rem;
  width: min(520px, 100%);
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);
}

.notes-modal-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.note-requirements {
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 0.85rem 1rem;
  background: #f8fafc;
}

.note-requirements h4 {
  margin: 0 0 0.35rem;
  font-size: 0.85rem;
  color: #0f172a;
}

.note-requirements ul {
  margin: 0;
  padding-left: 1rem;
  color: #475467;
  font-size: 0.85rem;
}

.notes-modal textarea {
  min-height: 140px;
  border-radius: 1rem;
  border: 1px solid #e4e7ec;
  padding: 0.9rem;
  font-family: inherit;
  resize: vertical;
}

.notes-modal textarea[readonly] {
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.notes-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.note-status {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0.35rem 0 0;
}

.note-status.saving {
  color: #2563eb;
}

.note-status.saved {
  color: #15803d;
}

.note-status.error,
.note-status.note-status-error {
  color: #b91c1c;
}

.tax-metadata-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.85rem;
}

.tax-metadata-grid label {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.85rem 0.95rem 0.9rem;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  background: linear-gradient(145deg, #f8fafc, #eef2ff);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.65);
  font-weight: 600;
  font-size: 0.85rem;
  color: #111827;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease, background 0.25s ease;
}

.tax-metadata-grid label:focus-within {
  border-color: #4338ca;
  background: linear-gradient(145deg, #eef2ff, #f8fafc);
  box-shadow: 0 10px 28px rgba(67, 56, 202, 0.18), 0 0 0 4px rgba(67, 56, 202, 0.12);
  transform: translateY(-1px);
}

.tax-metadata-grid input {
  border-radius: 0.85rem;
  border: 1px solid #e4e7ec;
  padding: 0.7rem 0.9rem;
  font-size: 0.95rem;
  font-family: inherit;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.25s ease;
}

.tax-metadata-grid input:hover {
  border-color: #cbd5e1;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06), 0 4px 10px rgba(15, 23, 42, 0.04);
  background: linear-gradient(180deg, #ffffff, #f1f5f9);
}

.tax-metadata-grid input::placeholder {
  color: #94a3b8;
}

.tax-metadata-grid input:focus,
.tax-metadata-grid select:focus {
  outline: none;
  border-color: #4338ca;
  box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.15);
  background: #fff;
}

.tax-metadata-grid input[readonly],
.tax-metadata-grid input:disabled,
.tax-metadata-grid select:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

.tax-metadata-grid select {
  border-radius: 0.85rem;
  border: 1px solid #e4e7ec;
  padding: 0.65rem 0.85rem;
  font-size: 0.9rem;
  font-family: inherit;
  background: #fff;
}

.tax-email-preview {
  margin-top: 0.75rem;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 1rem;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.email-recipient-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.email-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #eef2ff;
  color: #312e81;
  font-size: 0.8rem;
}

.email-recipient-input {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.email-recipient-input input[type="email"] {
  flex: 1 1;
  border-radius: 0.75rem;
  border: 1px solid #e4e7ec;
  padding: 0.6rem 0.8rem;
  font-size: 0.9rem;
  font-family: inherit;
}

.email-preview-textarea {
  width: 100%;
  min-height: 180px;
  border-radius: 0.85rem;
  border: 1px solid #e4e7ec;
  padding: 0.75rem 0.9rem;
  font-size: 0.9rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  resize: vertical;
  background: #fff;
  color: #0f172a;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.create-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  width: min(780px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);
}

.create-card label {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-weight: 600;
  color: #101828;
}

.create-card input,
.create-card select,
.create-card textarea {
  max-width: 100%;
  border-radius: 0.75rem;
  border: 1px solid #e4e7ec;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  font-family: inherit;
}

.phone-input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.phone-lada-select {
  min-width: 88px;
  flex-shrink: 0;
}

.phone-number-input {
  flex: 1 1;
}

.upload-field input[type="file"] {
  border: 1px dashed #cbd5f5;
  background: #fff;
  padding: 0.85rem;
  cursor: pointer;
}

.upload-list {
  list-style: none;
  margin: 0.5rem 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.upload-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f1f5f9;
  border-radius: 0.65rem;
  padding: 0.35rem 0.75rem;
  font-size: 0.85rem;
}

.upload-list li small {
  color: #475467;
}

.form-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.form-header h3 {
  margin: 0;
}

.form-header p {
  margin: 0.35rem 0 0;
  color: #475467;
}

.create-stepper {
  display: flex;
  gap: 0.75rem;
  font-size: 0.85rem;
}

.create-stepper .step {
  flex: 1 1;
  padding: 0.6rem 0.75rem;
  text-align: center;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475467;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

.create-stepper .step.active {
  background: #4f46e5;
  border-color: #4f46e5;
  color: white;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.info-box {
  background: #eef2ff;
  border: 1px dashed #c7d2fe;
  border-radius: 1rem;
  padding: 0.85rem 1rem;
  color: #312e81;
  font-size: 0.9rem;
}

.info-box ul {
  margin: 0.35rem 0 0;
  padding-left: 1.2rem;
}

.info-box li {
  margin-bottom: 0.25rem;
}

.info-box.notice {
  background: #ecfccb;
  border-color: #bef264;
  color: #365314;
}

.form-section h4 {
  margin: 0;
  font-size: 1rem;
  color: #0f172a;
}

.form-grid {
  display: grid;
  gap: 0.75rem;
}

.form-grid.two {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.form-grid.two > * {
  min-width: 0;
}

.full-width {
  grid-column: 1 / -1;
}

.search-combobox {
  position: relative;
}

.search-combobox input {
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  padding: 0.75rem 1rem;
  font-family: inherit;
  font-size: 0.95rem;
}

.search-combobox.open input {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  border-color: #c7d2fe;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.combobox-options {
  position: absolute;
  top: calc(100% + 2px);
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.15);
  z-index: 10;
}

.combobox-options li {
  padding: 0.55rem 0.85rem;
  cursor: pointer;
  font-size: 0.9rem;
}

.combobox-options li:hover {
  background: #eef2ff;
  color: #4338ca;
}


.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
}

.board,
.side-panel section {
  background: white;
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.section-header > * {
  min-width: 0;
}

.section-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.table-filters {
  margin-top: 1.25rem;
  padding: 1rem 1.25rem;
  border: 1px solid #eef2ff;
  border-radius: 1rem;
  background: #f8f9ff;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.filter-control {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475467;
}

.filter-control select,
.filter-control input {
  border-radius: 0.75rem;
  border: 1px solid #e4e7ec;
  padding: 0.6rem 0.75rem;
  font-family: inherit;
  font-size: 0.94rem;
  background: white;
}

.search-control {
  grid-column: span 2;
}

@media (max-width: 768px) {
  .search-control {
    grid-column: span 1;
  }
}

.board-table {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: relative;
}

.table-head,
.table-row {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 1rem;
  font-size: 0.9rem;
}

.table-head {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.75rem;
  color: #94a3b8;
}

.table-row {
  padding: 1rem 1.25rem;
  background: #f9fafb;
  border-radius: 0.85rem;
  align-items: center;
}

.table-row > * {
  min-width: 0;
}

.board-table .table-row span,
.board-table .table-row strong {
  overflow-wrap: anywhere;
}

.table-loading {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.75rem;
  z-index: 2;
}

.helper-text {
  margin: 0.5rem 0 0;
  font-size: 0.85rem;
  color: #475467;
}

.helper-text.folder-url {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.75rem;
  padding: 0.75rem 0.9rem;
  border-radius: 0.85rem;
  border: 1px solid #f6d9a7;
  background: #fef7e7;
  color: #7a4a00;
  font-weight: 600;
}

.helper-text.folder-url .folder-url-link {
  color: #7a4a00;
  font-weight: 600;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

.helper-text.folder-url .folder-url-label {
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #9a5b00;
}

.loader {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.loader-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4f46e5;
  animation: pulse 1s infinite ease-in-out;
}

.loader-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.loader-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes pulse {
  0%, 80%, 100% {
    opacity: 0.2;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-4px);
  }
}

.helper-text.error {
  color: #b42318;
}

.helper-text.warning {
  color: #b45309;
}

.helper-text.success {
  color: #027a48;
}

.approved-view {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
}

.approved-view header {
  margin-bottom: 1rem;
}

.approved-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.approved-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  background: #fdfdfd;
  flex-wrap: wrap;
}

.approved-card h4 {
  margin: 0 0 0.35rem;
}

.approved-card p {
  margin: 0;
  color: #475467;
}

.approved-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.attendance-view {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.attendance-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  flex-wrap: wrap;
}

.attendance-header h2 {
  margin: 0.25rem 0;
}

.attendance-header p {
  margin: 0;
  color: #475467;
  max-width: 760px;
}

.attendance-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.attendance-filters {
  margin-top: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;
}

.attendance-filters .filter-control {
  flex: 1 1 180px;
  min-width: 180px;
}

.attendance-filters .search-control {
  flex: 2 1 280px;
}

.attendance-filters .center-filter-group {
  flex: 1 1 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.attendance-filters .center-filter-group > span {
  white-space: nowrap;
}

.attendance-filters .center-filter-options {
  margin-top: 0;
  flex: 1 1 auto;
}

.attendance-export-panel {
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  padding: 1.25rem;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.attendance-export-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  flex-wrap: wrap;
}

.attendance-export-header h3 {
  margin: 0 0 0.25rem;
}

.attendance-export-header p {
  margin: 0;
  color: #64748b;
}

.attendance-export-actions {
  display: flex;
  gap: 0.5rem;
}

.attendance-export-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.attendance-export-item {
  display: grid;
  grid-template-columns: auto minmax(0, 1.6fr) auto auto;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.attendance-export-item.ready {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.attendance-export-item.missing {
  border-color: #fde68a;
  background: #fffbeb;
}

.attendance-export-check input {
  width: 18px;
  height: 18px;
}

.attendance-export-info strong {
  display: block;
}

.attendance-export-info span {
  display: block;
  color: #64748b;
  font-size: 0.85rem;
}

.attendance-export-status {
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  border: 1px solid transparent;
}

.attendance-export-status.ready {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.attendance-export-status.missing {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.center-filter-group {
  align-items: flex-start;
}

.center-filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.35rem;
}

.center-chip {
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  padding: 0.35rem 0.8rem;
  background: #ffffff;
  color: #475467;
  font-weight: 600;
  font-size: 0.78rem;
  cursor: pointer;
  opacity: 0.55;
  filter: saturate(0.6);
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease, filter 0.2s ease;
}

.center-chip.active {
  border-color: #0f172a;
  color: #0f172a;
  background: #e2e8f0;
  opacity: 1;
  filter: saturate(1);
}

.center-chip.center-cuu-ac-servicios-2020-sc {
  background: #ecfeff;
  border-color: #67e8f9;
  color: #0e7490;
}

.center-chip.center-luz-elena-najera-sanchez {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #4338ca;
}

.center-chip.center-argelia-fernandez-de-haro {
  background: #fef9c3;
  border-color: #fde047;
  color: #854d0e;
}

.attendance-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.75rem;
}

.attendance-summary-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  padding: 1rem;
  background: #f8fafc;
}

.attendance-summary-card h3 {
  margin: 0.1rem 0 0;
  font-size: 1.65rem;
}

.attendance-table-wrap {
  overflow-x: auto;
}

.attendance-table {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  min-width: 980px;
}

.attendance-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.attendance-group-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.95rem;
  border: 1px solid #e2e8f0;
  background: #f1f5f9;
}

.attendance-group-toggle {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid #cbd5f5;
  background: #ffffff;
  color: #1e293b;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.attendance-group-info strong {
  display: block;
}

.attendance-group-info small {
  display: block;
  color: #64748b;
}

.attendance-group-meta {
  margin-left: auto;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.82rem;
  color: #475467;
  font-weight: 600;
}

.attendance-table-head,
.attendance-table-row {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) repeat(7, minmax(90px, 1fr));
  gap: 0.75rem;
  align-items: center;
}

.attendance-table-head {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  color: #94a3b8;
  padding: 0 0.25rem;
}

.attendance-table-row {
  border: 1px solid #e4e7ec;
  border-radius: 0.95rem;
  padding: 0.85rem 1rem;
  background: #fdfdfd;
  font-size: 0.9rem;
}

.attendance-table-row strong {
  display: block;
}

.attendance-table-row small {
  color: #667085;
  display: block;
  margin-top: 0.2rem;
}

.attendance-chip {
  border-radius: 999px;
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
  border: 1px solid transparent;
}

.attendance-chip.state.cerrada {
  background: #ecfdf3;
  border-color: #abefc6;
  color: #067647;
}

.attendance-chip.state.abierta {
  background: #eef4ff;
  border-color: #c7d7fe;
  color: #3538cd;
}

.attendance-chip.state.incompleta {
  background: #fff8e8;
  border-color: #f9dbaf;
  color: #b54708;
}

.attendance-chip.validation.valida {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}

.attendance-chip.validation.fuera-de-horario,
.attendance-chip.validation.duplicado,
.attendance-chip.validation.token-invalido,
.attendance-chip.validation.usuario-inactivo {
  background: #fff4ed;
  border-color: #ffd6ae;
  color: #c2410c;
}

.attendance-overlay {
  align-items: flex-start;
}

.attendance-missing-modal {
  background: #ffffff;
  border-radius: 1.5rem;
  padding: 1.75rem;
  width: min(980px, 100%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);
}

.attendance-modal-badge {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  background: #0f172a;
  color: #ffffff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.attendance-missing-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 420px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.attendance-missing-row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 0.9rem;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.attendance-missing-row.complete {
  background: #f8fafc;
}

.attendance-missing-row strong {
  display: block;
}

.attendance-missing-row small {
  color: #64748b;
}

.attendance-missing-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.attendance-missing-actions select {
  min-width: 160px;
}

.attendance-missing-status {
  font-weight: 600;
  color: #16a34a;
}

.attendance-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  border-top: 1px solid #e2e8f0;
  padding-top: 1rem;
  color: #475467;
}

.whatsapp-preview {
  width: 100%;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 0.9rem;
  padding: 0.9rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.whatsapp-bubble {
  background: white;
  border-radius: 0.8rem;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(17, 94, 89, 0.2);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #065f46;
  font-size: 0.9rem;
}

.whatsapp-bubble a {
  color: #15803d;
  font-weight: 600;
  word-break: break-all;
}

.whatsapp-bubble em {
  color: #b45309;
}

.control-overview {
  position: relative;
  overflow: hidden;
  background: linear-gradient(165deg, #ffffff 0%, #f9fbff 55%, #f0f5ff 100%);
  border-radius: 1.5rem;
  padding: 1.75rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  isolation: isolate;
}

.control-overview::before {
  content: '';
  position: absolute;
  top: -120px;
  right: -120px;
  width: 360px;
  height: 360px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.18), rgba(59, 130, 246, 0.02));
  z-index: -1;
}

.overview-animate {
  opacity: 0;
  transform: translateY(16px);
  animation: overview-fade-up 520ms cubic-bezier(0.18, 0.7, 0.2, 1) forwards;
  animation-delay: var(--stagger-delay, 0ms);
}

@keyframes overview-fade-up {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.control-header h2 {
  margin: 0.25rem 0;
}

.control-header p {
  margin: 0.35rem 0 0;
  color: #475467;
  max-width: 720px;
}

.overview-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));
  gap: 0.85rem;
}

.overview-metric-card {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(4px);
  padding: 0.95rem 1rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.overview-metric-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.1);
}

.overview-metric-card .label {
  margin: 0;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.overview-metric-card strong {
  display: block;
  margin-top: 0.35rem;
  font-size: 1.7rem;
  line-height: 1.05;
  color: #111827;
}

.overview-metric-card span {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.88rem;
  color: #334155;
}

.overview-metric-card small {
  display: block;
  margin-top: 0.4rem;
  color: #475569;
  font-size: 0.78rem;
}

.overview-metric-card.tone-success {
  border-color: rgba(22, 163, 74, 0.25);
  background: linear-gradient(135deg, rgba(236, 253, 245, 0.95), rgba(240, 253, 250, 0.75));
}

.overview-metric-card.tone-warning {
  border-color: rgba(245, 158, 11, 0.25);
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.95), rgba(255, 247, 237, 0.72));
}

.overview-metric-card.tone-danger {
  border-color: rgba(239, 68, 68, 0.28);
  background: linear-gradient(135deg, rgba(254, 242, 242, 0.95), rgba(254, 226, 226, 0.72));
}

.overview-table-panel,
.overview-performance-panel,
.overview-board-panel {
  border: 1px solid #e2e8f0;
  border-radius: 1.15rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.07);
}

.overview-panel-header {
  display: flex;
  justify-content: space-between;
  gap: 0.85rem;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.overview-panel-header h3 {
  margin: 0;
}

.overview-panel-header p {
  margin: 0.3rem 0 0;
  color: #475467;
  font-size: 0.9rem;
}

.overview-table-wrap {
  overflow-x: auto;
}

.overview-table {
  width: 100%;
  min-width: 700px;
  border-collapse: collapse;
}

.overview-table th,
.overview-table td {
  text-align: left;
  padding: 0.72rem 0.62rem;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}

.overview-table th {
  color: #64748b;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.overview-table td {
  font-size: 0.89rem;
  color: #1f2937;
}

.overview-table tbody tr:hover {
  background: rgba(99, 102, 241, 0.05);
}

.overview-module-cell {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.overview-module-cell strong {
  display: block;
}

.overview-module-cell small {
  display: block;
  margin-top: 0.18rem;
  color: #64748b;
  font-size: 0.79rem;
}

.status-dot {
  width: 0.62rem;
  height: 0.62rem;
  border-radius: 999px;
  box-shadow: 0 0 0 5px rgba(148, 163, 184, 0.16);
  flex: 0 0 auto;
}

.status-dot.success {
  background: #16a34a;
  box-shadow: 0 0 0 5px rgba(22, 163, 74, 0.18);
}

.status-dot.warning {
  background: #f59e0b;
  box-shadow: 0 0 0 5px rgba(245, 158, 11, 0.18);
}

.status-dot.danger {
  background: #ef4444;
  box-shadow: 0 0 0 5px rgba(239, 68, 68, 0.18);
}

.status-dot.neutral {
  background: #64748b;
  box-shadow: 0 0 0 5px rgba(148, 163, 184, 0.18);
}

.overview-performance-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 0.85rem;
}

.overview-performance-item {
  border: 1px solid #e2e8f0;
  border-radius: 0.95rem;
  padding: 0.85rem 0.95rem;
  background: #fff;
  animation: overview-fade-up 520ms cubic-bezier(0.18, 0.7, 0.2, 1) forwards;
  animation-delay: var(--stagger-delay, 0ms);
  opacity: 0;
  transform: translateY(16px);
}

.overview-performance-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
}

.overview-performance-head strong {
  color: #0f172a;
}

.overview-performance-head span {
  color: #334155;
  font-size: 1.1rem;
  font-weight: 700;
}

.overview-performance-item p {
  margin: 0.45rem 0 0.55rem;
  color: #64748b;
  font-size: 0.84rem;
}

.overview-progress-track {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0.58rem;
  border-radius: 999px;
  background: #e2e8f0;
}

.overview-progress-fill {
  display: block;
  height: 100%;
  width: 0;
  border-radius: inherit;
  animation: overview-progress-grow 700ms ease forwards;
  animation-delay: 130ms;
}

@keyframes overview-progress-grow {
  to {
    width: var(--progress-width, 0%);
  }
}

.overview-progress-fill.tone-success {
  background: linear-gradient(90deg, #16a34a, #22c55e);
}

.overview-progress-fill.tone-warning {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.overview-progress-fill.tone-danger {
  background: linear-gradient(90deg, #ef4444, #fb7185);
}

.overview-progress-fill.tone-neutral {
  background: linear-gradient(90deg, #334155, #64748b);
}

.control-board-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.control-board-card {
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  padding: 1.25rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.control-board-card:hover {
  transform: translateY(-3px);
  border-color: rgba(79, 70, 229, 0.28);
  box-shadow: 0 18px 35px rgba(79, 70, 229, 0.16);
}

.control-board-card.disabled {
  opacity: 0.75;
  transform: none;
}

.control-board-card.disabled:hover {
  transform: none;
  border-color: #e2e8f0;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
}

.control-board-body h3 {
  margin: 0 0 0.35rem;
}

.control-board-body p {
  margin: 0;
  color: #475467;
}

.control-board-body ul {
  list-style: none;
  padding: 0;
  margin: 1rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.control-board-body li {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #475467;
}

.control-board-body li strong {
  font-size: 1.1rem;
  color: #111827;
}

.control-board-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.tax-view {
  background: white;
  border-radius: 1.5rem;
  padding: 1.75rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.tax-header h2 {
  margin: 0.15rem 0;
}

.tax-header p {
  margin: 0.35rem 0 0;
  color: #475467;
  max-width: 720px;
}

.tax-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.tax-subtabs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tax-controls {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
}

.tax-month-control {
  flex: 1 1;
  min-width: 240px;
}

.month-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.month-pill {
  border: 1px solid #d4d4d8;
  border-radius: 0.65rem;
  padding: 0.4rem 0.9rem;
  background: #f8fafc;
  font-weight: 600;
  cursor: pointer;
  color: #0f172a;
}

.month-pill.active {
  background: #4f46e5;
  color: white;
  border-color: transparent;
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.25);
}

.tax-year-select {
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tax-year-select select {
  border: 1px solid #d4d4d8;
  border-radius: 0.65rem;
  padding: 0.45rem 0.75rem;
  font-size: 0.95rem;
  font-family: inherit;
  background: #fff;
}

.tax-search {
  flex: 1 1;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tax-search input {
  border: 1px solid #d4d4d8;
  border-radius: 0.65rem;
  padding: 0.45rem 0.75rem;
  font-size: 0.95rem;
  font-family: inherit;
  background: #fff;
}

.tax-info-toggle {
  min-width: 180px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.info-toggle {
  border-radius: 999px;
  border: 1px dashed #c7d2fe;
  padding: 0.45rem 1.1rem;
  font-weight: 600;
  background: rgba(79, 70, 229, 0.08);
  color: #4f46e5;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.info-toggle.active {
  background: #4f46e5;
  color: #fff;
  border-color: transparent;
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.3);
}

.tax-info-toggle small {
  color: #475467;
  font-size: 0.78rem;
}

.tax-summary-card {
  border-radius: 1rem;
  padding: 1.25rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.tax-summary-card strong {
  font-size: 2rem;
}

.tax-summary-card span {
  color: #475467;
}

.tax-summary-card.active {
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.25);
  border-color: #4f46e5;
}

.tax-summary-card.success {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.tax-summary-card.warning {
  border-color: #fde68a;
  background: #fffbeb;
}

.tax-summary-card.danger {
  border-color: #fecaca;
  background: #fef2f2;
}

.tax-board-grid {
  display: grid;
  grid-template-columns: minmax(240px, 0.8fr) minmax(0, 2fr);
  gap: 1.5rem;
}

.tax-upload-grid {
  grid-template-columns: minmax(0, 1.85fr) minmax(260px, 0.9fr);
  align-items: flex-start;
}

.tax-board-grid.info-collapsed {
  grid-template-columns: 1fr;
}

.tax-main-panel,
.tax-side-panel {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.tax-checklist {
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  background: #f8fafc;
  padding: 1.25rem;
}

.tax-checklist h3 {
  margin: 0 0 0.75rem;
}

.tax-checklist ul {
  margin: 0;
  padding-left: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #475467;
}

.tax-status-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: flex-end;
}

.tax-table-stack {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.tax-table-card {
  border-radius: 1.25rem;
  border: 1px solid #e4e7ec;
  padding: 1.5rem;
  background: #fff;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.07);
}

.tax-upload-table-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tax-upload-table-card .tax-table {
  flex: 1 1;
}

.tax-table-card .section-header p {
  margin-top: 0.35rem;
  color: #475467;
}

.tax-table {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.tax-upload-table {
  overflow-x: auto;
  padding-bottom: 0.25rem;
}

.tax-upload-table .tax-table-head,
.tax-upload-table .tax-table-row {
  min-width: 1020px;
}

.activity-table {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 1.25rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.activity-head,
.activity-row {
  display: grid;
  grid-template-columns: var(--activity-grid, 1.4fr repeat(4, minmax(0, 1fr)) 1fr);
  gap: 0.75rem;
  align-items: center;
}

.activity-head {
  text-transform: uppercase;
  font-size: 0.72rem;
  color: #94a3b8;
  letter-spacing: 0.08em;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0.9rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid #e2e8f0;
}

.activity-row {
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
  gap: 0.85rem;
}

.client-cell {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  border: none;
  background: transparent;
  cursor: pointer;
}

.client-cell strong {
  font-size: 0.95rem;
  color: #0f172a;
}

.client-cell small {
  color: #94a3b8;
  font-size: 0.78rem;
}

.activity-cell {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.activity-cell.disabled-cell {
  opacity: 0.4;
}


.activity-chip {
  border: 1px solid #e4e7ec;
  border-radius: 0.95rem;
  padding: 0.55rem 0.85rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-height: 72px;
  box-shadow: inset 0 1px 0 rgba(15, 23, 42, 0.02);
}

.activity-chip strong {
  font-size: 0.9rem;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.activity-chip small {
  color: #475467;
  font-size: 0.78rem;
}

.activity-chip.condensed {
  min-height: auto;
  padding: 0.45rem 0.65rem;
}

.activity-chip.muted {
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #94a3b8;
}

.activity-chip.done {
  background: rgba(22, 163, 74, 0.12);
  border-color: rgba(22, 163, 74, 0.4);
  color: #15803d;
}

.activity-chip.ontrack {
  background: rgba(34, 197, 94, 0.12);
  border-color: rgba(34, 197, 94, 0.4);
  color: #15803d;
}

.activity-chip.dueSoon {
  background: rgba(251, 146, 60, 0.15);
  border-color: rgba(251, 146, 60, 0.4);
  color: #b45309;
}

.activity-chip.late {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.45);
  color: #b91c1c;
}

.activity-chip.pending {
  background: rgba(250, 204, 21, 0.18);
  border-color: rgba(250, 204, 21, 0.4);
  color: #92400e;
}

.activity-chip.na {
  background: rgba(148, 163, 184, 0.18);
  border-color: rgba(148, 163, 184, 0.35);
  color: #475467;
}

.activity-responsable {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  align-items: flex-start;
}

.activity-responsable strong {
  color: #0f172a;
}

.activity-responsable small {
  color: #94a3b8;
}

.chip-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.activity-legend-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: flex-end;
}

.activity-legend-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  color: #0f172a;
  font-size: 0.82rem;
}

.tax-table-head,
.tax-table-row {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.75rem;
  font-size: 0.9rem;
}

.tax-table-empty {
  border: 1px dashed #d4d4d8;
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  background: #fafafa;
  margin-top: 0.5rem;
}

.tax-table-head {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.75rem;
  color: #94a3b8;
}

.tax-table-row {
  padding: 0.9rem 1rem;
  border-radius: 1rem;
  background: #f9fafb;
  align-items: center;
}

.tax-upload-table .tax-table-head,
.tax-upload-table .tax-table-row {
  grid-template-columns: 1.5fr 1.25fr 0.9fr 1.2fr 0.5fr 0.95fr 0.7fr 0.45fr;
}

.tax-upload-row {
  background: #fff;
  border: 1px solid #e4e7ec;
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.04);
  border-left: 4px solid transparent;
}

.tax-upload-row.status-pending { border-left-color: #f97316; }
.tax-upload-row.status-review { border-left-color: #3b82f6; }
.tax-upload-row.status-scheduled { border-left-color: #8b5cf6; }
.tax-upload-row.status-sent { border-left-color: #16a34a; }
.tax-upload-row.status-rejected { border-left-color: #dc2626; }
.tax-upload-row.status-waiting { border-left-color: #f59e0b; }
.tax-upload-row.status-received { border-left-color: #0ea5e9; }
.tax-upload-row.status-planned { border-left-color: #94a3b8; }

.tax-upload-cell {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.tax-upload-cell strong {
  font-size: 0.95rem;
  color: #0f172a;
}

.tax-upload-cell span {
  color: #475467;
  font-size: 0.8rem;
}

.tax-upload-cell small {
  color: #94a3b8;
  font-size: 0.75rem;
}

.note-preview-cell {
  min-width: 0;
}

.note-json-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem 0.9rem;
}

.note-json-list li {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  font-size: 0.82rem;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  padding: 0.45rem 0.55rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.note-json-list li strong {
  font-weight: 700;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.note-json-list li span {
  color: #0f172a;
}

.note-text.is-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.note-preview-toggle {
  align-self: flex-start;
  font-size: 0.75rem;
  margin-top: 0.15rem;
}

.note-preview-cell small {
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 1200px) {
  .note-json-list {
    grid-template-columns: 1fr;
  }
}

.note-preview-cell.no-content {
  min-height: 0;
}

.tax-upload-cell.responsable-cell {
  justify-content: center;
}

.client-pill {
  border: none;
  background: #e2e8f0;
  border-radius: 999px;
  padding: 0.3rem 0.85rem;
  cursor: pointer;
  font: inherit;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.client-pill strong {
  font-size: 0.95rem;
}

.client-pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.client-pill.accent-a { background: #eef2ff; color: #3730a3; }
.client-pill.accent-b { background: #ecfccb; color: #365314; }
.client-pill.accent-c { background: #fee2e2; color: #881337; }
.client-pill.accent-d { background: #fef3c7; color: #92400e; }
.client-pill.accent-e { background: #cffafe; color: #115e59; }
.client-pill.accent-f { background: #ede9fe; color: #5b21b6; }

.service-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  background: rgba(79, 70, 229, 0.08);
  color: #4338ca;
  font-size: 0.75rem;
  margin-top: 0.35rem;
  font-weight: 600;
  width: fit-content;
}

.tax-upload-actions {
  display: flex;
  justify-content: flex-end;
}

.tax-notes-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tax-status-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.95rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  min-height: 64px;
}

.tax-status-indicator.ontrack {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.tax-status-indicator.dueSoon {
  border-color: #fde68a;
  background: #fffbeb;
}

.tax-status-indicator.late {
  border-color: #fecaca;
  background: #fef2f2;
}

.tax-status-indicator.default {
  border-color: #e2e8f0;
  background: #f8fafc;
}

.note-icon-button {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 999px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475467;
  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.note-icon-button svg {
  width: 16px;
  height: 16px;
}

.note-icon-button:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #4f46e5;
  transform: translateY(-1px);
}

.note-icon-button.active {
  background: rgba(79, 70, 229, 0.15);
  border-color: #4f46e5;
  color: #4338ca;
}

.icon-btn {
  border: none;
  background: transparent;
  padding: 0.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475467;
}

.icon-btn.note {
  border: 1px solid #e4e7ec;
  border-radius: 999px;
  width: 34px;
  height: 34px;
  padding: 0;
}

.icon-btn.note svg {
  width: 14px;
  height: 14px;
}

.icon-btn.note:hover {
  border-color: #4f46e5;
  color: #4338ca;
  background: rgba(79, 70, 229, 0.08);
}

.tax-status-chip {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-flex;
}

.tax-status-chip.ontrack {
  background: #15803d;
  box-shadow: 0 0 0 4px rgba(21, 128, 61, 0.2);
}

.tax-status-chip.dueSoon {
  background: #b45309;
  box-shadow: 0 0 0 4px rgba(180, 83, 9, 0.2);
}

.tax-status-chip.late {
  background: #b91c1c;
  box-shadow: 0 0 0 4px rgba(185, 28, 28, 0.2);
}

.tax-status-chip.default {
  background: #94a3b8;
  box-shadow: 0 0 0 4px rgba(148, 163, 184, 0.2);
}

.traffic-chip {
  border-radius: 0.9rem;
  border: 1px solid #e2e8f0;
  padding: 0.5rem 0.9rem;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  min-width: 120px;
  background: #f8fafc;
}

.traffic-chip strong {
  font-size: 0.95rem;
  color: #0f172a;
}

.traffic-chip small {
  color: #475467;
  font-size: 0.78rem;
}

.traffic-chip.ontrack {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.traffic-chip.dueSoon {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.traffic-chip.late {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.requirement-list {
  list-style: none;
  padding: 0;
  margin: 0 0 0.35rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.requirement-list li {
  background: #f1f5f9;
  border-radius: 0.65rem;
  padding: 0.15rem 0.6rem;
  font-size: 0.72rem;
  color: #475467;
}

.tax-legend {
  border-radius: 1.25rem;
  border: 1px solid #e4e7ec;
  background: #fff;
  padding: 1.25rem;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.05);
}

.tax-legend h3 {
  margin: 0;
}

.tax-legend ul {
  list-style: none;
  padding: 0;
  margin: 1rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.tax-legend li {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.status-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.pending {
  background: #f97316;
}

.status-dot.review {
  background: #3b82f6;
}

.status-dot.scheduled {
  background: #8b5cf6;
}

.status-dot.sent {
  background: #16a34a;
}

.status-dot.rejected {
  background: #dc2626;
}

.status-dot.ontrack {
  background: #16a34a;
}

.status-dot.pending {
  background: #f59e0b;
}

.status-dot.dueSoon {
  background: #f97316;
}

.status-dot.late {
  background: #dc2626;
}

.status-dot.done {
  background: #15803d;
}

.status-dot.na {
  background: #cbd5e1;
}

.tax-legend p {
  margin: 0.1rem 0 0;
  color: #475467;
  font-size: 0.85rem;
}

.chip {
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.chip.enviada {
  background: rgba(99, 102, 241, 0.15);
  color: #4338ca;
}

.chip.aprobada {
  background: rgba(34, 197, 94, 0.15);
  color: #15803d;
}

.chip.procesada {
  background: rgba(59, 130, 246, 0.15);
  color: #1d4ed8;
}

.chip.pendiente {
  background: rgba(249, 115, 22, 0.18);
  color: #c2410c;
}

.table-row.link-row {
  text-decoration: none;
  color: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.table-row.link-row:hover {
  background: #eef2ff;
  box-shadow: 0 12px 24px rgba(79, 70, 229, 0.15);
  transform: translateY(-2px);
  cursor: pointer;
}

.side-panel {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.logs .section-header p {
  margin: 0.35rem 0 0;
  color: #475467;
}

.logs-list {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.log-item {
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  padding: 1.25rem;
  background: #ffffff;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.log-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.35rem;
}

.badge {
  border-radius: 999px;
  padding: 0.25rem 0.8rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
}

.badge.ok {
  background: rgba(34, 197, 94, 0.18);
  color: #0f9d58;
}

.badge.error {
  background: rgba(239, 68, 68, 0.18);
  color: #b91c1c;
}

.badge.advertencia {
  background: rgba(250, 204, 21, 0.3);
  color: #b45309;
}

.badge.activo {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.log-duration {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475467;
}

.log-title {
  margin: 0;
  font-size: 1rem;
}

.log-title a {
  color: #0f172a;
  text-decoration: none;
}

.log-title a:hover {
  text-decoration: underline;
}

.log-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.log-footer small {
  margin: 0;
  font-size: 0.78rem;
  color: #64748b;
}

.log-trigger {
  border-radius: 999px;
  border: 1px solid rgba(79, 70, 229, 0.2);
  padding: 0.2rem 0.85rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #4338ca;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: rgba(99, 102, 241, 0.08);
}

.log-item p {
  margin: 0.35rem 0 0.15rem;
  color: #475467;
}

.log-item small {
  color: #98a2b3;
}

.log-message {
  margin: 0;
  color: #475467;
  font-size: 0.95rem;
}

.reminders ul {
  list-style: none;
  padding: 0;
  margin: 1rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.reminders li {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 0.9rem;
  background: #f8fafc;
}

.badge-set {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: #475467;
}

.link-btn {
  border: none;
  background: none;
  color: #4f46e5;
  font-weight: 600;
  cursor: pointer;
}

.btn:focus-visible,
.link-btn:focus-visible,
.summary-card:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

.session-dropdown {
  position: relative;
}

.session-trigger {
  border: 1px solid rgba(79, 70, 229, 0.28);
  background: rgba(79, 70, 229, 0.08);
  color: #312e81;
  border-radius: 999px;
  min-width: 44px;
  min-height: 44px;
  padding: 0.55rem 0.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.session-trigger:hover,
.session-trigger.open {
  transform: translateY(-1px);
  border-color: rgba(79, 70, 229, 0.45);
  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.18);
}

.session-trigger:focus-visible,
.session-menu-link:focus-visible,
.session-menu-action:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

.header-icon {
  width: 1.08rem;
  height: 1.08rem;
  flex-shrink: 0;
}

.session-chevron {
  width: 0.95rem;
  height: 0.95rem;
  transition: transform 0.2s ease;
}

.session-trigger.open .session-chevron {
  transform: rotate(180deg);
}

.session-menu {
  position: absolute;
  top: calc(100% + 0.55rem);
  right: 0;
  min-width: 260px;
  max-width: min(320px, calc(100vw - 2rem));
  padding: 0.55rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(79, 70, 229, 0.2);
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.2);
  z-index: 40;
}

.session-menu-email {
  margin: 0;
  padding: 0.5rem 0.65rem 0.65rem;
  border-bottom: 1px solid #eef2ff;
  color: #10283b;
  font-size: 0.86rem;
  font-weight: 600;
  word-break: break-word;
}

.session-menu-links {
  margin-top: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.session-menu-links:empty {
  display: none;
}

.session-menu-link,
.session-menu-action {
  width: 100%;
  border: none;
  border-radius: 0.7rem;
  background: transparent;
  color: #1f3444;
  text-align: left;
  font-size: 0.88rem;
  font-weight: 600;
  padding: 0.55rem 0.65rem;
  cursor: pointer;
}

.session-menu-link:hover,
.session-menu-action:hover {
  background: rgba(79, 70, 229, 0.12);
  color: #312e81;
}

.session-menu-action {
  margin-top: 0.35rem;
}

.header-icon-btn {
  min-width: 44px;
  width: 44px;
  min-height: 44px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.header-icon-btn .header-icon {
  width: 1.15rem;
  height: 1.15rem;
}

.header-icon-btn.is-loading .header-icon {
  animation: header-icon-spin 0.9s linear infinite;
}

@keyframes header-icon-spin {
  to {
    transform: rotate(360deg);
  }
}

.data-pill {
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.8rem;
}

.data-pill.live {
  background: rgba(34, 197, 94, 0.2);
  color: #0f9d58;
}

.data-pill.mock {
  background: rgba(59, 130, 246, 0.2);
  color: #1d4ed8;
}

@media (max-width: 1200px) {
  .tax-upload-table .tax-table-head,
  .tax-upload-table .tax-table-row {
    min-width: 900px;
  }
}

@media (max-width: 1100px) {
  .activity-table {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .activity-head {
    display: none;
  }

  .activity-row {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.25rem;
  }

  .activity-row .client-cell {
    width: 100%;
    background: #eef2ff;
    border-radius: 0.95rem;
    padding: 0.85rem 1rem;
    border: 1px solid #e0e7ff;
    box-shadow: inset 0 1px 0 rgba(79, 70, 229, 0.08);
  }

  .activity-row .client-cell strong {
    font-size: 1rem;
  }

  .activity-row .activity-cell {
    border: 1px solid #e2e8f0;
    border-radius: 0.9rem;
    padding: 0.85rem;
    background: #fff;
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
  }

  .activity-row .activity-cell.disabled-cell {
    opacity: 0.65;
  }

  .activity-row .activity-cell .btn.ghost {
    width: 100%;
  }

  .activity-row .activity-chip {
    min-height: auto;
  }

  .activity-row .activity-responsable {
    width: 100%;
    border-top: 1px dashed #e2e8f0;
    padding-top: 0.75rem;
  }
}


@media (max-width: 960px) {
  .app-header {
    flex-direction: column;
  }

  .header-actions {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .session-menu {
    right: auto;
    left: 0;
  }

  .content-grid {
    grid-template-columns: 1fr;
  }

  .filters {
    flex-direction: column;
    align-items: flex-start;
  }

  .table-head,
  .table-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .table-row {
    font-size: 0.85rem;
  }

  .create-card {
    padding: 1.5rem;
  }

  .login-card {
    padding: 2rem;
  }

  .tax-board-grid {
    grid-template-columns: 1fr;
  }

  .tax-controls {
    flex-direction: column;
  }

  .control-board-grid {
    grid-template-columns: 1fr;
  }

  .overview-panel-header {
    flex-direction: column;
  }

  .overview-table {
    min-width: 620px;
  }

  .overview-performance-list {
    grid-template-columns: 1fr;
  }

  .attendance-header {
    flex-direction: column;
  }

  .attendance-export-item {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }

  .attendance-export-status {
    justify-self: flex-start;
  }

  .attendance-export-item .btn {
    width: 100%;
  }

  .attendance-missing-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .attendance-missing-actions {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .app-shell {
    padding: 1.75rem 1rem 2.25rem;
    gap: 1.5rem;
  }

  .app-header h1 {
    font-size: 1.65rem;
  }

  .session-menu {
    min-width: 210px;
    max-width: calc(100vw - 2.5rem);
  }

  .filters {
    padding: 1rem;
  }

  .control-overview {
    padding: 1.15rem;
    border-radius: 1.2rem;
  }

  .overview-table-panel,
  .overview-performance-panel,
  .overview-board-panel {
    padding: 0.85rem;
  }

  .overview-metric-card strong {
    font-size: 1.4rem;
  }

  .overlay {
    padding: 1.5rem 0.75rem;
  }

  .create-card {
    width: 100%;
    padding: 1.25rem;
    border-radius: 1.25rem;
  }

  .form-grid.two {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .activity-table {
    padding: 0.25rem;
  }

  .activity-row {
    padding: 1rem;
  }

  .activity-row .activity-cell {
    padding: 0.65rem 0.75rem;
  }

  .activity-chip {
    padding: 0.5rem 0.6rem;
  }

  .activity-chip strong {
    font-size: 0.85rem;
  }

  .activity-chip small {
    font-size: 0.72rem;
  }

  .activity-row .client-cell {
    padding: 0.75rem 0.85rem;
  }
}

@media (max-width: 900px) {
  .tax-upload-table {
    overflow-x: visible;
  }

  .tax-upload-table .tax-table-head {
    display: none;
  }

  .tax-upload-table .tax-table-row {
    min-width: 0;
    grid-template-columns: 1fr;
    padding: 1.25rem;
    gap: 0.85rem;
  }

  .tax-upload-row {
    gap: 0.85rem;
  }

  .tax-upload-row > * {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
  }

  .tax-upload-row > *:not(.traffic-chip):not(.tax-upload-actions):not(.tax-notes-toggle):not(.note-preview-cell.no-content) {
    background: #f8fafc;
    border-radius: 0.85rem;
    padding: 0.75rem 0.85rem;
  }

  .tax-upload-row > *::before {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #94a3b8;
    margin-bottom: 0.15rem;
  }

  .tax-upload-row > :nth-child(1)::before { content: 'Cliente'; }
  .tax-upload-row > :nth-child(2)::before { content: 'Obligación'; }
  .tax-upload-row > :nth-child(3)::before { content: 'Responsable'; }
  .tax-upload-row > :nth-child(4)::before { content: 'Requisitos y notas'; }
  .tax-upload-row > :nth-child(5)::before { content: 'Estado'; }
  .tax-upload-row > :nth-child(6)::before { content: 'Vence'; }
  .tax-upload-row > :nth-child(7)::before { content: 'Acción'; }
  .tax-upload-row > :nth-child(8)::before { content: 'Notas'; }

  .tax-upload-row > :nth-child(5) {
    align-items: flex-start;
  }

  .tax-upload-row > :nth-child(6),
  .traffic-chip {
    width: 100%;
  }

  .tax-upload-row > :nth-child(7) {
    padding: 0;
  }

  .tax-upload-row > :nth-child(8) {
    padding: 0;
  }

  .tax-upload-row > .note-preview-cell.no-content::before {
    display: none;
  }

  .tax-upload-row > .tax-upload-actions {
    align-items: flex-start;
  }

  .tax-upload-row > .tax-notes-toggle {
    align-items: flex-start;
  }

  .tax-upload-actions .btn {
    width: 100%;
  }

  .tax-info-toggle {
    width: 100%;
  }

.info-toggle {
    width: 100%;
    text-align: center;
  }
}

/* Corporate Elegant Theme Layer */
:root {
  --ci-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;
  --ci-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;
  --ci-canvas: #edf2f5;
  --ci-canvas-deep: #e4ebf0;
  --ci-surface: #ffffff;
  --ci-surface-soft: #f8fbfd;
  --ci-border: #cfdae3;
  --ci-border-strong: #bccdda;
  --ci-text: #172a3a;
  --ci-muted: #5d6f80;
  --ci-accent: #1f4f68;
  --ci-accent-strong: #153648;
  --ci-accent-soft: #d8e7f1;
  --ci-gold: #b4955e;
  --ci-success: #1f7a4f;
  --ci-warning: #ab7a14;
  --ci-danger: #b24b3e;
}

:root {
  font-family: var(--ci-font-body);
  color: var(--ci-text);
  background-color: var(--ci-canvas);
}

::selection {
  background: rgba(31, 79, 104, 0.2);
  color: #0f2b3d;
}

body {
  color: var(--ci-text);
  background:
    radial-gradient(circle at 8% 7%, rgba(31, 79, 104, 0.11), transparent 45%),
    radial-gradient(circle at 85% 14%, rgba(180, 149, 94, 0.16), transparent 40%),
    linear-gradient(180deg, #f2f6f8 0%, #eaf0f4 100%);
  background-color: var(--ci-canvas);
}

.auth-shell {
  background:
    radial-gradient(circle at 84% 16%, rgba(21, 54, 72, 0.24), transparent 42%),
    linear-gradient(165deg, rgba(244, 248, 251, 0.98), rgba(229, 237, 242, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top -140px right -160px / 760px auto;
}

.login-card {
  border: 1px solid var(--ci-border);
  background:
    linear-gradient(165deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 253, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/340px 340px;
}

.app-shell {
  position: relative;
  isolation: isolate;
}

.app-shell::before {
  content: '';
  position: absolute;
  inset: 0;
  min-height: 100%;
  pointer-events: none;
  z-index: -2;
  background:
    radial-gradient(circle at 88% 14%, rgba(21, 54, 72, 0.14), transparent 42%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top -130px right clamp(-360px, -14vw, -120px) /
      clamp(1020px, 118vw, 1720px) auto;
  opacity: 0.95;
}

.app-shell::after {
  content: '';
  position: absolute;
  inset: 0;
  min-height: 100%;
  pointer-events: none;
  z-index: -1;
  background:
    radial-gradient(circle at 6% 85%, rgba(180, 149, 94, 0.13), transparent 42%),
    radial-gradient(circle at 92% 70%, rgba(31, 79, 104, 0.09), transparent 35%),
    radial-gradient(circle at 56% 118%, rgba(21, 54, 72, 0.08), transparent 46%);
}

.app-header {
  position: relative;
  border: 1px solid var(--ci-border);
  border-radius: 1.3rem;
  padding: 1.2rem 1.35rem;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/420px 420px;
  box-shadow: 0 18px 34px rgba(22, 43, 57, 0.12);
}

.app-header h1,
.control-header h2,
.section-header h3,
.tax-header h2,
.overview-panel-header h3,
.form-header h3,
.approved-view h3 {
  font-family: var(--ci-font-display);
  letter-spacing: 0.01em;
  color: #10283b;
}

.eyebrow {
  color: var(--ci-accent);
}

.subtitle,
.control-header p,
.section-header p,
.overview-panel-header p,
.helper-text {
  color: var(--ci-muted);
}

.header-actions {
  align-items: center;
}

.btn {
  position: relative;
  overflow: hidden;
  letter-spacing: 0.01em;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.btn.primary {
  background: linear-gradient(130deg, var(--ci-accent-strong), var(--ci-accent));
  color: #f5f9fc;
  border: 1px solid rgba(18, 51, 71, 0.45);
  box-shadow: 0 12px 22px rgba(21, 54, 72, 0.3);
}

.btn.primary::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center/cover no-repeat;
  opacity: 0.7;
}

.btn.ghost {
  background: rgba(255, 255, 255, 0.78);
  color: var(--ci-accent-strong);
  border-color: rgba(21, 54, 72, 0.28);
}

.btn.secondary {
  background: linear-gradient(145deg, #f2f8fc, #e5eff5);
  color: var(--ci-accent-strong);
  border-color: rgba(21, 54, 72, 0.2);
  box-shadow: 0 9px 16px rgba(18, 51, 71, 0.13);
}

.view-tabs {
  padding: 0.28rem;
  border: 1px solid rgba(21, 54, 72, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.68);
  backdrop-filter: blur(4px);
  width: fit-content;
}

.pill {
  border-color: rgba(21, 54, 72, 0.16);
  color: #274358;
  background: rgba(248, 252, 255, 0.72);
}

.pill.active {
  border-color: rgba(16, 42, 59, 0.45);
  background: linear-gradient(130deg, #173a50, #245c78);
  box-shadow: 0 8px 18px rgba(21, 54, 72, 0.27);
}

.filters,
.summary-card,
.board,
.side-panel section,
.approved-view,
.tax-view,
.control-overview,
.tax-summary-card,
.airtable-modal,
.automation-upload-card,
.activity-modal,
.whatsapp-modal,
.tax-upload-dialog {
  border: 1px solid var(--ci-border);
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/380px 380px;
  box-shadow: 0 16px 34px rgba(20, 40, 56, 0.11);
}

/* Resource coverage across all module views */
.attendance-view,
.attendance-export-panel,
.attendance-group,
.attendance-missing-modal,
.notes-modal,
.tax-main-panel,
.tax-side-panel,
.tax-checklist,
.tax-legend,
.tax-table-card,
.tax-upload-table-card,
.tax-note-summary,
.create-card,
.form-section {
  border: 1px solid rgba(188, 205, 218, 0.62);
  background:
    linear-gradient(155deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/360px 360px;
  box-shadow: 0 14px 28px rgba(20, 40, 56, 0.1);
}

.approved-card,
.attendance-summary-card,
.attendance-missing-row,
.activity-row,
.tax-upload-file-list li,
.whatsapp-bubble,
.whatsapp-preview,
.info-box,
.tax-locked-card,
.note-summary-raw,
.tax-note-summary-grid li {
  border-color: rgba(188, 205, 218, 0.62);
  background:
    linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 253, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/320px 320px;
}

.tax-upload-row {
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(246, 250, 252, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/320px 320px;
  box-shadow: 0 12px 25px rgba(18, 51, 71, 0.12);
}

.summary-card.active {
  border-color: rgba(21, 54, 72, 0.44);
  box-shadow: 0 16px 28px rgba(21, 54, 72, 0.26);
}

.summary-card .label {
  color: #70859a;
}

.summary-card span {
  color: var(--ci-muted);
}

.table-filters,
.attendance-filters,
.tax-status-filters {
  border-color: var(--ci-border);
  background: linear-gradient(145deg, #f8fbfd, #eef4f8);
}

.table-head,
.attendance-table-head,
.tax-table-head,
.overview-table th {
  color: #70859a;
}

.table-row,
.attendance-table-row,
.tax-table-row {
  border: 1px solid rgba(188, 205, 218, 0.58);
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 253, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/320px 320px;
}

.table-row.link-row:hover,
.attendance-table-row:hover,
.tax-table-row:hover,
.overview-table tbody tr:hover {
  background:
    linear-gradient(145deg, rgba(227, 239, 247, 0.98), rgba(238, 245, 250, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/320px 320px;
  box-shadow: 0 12px 22px rgba(18, 51, 71, 0.16);
}

.loader-dot {
  background: var(--ci-accent);
}

.session-trigger {
  background: rgba(217, 231, 241, 0.8);
  border: 1px solid rgba(21, 54, 72, 0.2);
  color: #153648;
}

.session-menu {
  border: 1px solid rgba(21, 54, 72, 0.2);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(245, 250, 253, 0.96));
}

.data-pill {
  border: 1px solid rgba(21, 54, 72, 0.2);
}

.data-pill.live {
  background: rgba(18, 128, 86, 0.12);
  color: #0f6f4a;
}

.data-pill.mock {
  background: rgba(180, 149, 94, 0.16);
  color: #7a5f2d;
}

.badge.ok {
  background: rgba(31, 122, 79, 0.16);
  color: #1f7a4f;
}

.badge.error {
  background: rgba(178, 75, 62, 0.16);
  color: #9f3f32;
}

.badge.advertencia {
  background: rgba(171, 122, 20, 0.2);
  color: #8d6510;
}

.badge.activo {
  background: rgba(31, 79, 104, 0.16);
  color: #184862;
}

.control-overview::before {
  background: radial-gradient(circle, rgba(31, 79, 104, 0.2), rgba(31, 79, 104, 0.02));
}

.overview-table-panel,
.overview-performance-panel,
.overview-board-panel {
  border-color: var(--ci-border);
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.96), rgba(246, 250, 252, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/360px 360px;
}

.overview-module-cell small,
.overview-performance-item p {
  color: var(--ci-muted);
}

.status-dot.success {
  background: var(--ci-success);
  box-shadow: 0 0 0 5px rgba(31, 122, 79, 0.18);
}

.status-dot.warning {
  background: var(--ci-warning);
  box-shadow: 0 0 0 5px rgba(171, 122, 20, 0.2);
}

.status-dot.danger {
  background: var(--ci-danger);
  box-shadow: 0 0 0 5px rgba(178, 75, 62, 0.2);
}

.overview-progress-fill.tone-success {
  background: linear-gradient(90deg, #176b46, #2c8f61);
}

.overview-progress-fill.tone-warning {
  background: linear-gradient(90deg, #9c6f10, #c5942f);
}

.overview-progress-fill.tone-danger {
  background: linear-gradient(90deg, #9d3e32, #c05b4f);
}

.overview-progress-fill.tone-neutral {
  background: linear-gradient(90deg, #2f4f64, #4f7188);
}

input,
select,
textarea {
  border-color: var(--ci-border);
}

input:focus-visible,
select:focus-visible,
textarea:focus-visible,
.btn:focus-visible,
.pill:focus-visible,
.link-btn:focus-visible {
  outline: 2px solid rgba(31, 79, 104, 0.45);
  outline-offset: 2px;
}

@keyframes corporate-rise {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.app-header,
.view-tabs,
.filters,
.summary-grid,
.board,
.side-panel section,
.approved-view,
.tax-view,
.control-overview {
  animation: corporate-rise 420ms cubic-bezier(0.2, 0.78, 0.2, 1) both;
}

.view-tabs {
  animation-delay: 60ms;
}

.filters {
  animation-delay: 110ms;
}

.summary-grid {
  animation-delay: 160ms;
}

@media (max-width: 960px) {
  .view-tabs {
    width: 100%;
    overflow-x: auto;
  }
}

@media (max-width: 640px) {
  .app-header {
    padding: 1rem 1rem 1.1rem;
  }
}

/* Dark Mode Overhaul (toggleable) */
:root[data-theme='dark'] {
  --ci-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;
  --ci-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;
  --ci-canvas: #08121a;
  --ci-canvas-deep: #0d1a24;
  --ci-surface: #101c27;
  --ci-surface-soft: #162535;
  --ci-border: #284256;
  --ci-border-strong: #35566d;
  --ci-text: #e5f0f8;
  --ci-muted: #9db6c9;
  --ci-accent: #5da7d8;
  --ci-accent-strong: #2c6f95;
  --ci-accent-soft: rgba(102, 169, 211, 0.2);
  --ci-gold: #cba86b;
  --ci-success: #4ac78c;
  --ci-warning: #e2b25f;
  --ci-danger: #e48679;
}

:root[data-theme='dark'] ::selection {
  background: rgba(102, 169, 211, 0.35);
  color: #f5fbff;
}

:root[data-theme='dark'] body {
  color: var(--ci-text);
  background:
    radial-gradient(circle at 84% 12%, rgba(93, 167, 216, 0.2), transparent 46%),
    radial-gradient(circle at 12% 82%, rgba(203, 168, 107, 0.16), transparent 44%),
    linear-gradient(180deg, #061018 0%, #0b1720 45%, #0c1a24 100%);
  background-color: var(--ci-canvas);
}

:root[data-theme='dark'] .auth-shell {
  background:
    radial-gradient(circle at 85% 16%, rgba(93, 167, 216, 0.17), transparent 40%),
    linear-gradient(165deg, rgba(7, 20, 30, 0.98), rgba(9, 24, 36, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat top -170px right -170px / 780px auto;
}

:root[data-theme='dark'] .login-card {
  color: var(--ci-text);
  border: 1px solid var(--ci-border);
  background:
    linear-gradient(165deg, rgba(15, 28, 40, 0.97), rgba(12, 24, 35, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/360px 360px;
  box-shadow: 0 28px 56px rgba(2, 8, 14, 0.55);
}

:root[data-theme='dark'] .login-card input {
  color: var(--ci-text);
  background: rgba(8, 18, 27, 0.9);
  border-color: var(--ci-border);
}

:root[data-theme='dark'] .auth-footnote strong,
:root[data-theme='dark'] .form-header h3,
:root[data-theme='dark'] .control-header h2,
:root[data-theme='dark'] .section-header h3,
:root[data-theme='dark'] .tax-header h2,
:root[data-theme='dark'] .overview-panel-header h3,
:root[data-theme='dark'] .approved-view h3,
:root[data-theme='dark'] .app-header h1 {
  color: #f0f7fc;
  font-family: var(--ci-font-display);
}

:root[data-theme='dark'] .auth-footnote,
:root[data-theme='dark'] .subtitle,
:root[data-theme='dark'] .control-header p,
:root[data-theme='dark'] .section-header p,
:root[data-theme='dark'] .overview-panel-header p,
:root[data-theme='dark'] .helper-text {
  color: var(--ci-muted);
}

:root[data-theme='dark'] .app-shell {
  position: relative;
  isolation: isolate;
}

:root[data-theme='dark'] .app-shell::before {
  content: '';
  position: absolute;
  inset: 0;
  min-height: 100%;
  pointer-events: none;
  z-index: -2;
  background:
    radial-gradient(circle at 84% 14%, rgba(93, 167, 216, 0.2), transparent 46%),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat top -170px right clamp(-390px, -15vw, -140px) /
      clamp(1080px, 126vw, 1780px) auto;
  opacity: 0.92;
}

:root[data-theme='dark'] .app-shell::after {
  content: '';
  position: absolute;
  inset: 0;
  min-height: 100%;
  pointer-events: none;
  z-index: -1;
  background:
    radial-gradient(circle at 10% 90%, rgba(203, 168, 107, 0.11), transparent 45%),
    radial-gradient(circle at 96% 72%, rgba(93, 167, 216, 0.14), transparent 38%),
    radial-gradient(circle at 52% 118%, rgba(23, 54, 72, 0.2), transparent 48%);
}

:root[data-theme='dark'] .app-header {
  border: 1px solid var(--ci-border);
  border-radius: 1.25rem;
  padding: 1.15rem 1.3rem;
  background:
    linear-gradient(135deg, rgba(16, 29, 41, 0.96), rgba(13, 25, 36, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/420px 420px;
  box-shadow: 0 18px 36px rgba(2, 8, 14, 0.52);
}

:root[data-theme='dark'] .eyebrow {
  color: #8fc4e6;
}

:root[data-theme='dark'] .btn {
  color: var(--ci-text);
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;
}

:root[data-theme='dark'] .theme-toggle-corner {
  border-color: rgba(126, 179, 212, 0.36);
  background: rgba(9, 24, 35, 0.75);
  color: #a8d0ea;
  opacity: 0.24;
}

:root[data-theme='dark'] .theme-toggle-corner:hover,
:root[data-theme='dark'] .theme-toggle-corner:focus-visible {
  opacity: 0.88;
  border-color: rgba(156, 202, 231, 0.62);
  box-shadow: 0 10px 20px rgba(4, 12, 19, 0.52);
}

:root[data-theme='dark'] .btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

:root[data-theme='dark'] .btn.primary {
  background: linear-gradient(130deg, #1f4f6c, #347ba5);
  border: 1px solid rgba(122, 188, 231, 0.35);
  color: #f2f9ff;
  box-shadow: 0 14px 24px rgba(6, 21, 32, 0.5);
}

:root[data-theme='dark'] .btn.primary::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) center/cover no-repeat;
  opacity: 0.82;
}

:root[data-theme='dark'] .btn.ghost {
  background: rgba(14, 31, 43, 0.85);
  color: #b4d6eb;
  border: 1px solid rgba(102, 169, 211, 0.34);
}

:root[data-theme='dark'] .btn.secondary {
  background: linear-gradient(145deg, rgba(25, 45, 60, 0.95), rgba(17, 33, 45, 0.93));
  color: #d6eaf8;
  border-color: rgba(102, 169, 211, 0.28);
  box-shadow: 0 10px 18px rgba(4, 13, 20, 0.46);
}

:root[data-theme='dark'] .view-tabs {
  padding: 0.32rem;
  border: 1px solid rgba(102, 169, 211, 0.24);
  border-radius: 999px;
  background: rgba(10, 22, 32, 0.82);
  backdrop-filter: blur(6px);
  width: fit-content;
}

:root[data-theme='dark'] .pill {
  border-color: rgba(102, 169, 211, 0.2);
  background: rgba(17, 33, 47, 0.92);
  color: #b8d4e6;
}

:root[data-theme='dark'] .pill.active {
  border-color: rgba(176, 214, 238, 0.36);
  background: linear-gradient(130deg, #225673, #317ca7);
  color: #f4fbff;
  box-shadow: 0 10px 18px rgba(6, 20, 30, 0.48);
}

:root[data-theme='dark'] .filters,
:root[data-theme='dark'] .summary-card,
:root[data-theme='dark'] .board,
:root[data-theme='dark'] .side-panel section,
:root[data-theme='dark'] .approved-view,
:root[data-theme='dark'] .tax-view,
:root[data-theme='dark'] .control-overview,
:root[data-theme='dark'] .tax-summary-card,
:root[data-theme='dark'] .airtable-modal,
:root[data-theme='dark'] .automation-upload-card,
:root[data-theme='dark'] .activity-modal,
:root[data-theme='dark'] .whatsapp-modal,
:root[data-theme='dark'] .tax-upload-dialog {
  color: var(--ci-text);
  border: 1px solid var(--ci-border);
  background:
    linear-gradient(160deg, rgba(16, 28, 40, 0.97), rgba(12, 24, 35, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/390px 390px;
  box-shadow: 0 18px 34px rgba(2, 8, 14, 0.5);
}

/* Resource coverage across all module views (dark) */
:root[data-theme='dark'] .attendance-view,
:root[data-theme='dark'] .attendance-export-panel,
:root[data-theme='dark'] .attendance-group,
:root[data-theme='dark'] .attendance-missing-modal,
:root[data-theme='dark'] .notes-modal,
:root[data-theme='dark'] .tax-main-panel,
:root[data-theme='dark'] .tax-side-panel,
:root[data-theme='dark'] .tax-checklist,
:root[data-theme='dark'] .tax-legend,
:root[data-theme='dark'] .tax-table-card,
:root[data-theme='dark'] .tax-upload-table-card,
:root[data-theme='dark'] .tax-note-summary,
:root[data-theme='dark'] .create-card,
:root[data-theme='dark'] .form-section {
  border: 1px solid rgba(53, 86, 109, 0.76);
  background:
    linear-gradient(160deg, rgba(18, 32, 45, 0.97), rgba(12, 24, 35, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/360px 360px;
  box-shadow: 0 16px 30px rgba(2, 8, 14, 0.52);
}

:root[data-theme='dark'] .approved-card,
:root[data-theme='dark'] .attendance-summary-card,
:root[data-theme='dark'] .attendance-missing-row,
:root[data-theme='dark'] .activity-row,
:root[data-theme='dark'] .tax-legacy-upload-card,
:root[data-theme='dark'] .tax-upload-file-list li,
:root[data-theme='dark'] .whatsapp-bubble,
:root[data-theme='dark'] .whatsapp-preview,
:root[data-theme='dark'] .info-box,
:root[data-theme='dark'] .tax-locked-card,
:root[data-theme='dark'] .note-summary-raw,
:root[data-theme='dark'] .tax-note-summary-grid li {
  border-color: rgba(53, 86, 109, 0.76);
  background:
    linear-gradient(150deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .tax-upload-row {
  background:
    linear-gradient(145deg, rgba(19, 35, 49, 0.98), rgba(13, 28, 40, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);
}

:root[data-theme='dark'] .summary-card .label,
:root[data-theme='dark'] .table-head,
:root[data-theme='dark'] .attendance-table-head,
:root[data-theme='dark'] .tax-table-head,
:root[data-theme='dark'] .tax-legacy-upload-header small,
:root[data-theme='dark'] .overview-table th {
  color: #8ea8ba;
}

:root[data-theme='dark'] .summary-card span,
:root[data-theme='dark'] .table-row,
:root[data-theme='dark'] .tax-table-row,
:root[data-theme='dark'] .attendance-table-row,
:root[data-theme='dark'] .overview-table td,
:root[data-theme='dark'] .approved-card p,
:root[data-theme='dark'] .log-message,
:root[data-theme='dark'] .log-footer small,
:root[data-theme='dark'] .form-header p {
  color: #c7d9e6;
}

:root[data-theme='dark'] .summary-card.active {
  border-color: rgba(117, 182, 223, 0.5);
  box-shadow: 0 16px 28px rgba(7, 24, 37, 0.52);
}

:root[data-theme='dark'] .table-filters,
:root[data-theme='dark'] .attendance-filters,
:root[data-theme='dark'] .tax-status-filters,
:root[data-theme='dark'] .form-section,
:root[data-theme='dark'] .create-stepper .step,
:root[data-theme='dark'] .tax-upload-step {
  border-color: var(--ci-border);
  background: linear-gradient(145deg, rgba(14, 29, 41, 0.95), rgba(11, 24, 35, 0.94));
}

:root[data-theme='dark'] .create-stepper .step.active,
:root[data-theme='dark'] .tax-upload-step.active {
  background: linear-gradient(130deg, #225773, #317ca7);
  border-color: rgba(141, 203, 241, 0.4);
  color: #f4fbff;
}

:root[data-theme='dark'] .table-row,
:root[data-theme='dark'] .tax-table-row,
:root[data-theme='dark'] .attendance-table-row,
:root[data-theme='dark'] .approved-card,
:root[data-theme='dark'] .log-item,
:root[data-theme='dark'] .tax-note-summary-grid li,
:root[data-theme='dark'] .note-summary-raw,
:root[data-theme='dark'] .activity-detail,
:root[data-theme='dark'] .attendance-summary-card,
:root[data-theme='dark'] .activity-row .activity-cell,
:root[data-theme='dark'] .client-pill,
:root[data-theme='dark'] .tax-table-card,
:root[data-theme='dark'] .tax-upload-table-card {
  border: 1px solid rgba(53, 86, 109, 0.7);
  background:
    linear-gradient(145deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .table-row.link-row:hover,
:root[data-theme='dark'] .tax-table-row:hover,
:root[data-theme='dark'] .attendance-table-row:hover,
:root[data-theme='dark'] .overview-table tbody tr:hover,
:root[data-theme='dark'] .control-board-card:hover,
:root[data-theme='dark'] .log-item:hover {
  background:
    linear-gradient(145deg, rgba(28, 50, 68, 0.98), rgba(20, 39, 54, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
  box-shadow: 0 14px 24px rgba(4, 13, 20, 0.5);
}

:root[data-theme='dark'] .table-loading {
  background: rgba(8, 17, 25, 0.86);
}

:root[data-theme='dark'] .session-trigger {
  background: rgba(16, 35, 49, 0.9);
  border: 1px solid rgba(93, 167, 216, 0.28);
  color: #d6e8f4;
}

:root[data-theme='dark'] .session-trigger:hover,
:root[data-theme='dark'] .session-trigger.open {
  border-color: rgba(131, 196, 236, 0.54);
  box-shadow: 0 10px 20px rgba(2, 11, 17, 0.5);
}

:root[data-theme='dark'] .session-menu {
  border: 1px solid rgba(70, 125, 160, 0.55);
  background: linear-gradient(145deg, rgba(14, 28, 40, 0.98), rgba(10, 22, 33, 0.96));
  box-shadow: 0 16px 34px rgba(1, 8, 13, 0.64);
}

:root[data-theme='dark'] .session-menu-email {
  border-bottom-color: rgba(79, 132, 166, 0.38);
  color: #d6e8f4;
}

:root[data-theme='dark'] .session-menu-link,
:root[data-theme='dark'] .session-menu-action {
  color: #d6e8f4;
}

:root[data-theme='dark'] .session-menu-link:hover,
:root[data-theme='dark'] .session-menu-action:hover {
  background: rgba(93, 167, 216, 0.22);
  color: #f0f8ff;
}

:root[data-theme='dark'] .data-pill {
  border: 1px solid rgba(93, 167, 216, 0.3);
}

:root[data-theme='dark'] .data-pill.live {
  background: rgba(74, 199, 140, 0.16);
  color: #8ce4b7;
}

:root[data-theme='dark'] .data-pill.mock {
  background: rgba(203, 168, 107, 0.18);
  color: #e6c58e;
}

:root[data-theme='dark'] .badge.ok {
  background: rgba(74, 199, 140, 0.2);
  color: #95e7bf;
}

:root[data-theme='dark'] .badge.error {
  background: rgba(228, 134, 121, 0.2);
  color: #f0aba2;
}

:root[data-theme='dark'] .badge.advertencia {
  background: rgba(226, 178, 95, 0.24);
  color: #f4cb85;
}

:root[data-theme='dark'] .badge.activo {
  background: rgba(93, 167, 216, 0.24);
  color: #a9d4ef;
}

:root[data-theme='dark'] .control-overview::before {
  background: radial-gradient(circle, rgba(93, 167, 216, 0.22), rgba(93, 167, 216, 0.03));
}

:root[data-theme='dark'] .overview-table-panel,
:root[data-theme='dark'] .overview-performance-panel,
:root[data-theme='dark'] .overview-board-panel {
  border-color: var(--ci-border);
  background:
    linear-gradient(160deg, rgba(17, 31, 44, 0.96), rgba(12, 24, 35, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/360px 360px;
}

:root[data-theme='dark'] .overview-module-cell small,
:root[data-theme='dark'] .overview-performance-item p,
:root[data-theme='dark'] .control-board-body p,
:root[data-theme='dark'] .attendance-summary-card p {
  color: var(--ci-muted);
}

:root[data-theme='dark'] .status-dot.success {
  background: var(--ci-success);
  box-shadow: 0 0 0 5px rgba(74, 199, 140, 0.2);
}

:root[data-theme='dark'] .status-dot.warning {
  background: var(--ci-warning);
  box-shadow: 0 0 0 5px rgba(226, 178, 95, 0.24);
}

:root[data-theme='dark'] .status-dot.danger {
  background: var(--ci-danger);
  box-shadow: 0 0 0 5px rgba(228, 134, 121, 0.24);
}

:root[data-theme='dark'] .status-dot.neutral {
  background: #7ea5bf;
  box-shadow: 0 0 0 5px rgba(126, 165, 191, 0.22);
}

:root[data-theme='dark'] .overview-progress-track {
  background: #1a3448;
}

:root[data-theme='dark'] .overview-progress-fill.tone-success {
  background: linear-gradient(90deg, #2f9f6c, #52c992);
}

:root[data-theme='dark'] .overview-progress-fill.tone-warning {
  background: linear-gradient(90deg, #a57729, #e2b25f);
}

:root[data-theme='dark'] .overview-progress-fill.tone-danger {
  background: linear-gradient(90deg, #b76054, #e48679);
}

:root[data-theme='dark'] .overview-progress-fill.tone-neutral {
  background: linear-gradient(90deg, #487490, #6ca0c2);
}

:root[data-theme='dark'] .link-btn {
  color: #8ec5e7;
}

:root[data-theme='dark'] input,
:root[data-theme='dark'] select,
:root[data-theme='dark'] textarea,
:root[data-theme='dark'] .filter-control select,
:root[data-theme='dark'] .filter-control input,
:root[data-theme='dark'] .search-combobox input,
:root[data-theme='dark'] .login-card input,
:root[data-theme='dark'] .tax-dropzone,
:root[data-theme='dark'] .tax-upload-file-list,
:root[data-theme='dark'] .tax-upload-file-list li {
  color: #e2eef6;
  border-color: var(--ci-border);
  background-color: rgba(9, 20, 30, 0.92);
}

:root[data-theme='dark'] select option {
  color: #e2eef6;
  background: #102131;
}

:root[data-theme='dark'] input::placeholder,
:root[data-theme='dark'] textarea::placeholder {
  color: #7f9ab0;
}

:root[data-theme='dark'] .info-box,
:root[data-theme='dark'] .tax-locked-card,
:root[data-theme='dark'] .whatsapp-preview,
:root[data-theme='dark'] .whatsapp-bubble,
:root[data-theme='dark'] .note-summary-raw,
:root[data-theme='dark'] .helper-text.folder-url {
  border-color: rgba(203, 168, 107, 0.4);
  background: linear-gradient(145deg, rgba(46, 38, 23, 0.9), rgba(37, 30, 18, 0.88));
  color: #f3d8ab;
}

:root[data-theme='dark'] .info-box.notice {
  border-color: rgba(74, 199, 140, 0.36);
  background: linear-gradient(145deg, rgba(19, 52, 40, 0.9), rgba(14, 43, 33, 0.88));
  color: #9de6c2;
}

:root[data-theme='dark'] .combobox-options {
  background: #122332;
  border-color: var(--ci-border);
}

:root[data-theme='dark'] .combobox-options li {
  color: #d7e7f2;
}

:root[data-theme='dark'] .combobox-options li:hover {
  background: rgba(93, 167, 216, 0.2);
  color: #eff8ff;
}

:root[data-theme='dark'] .loader-dot {
  background: #6eb4df;
}

:root[data-theme='dark'] .btn:focus-visible,
:root[data-theme='dark'] .link-btn:focus-visible,
:root[data-theme='dark'] .summary-card:focus-visible,
:root[data-theme='dark'] .pill:focus-visible,
:root[data-theme='dark'] input:focus-visible,
:root[data-theme='dark'] select:focus-visible,
:root[data-theme='dark'] textarea:focus-visible {
  outline: 2px solid rgba(118, 189, 233, 0.65);
  outline-offset: 2px;
}

/* Dark mode contrast hardening across all views */
:root[data-theme='dark'] .control-board-body h3,
:root[data-theme='dark'] .control-board-body li strong,
:root[data-theme='dark'] .overview-module-cell strong,
:root[data-theme='dark'] .overview-performance-head strong,
:root[data-theme='dark'] .overview-performance-head span,
:root[data-theme='dark'] .approved-card h4,
:root[data-theme='dark'] .attendance-group-info strong,
:root[data-theme='dark'] .attendance-table-row strong,
:root[data-theme='dark'] .attendance-modal-badge,
:root[data-theme='dark'] .tax-upload-cell strong,
:root[data-theme='dark'] .activity-chip strong,
:root[data-theme='dark'] .activity-responsable strong,
:root[data-theme='dark'] .tax-checklist h3,
:root[data-theme='dark'] .tax-legend h3,
:root[data-theme='dark'] .traffic-chip strong,
:root[data-theme='dark'] .note-json-list li span,
:root[data-theme='dark'] .tax-upload-step-panel-header h4,
:root[data-theme='dark'] .tax-year-select label,
:root[data-theme='dark'] .tax-search label {
  color: #ecf6fd;
}

:root[data-theme='dark'] .control-board-body p,
:root[data-theme='dark'] .control-board-body li,
:root[data-theme='dark'] .approved-card p,
:root[data-theme='dark'] .attendance-table-row small,
:root[data-theme='dark'] .attendance-group-info small,
:root[data-theme='dark'] .attendance-group-meta,
:root[data-theme='dark'] .tax-upload-cell span,
:root[data-theme='dark'] .tax-upload-cell small,
:root[data-theme='dark'] .activity-chip small,
:root[data-theme='dark'] .activity-responsable small,
:root[data-theme='dark'] .tax-checklist ul,
:root[data-theme='dark'] .note-json-list li,
:root[data-theme='dark'] .note-json-list li strong,
:root[data-theme='dark'] .tax-upload-row > *::before,
:root[data-theme='dark'] .tax-table-empty,
:root[data-theme='dark'] .tax-table-card .section-header p,
:root[data-theme='dark'] .attendance-header p,
:root[data-theme='dark'] .attendance-export-info span {
  color: #b6ccdc;
}

:root[data-theme='dark'] .log-title a {
  color: #eaf5fd;
}

:root[data-theme='dark'] .month-pill {
  border-color: rgba(98, 150, 182, 0.42);
  background: rgba(15, 30, 42, 0.88);
  color: #cde3f2;
}

:root[data-theme='dark'] .month-pill.active {
  border-color: rgba(149, 207, 244, 0.46);
  background: linear-gradient(130deg, #255d7c, #3b86b0);
  color: #f5fbff;
}

:root[data-theme='dark'] .tax-year-select select,
:root[data-theme='dark'] .tax-search input,
:root[data-theme='dark'] .attendance-group-toggle {
  background: rgba(10, 22, 32, 0.92);
  border-color: rgba(74, 119, 148, 0.64);
  color: #d8eaf5;
}

:root[data-theme='dark'] .tax-status-indicator,
:root[data-theme='dark'] .traffic-chip,
:root[data-theme='dark'] .note-icon-button,
:root[data-theme='dark'] .icon-btn.note {
  border-color: rgba(53, 86, 109, 0.72);
  background: linear-gradient(145deg, rgba(18, 33, 46, 0.96), rgba(12, 26, 37, 0.93));
  color: #c6dcec;
}

:root[data-theme='dark'] .tax-status-indicator.ontrack,
:root[data-theme='dark'] .traffic-chip.ontrack {
  border-color: rgba(74, 199, 140, 0.46);
  background: rgba(34, 95, 69, 0.45);
}

:root[data-theme='dark'] .tax-status-indicator.dueSoon,
:root[data-theme='dark'] .traffic-chip.dueSoon {
  border-color: rgba(226, 178, 95, 0.48);
  background: rgba(108, 78, 23, 0.45);
}

:root[data-theme='dark'] .tax-status-indicator.late,
:root[data-theme='dark'] .traffic-chip.late {
  border-color: rgba(228, 134, 121, 0.5);
  background: rgba(104, 42, 35, 0.48);
}

:root[data-theme='dark'] .tax-status-indicator.default,
:root[data-theme='dark'] .traffic-chip.default {
  border-color: rgba(126, 165, 191, 0.42);
  background: rgba(34, 57, 74, 0.48);
}

:root[data-theme='dark'] .service-pill {
  background: rgba(68, 138, 184, 0.22);
  color: #b8ddf3;
}

:root[data-theme='dark'] .client-pill {
  background: rgba(30, 51, 67, 0.92);
  color: #d4e7f3;
  border: 1px solid rgba(74, 119, 148, 0.58);
}

:root[data-theme='dark'] .client-pill.accent-a,
:root[data-theme='dark'] .client-pill.accent-b,
:root[data-theme='dark'] .client-pill.accent-c,
:root[data-theme='dark'] .client-pill.accent-d,
:root[data-theme='dark'] .client-pill.accent-e,
:root[data-theme='dark'] .client-pill.accent-f {
  color: #d4e7f3;
}

:root[data-theme='dark'] .client-pill.accent-a { background: rgba(46, 75, 106, 0.85); }
:root[data-theme='dark'] .client-pill.accent-b { background: rgba(41, 79, 67, 0.85); }
:root[data-theme='dark'] .client-pill.accent-c { background: rgba(96, 50, 60, 0.85); }
:root[data-theme='dark'] .client-pill.accent-d { background: rgba(97, 72, 39, 0.85); }
:root[data-theme='dark'] .client-pill.accent-e { background: rgba(38, 86, 94, 0.85); }
:root[data-theme='dark'] .client-pill.accent-f { background: rgba(65, 56, 107, 0.85); }

:root[data-theme='dark'] .note-icon-button:hover,
:root[data-theme='dark'] .icon-btn.note:hover {
  border-color: rgba(132, 188, 223, 0.6);
  color: #d9eefb;
  background: rgba(66, 121, 157, 0.34);
}

/* Dark mode contrast hardening v2 (overview + attendance) */
:root[data-theme='dark'] .btn:not(.primary):not(.ghost):not(.secondary) {
  border: 1px solid rgba(108, 170, 207, 0.42);
  background: linear-gradient(132deg, rgba(37, 78, 106, 0.92), rgba(25, 54, 74, 0.94));
  color: #e9f6ff;
  box-shadow: 0 10px 18px rgba(4, 13, 20, 0.42);
}

:root[data-theme='dark'] .btn:not(.primary):not(.ghost):not(.secondary):hover:not(:disabled) {
  border-color: rgba(145, 205, 240, 0.56);
  background: linear-gradient(132deg, rgba(46, 93, 124, 0.94), rgba(31, 67, 91, 0.96));
}

:root[data-theme='dark'] .overview-metric-card,
:root[data-theme='dark'] .overview-performance-item,
:root[data-theme='dark'] .control-board-card,
:root[data-theme='dark'] .attendance-export-item,
:root[data-theme='dark'] .attendance-group-header {
  border: 1px solid rgba(58, 96, 123, 0.78);
  background:
    linear-gradient(150deg, rgba(18, 34, 47, 0.98), rgba(12, 26, 37, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);
}

:root[data-theme='dark'] .overview-metric-card .label {
  color: #a7c2d5;
}

:root[data-theme='dark'] .overview-metric-card strong {
  color: #f2f9ff;
}

:root[data-theme='dark'] .overview-metric-card span {
  color: #d5e7f3;
}

:root[data-theme='dark'] .overview-metric-card small {
  color: #bfd5e4;
}

:root[data-theme='dark'] .overview-metric-card.tone-success {
  border-color: rgba(74, 199, 140, 0.5);
  background:
    linear-gradient(145deg, rgba(18, 59, 44, 0.9), rgba(15, 38, 30, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .overview-metric-card.tone-warning {
  border-color: rgba(226, 178, 95, 0.54);
  background:
    linear-gradient(145deg, rgba(77, 57, 20, 0.88), rgba(48, 35, 14, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .overview-metric-card.tone-danger {
  border-color: rgba(228, 134, 121, 0.56);
  background:
    linear-gradient(145deg, rgba(86, 38, 37, 0.88), rgba(49, 22, 24, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .overview-performance-head strong,
:root[data-theme='dark'] .overview-performance-head span,
:root[data-theme='dark'] .attendance-export-info strong,
:root[data-theme='dark'] .attendance-group-info strong {
  color: #eef8ff;
}

:root[data-theme='dark'] .control-board-card.disabled {
  opacity: 0.78;
  border-color: rgba(59, 91, 115, 0.62);
  background:
    linear-gradient(145deg, rgba(17, 29, 40, 0.96), rgba(12, 23, 33, 0.94)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .control-board-card.disabled:hover {
  border-color: rgba(59, 91, 115, 0.62);
  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);
}

:root[data-theme='dark'] .attendance-export-item.ready {
  border-color: rgba(74, 199, 140, 0.5);
  background: linear-gradient(145deg, rgba(22, 67, 49, 0.88), rgba(15, 40, 31, 0.94));
}

:root[data-theme='dark'] .attendance-export-item.missing {
  border-color: rgba(226, 178, 95, 0.52);
  background: linear-gradient(145deg, rgba(91, 64, 20, 0.88), rgba(50, 36, 14, 0.94));
}

:root[data-theme='dark'] .attendance-export-status {
  border-color: rgba(89, 138, 170, 0.55);
  background: rgba(20, 44, 61, 0.8);
  color: #d5e8f5;
}

:root[data-theme='dark'] .attendance-export-status.ready {
  border-color: rgba(86, 214, 158, 0.58);
  background: rgba(32, 92, 65, 0.58);
  color: #c3f3dc;
}

:root[data-theme='dark'] .attendance-export-status.missing {
  border-color: rgba(230, 182, 95, 0.58);
  background: rgba(106, 77, 26, 0.6);
  color: #ffe0a4;
}

:root[data-theme='dark'] .attendance-export-check input {
  accent-color: #5da7d8;
  background-color: #102131;
  border-color: rgba(95, 151, 186, 0.6);
}

:root[data-theme='dark'] .attendance-group .attendance-table-row {
  border-color: rgba(58, 96, 123, 0.74);
  background:
    linear-gradient(145deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .attendance-group .attendance-table-row:hover {
  background:
    linear-gradient(145deg, rgba(28, 50, 68, 0.98), rgba(20, 39, 54, 0.96)),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center/320px 320px;
}

:root[data-theme='dark'] .attendance-chip {
  border-color: rgba(73, 116, 144, 0.62);
  background: rgba(22, 44, 61, 0.72);
  color: #dbeaf4;
}

:root[data-theme='dark'] .attendance-chip.state.cerrada,
:root[data-theme='dark'] .attendance-chip.validation.valida {
  border-color: rgba(74, 199, 140, 0.58);
  background: rgba(32, 92, 65, 0.58);
  color: #b9efcf;
}

:root[data-theme='dark'] .attendance-chip.state.abierta {
  border-color: rgba(122, 172, 212, 0.6);
  background: rgba(46, 84, 117, 0.62);
  color: #cce7fa;
}

:root[data-theme='dark'] .attendance-chip.state.incompleta {
  border-color: rgba(226, 178, 95, 0.62);
  background: rgba(106, 77, 26, 0.62);
  color: #ffe0a4;
}

:root[data-theme='dark'] .attendance-chip.validation.fuera-de-horario,
:root[data-theme='dark'] .attendance-chip.validation.duplicado,
:root[data-theme='dark'] .attendance-chip.validation.token-invalido,
:root[data-theme='dark'] .attendance-chip.validation.usuario-inactivo {
  border-color: rgba(228, 134, 121, 0.62);
  background: rgba(104, 42, 35, 0.64);
  color: #ffd0c8;
}

:root[data-theme='dark'] .center-chip {
  border-color: rgba(69, 108, 134, 0.72);
  background: rgba(12, 25, 36, 0.9);
  color: #c4daea;
  opacity: 0.78;
  filter: none;
}

:root[data-theme='dark'] .center-chip.active {
  border-color: rgba(152, 214, 245, 0.48);
  background: linear-gradient(130deg, #255d7c, #367ca3);
  color: #f4fbff;
  opacity: 1;
}

:root[data-theme='dark'] .center-chip.center-cuu-ac-servicios-2020-sc {
  background: rgba(34, 92, 114, 0.68);
  border-color: rgba(110, 203, 228, 0.56);
  color: #d0f2fa;
}

:root[data-theme='dark'] .center-chip.center-luz-elena-najera-sanchez {
  background: rgba(54, 68, 130, 0.68);
  border-color: rgba(150, 169, 240, 0.6);
  color: #dce4ff;
}

:root[data-theme='dark'] .center-chip.center-argelia-fernandez-de-haro {
  background: rgba(98, 74, 31, 0.68);
  border-color: rgba(232, 197, 110, 0.58);
  color: #ffebc1;
}

.db-shortcuts-panel {
  margin-top: 1rem;
  border: 1px solid rgba(58, 93, 117, 0.22);
  border-radius: 18px;
  padding: 1rem 1.1rem;
  background: linear-gradient(135deg, rgba(242, 248, 252, 0.95), rgba(229, 240, 247, 0.9));
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.db-shortcuts-view {
  margin-top: 0.9rem;
}

.db-shortcuts-panel h3 {
  margin: 0.2rem 0 0.25rem;
}

.db-shortcuts-panel p {
  margin: 0;
}

.db-shortcuts-actions {
  display: flex;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.locations-panel {
  margin-bottom: 1rem;
  border: 1px solid rgba(58, 93, 117, 0.22);
  border-radius: 20px;
  padding: 1rem 1.1rem;
  background: linear-gradient(145deg, rgba(246, 250, 253, 0.95), rgba(236, 245, 251, 0.92));
}

.locations-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  flex-wrap: wrap;
}

.locations-header h3 {
  margin: 0.2rem 0 0.3rem;
}

.locations-header p {
  margin: 0;
}

.locations-form-grid {
  margin-top: 0.9rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.7rem;
}

.locations-header-actions {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex-wrap: wrap;
}

.locations-visibility-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.locations-visibility-toggle::before {
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: rgba(76, 99, 115, 0.8);
  box-shadow: 0 0 0 1px rgba(54, 75, 92, 0.2);
  transition: background 0.25s ease, box-shadow 0.25s ease;
}

.locations-visibility-toggle.active::before {
  background: rgba(39, 151, 91, 0.9);
  box-shadow: 0 0 0 4px rgba(39, 151, 91, 0.16);
  animation: locations-status-pulse 1.65s ease-in-out infinite;
}

.locations-collapsed-note {
  margin-top: 0.6rem;
}

.locations-collapsible {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.42s cubic-bezier(0.2, 0.85, 0.22, 1);
}

.locations-collapsible.is-open {
  grid-template-rows: 1fr;
}

.locations-collapsible-inner {
  min-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.26s ease, transform 0.42s cubic-bezier(0.2, 0.85, 0.22, 1);
}

.locations-collapsible.is-open .locations-collapsible-inner {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

.locations-collapsible.is-closed .locations-collapsible-inner {
  pointer-events: none;
  visibility: hidden;
}

@keyframes locations-status-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 4px rgba(39, 151, 91, 0.16);
  }
  50% {
    box-shadow: 0 0 0 7px rgba(39, 151, 91, 0.08);
  }
}

.locations-search {
  grid-column: 1 / -1;
}

.locations-maps-url {
  grid-column: 1 / -1;
}

.locations-maps-url-primary {
  border: 1px solid rgba(31, 106, 158, 0.2);
  border-radius: 16px;
  background: rgba(228, 243, 252, 0.54);
  padding: 0.78rem;
}

.locations-maps-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.locations-maps-header label {
  margin: 0;
  font-weight: 700;
}

.locations-maps-url label {
  display: block;
  margin-bottom: 0.35rem;
}

.locations-maps-url-row {
  display: flex;
  gap: 0.55rem;
  align-items: center;
}

.locations-maps-url-row input[type='text'] {
  flex: 1 1;
}

.locations-search label {
  display: block;
  margin-bottom: 0.35rem;
}

.locations-search-row {
  display: flex;
  gap: 0.55rem;
  align-items: center;
}

.locations-search-row input[type='search'] {
  flex: 1 1;
}

.locations-form-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.36rem;
  color: #1f455d;
  font-weight: 620;
}

.locations-maps-url-row input[type='text'],
.locations-search-row input[type='search'],
.locations-form-grid input:not([type='checkbox']),
.locations-form-grid textarea {
  width: 100%;
  min-height: 2.7rem;
  border: 1px solid rgba(56, 90, 111, 0.28);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(245, 250, 254, 0.98));
  color: #153245;
  padding: 0.62rem 0.78rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82), 0 1px 2px rgba(20, 56, 78, 0.08);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.locations-form-grid input[type='number'] {
  font-variant-numeric: tabular-nums;
}

.locations-form-grid textarea {
  min-height: 88px;
  line-height: 1.45;
}

.locations-maps-url-row input[type='text']::placeholder,
.locations-search-row input[type='search']::placeholder,
.locations-form-grid input:not([type='checkbox'])::placeholder,
.locations-form-grid textarea::placeholder {
  color: rgba(66, 101, 123, 0.78);
}

.locations-maps-url-row input[type='text']:hover:not(:disabled),
.locations-search-row input[type='search']:hover:not(:disabled),
.locations-form-grid input:not([type='checkbox']):hover:not(:disabled),
.locations-form-grid textarea:hover:not(:disabled) {
  border-color: rgba(36, 100, 140, 0.42);
}

.locations-maps-url-row input[type='text']:focus-visible,
.locations-search-row input[type='search']:focus-visible,
.locations-form-grid input:not([type='checkbox']):focus-visible,
.locations-form-grid textarea:focus-visible {
  outline: none;
  border-color: rgba(25, 117, 185, 0.72);
  box-shadow: 0 0 0 3px rgba(25, 117, 185, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.92);
}

.locations-maps-url-row input[type='text']:disabled,
.locations-search-row input[type='search']:disabled,
.locations-form-grid input:not([type='checkbox']):disabled,
.locations-form-grid textarea:disabled {
  cursor: not-allowed;
  border-color: rgba(88, 116, 136, 0.24);
  background: rgba(236, 244, 250, 0.86);
  color: rgba(54, 80, 97, 0.74);
  box-shadow: none;
}

.locations-suggestions {
  margin-top: 0.45rem;
  border: 1px solid rgba(63, 95, 117, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  overflow: hidden;
  max-height: 260px;
  overflow-y: auto;
}

.locations-suggestion {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 0.58rem 0.68rem;
  text-align: left;
  cursor: pointer;
  display: grid;
  gap: 0.2rem;
}

.locations-suggestion + .locations-suggestion {
  border-top: 1px solid rgba(63, 95, 117, 0.14);
}

.locations-suggestion:hover {
  background: rgba(99, 163, 214, 0.13);
}

.locations-suggestion:focus-visible {
  outline: 2px solid rgba(25, 117, 185, 0.65);
  outline-offset: -2px;
}

.locations-suggestion-title {
  font-weight: 600;
}

.locations-suggestion-subtitle {
  font-size: 0.89rem;
  opacity: 0.9;
}

.locations-suggestion-coords {
  font-size: 0.78rem;
  opacity: 0.75;
}

.locations-notes {
  grid-column: 1 / -1;
}

.locations-form-grid textarea {
  width: 100%;
  resize: vertical;
  min-height: 70px;
}

.checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}

.locations-form-actions {
  grid-column: 1 / -1;
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.locations-table-wrap {
  margin-top: 0.9rem;
  overflow-x: auto;
}

.locations-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 680px;
}

.locations-table th,
.locations-table td {
  text-align: left;
  padding: 0.55rem 0.65rem;
  border-bottom: 1px solid rgba(63, 95, 117, 0.16);
}

.locations-actions {
  display: flex;
  gap: 0.45rem;
}

:root[data-theme='dark'] .db-shortcuts-panel {
  border-color: rgba(78, 122, 151, 0.5);
  background: linear-gradient(145deg, rgba(18, 37, 52, 0.95), rgba(12, 29, 41, 0.93));
}

:root[data-theme='dark'] .db-shortcuts-panel h3,
:root[data-theme='dark'] .locations-header h3 {
  color: #ebf6ff;
}

:root[data-theme='dark'] .db-shortcuts-panel p,
:root[data-theme='dark'] .locations-header p {
  color: #c3d9e9;
}

:root[data-theme='dark'] .locations-panel {
  border-color: rgba(78, 122, 151, 0.5);
  background: linear-gradient(145deg, rgba(18, 37, 52, 0.95), rgba(12, 29, 41, 0.93));
}

:root[data-theme='dark'] .locations-panel label,
:root[data-theme='dark'] .locations-panel .checkbox-inline span {
  color: #d6e8f5;
}

:root[data-theme='dark'] .locations-form-grid label {
  color: #d8e9f6;
}

:root[data-theme='dark'] .locations-visibility-toggle::before {
  background: rgba(133, 160, 180, 0.82);
  box-shadow: 0 0 0 1px rgba(84, 118, 142, 0.45);
}

:root[data-theme='dark'] .locations-visibility-toggle.active::before {
  background: rgba(69, 210, 132, 0.92);
  box-shadow: 0 0 0 4px rgba(69, 210, 132, 0.2);
}

:root[data-theme='dark'] .locations-maps-url-primary {
  border-color: rgba(104, 173, 216, 0.36);
  background: rgba(11, 31, 45, 0.88);
}

:root[data-theme='dark'] .locations-maps-url-row input[type='text'],
:root[data-theme='dark'] .locations-search-row input[type='search'],
:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']),
:root[data-theme='dark'] .locations-form-grid textarea {
  border-color: rgba(110, 156, 186, 0.42);
  background: linear-gradient(180deg, rgba(8, 21, 31, 0.96), rgba(10, 26, 37, 0.94));
  color: #e9f5fd;
  box-shadow: inset 0 1px 0 rgba(146, 189, 214, 0.12), 0 1px 2px rgba(0, 0, 0, 0.22);
}

:root[data-theme='dark'] .locations-maps-url-row input[type='text']::placeholder,
:root[data-theme='dark'] .locations-search-row input[type='search']::placeholder,
:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox'])::placeholder,
:root[data-theme='dark'] .locations-form-grid textarea::placeholder {
  color: rgba(176, 206, 226, 0.74);
}

:root[data-theme='dark'] .locations-maps-url-row input[type='text']:hover:not(:disabled),
:root[data-theme='dark'] .locations-search-row input[type='search']:hover:not(:disabled),
:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):hover:not(:disabled),
:root[data-theme='dark'] .locations-form-grid textarea:hover:not(:disabled) {
  border-color: rgba(128, 191, 226, 0.58);
}

:root[data-theme='dark'] .locations-maps-url-row input[type='text']:focus-visible,
:root[data-theme='dark'] .locations-search-row input[type='search']:focus-visible,
:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):focus-visible,
:root[data-theme='dark'] .locations-form-grid textarea:focus-visible {
  border-color: rgba(120, 198, 238, 0.86);
  box-shadow: 0 0 0 3px rgba(98, 175, 217, 0.26), inset 0 1px 0 rgba(146, 189, 214, 0.16);
}

:root[data-theme='dark'] .locations-maps-url-row input[type='text']:disabled,
:root[data-theme='dark'] .locations-search-row input[type='search']:disabled,
:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):disabled,
:root[data-theme='dark'] .locations-form-grid textarea:disabled {
  border-color: rgba(81, 118, 142, 0.36);
  background: rgba(12, 26, 37, 0.74);
  color: rgba(167, 192, 210, 0.74);
  box-shadow: none;
}

:root[data-theme='dark'] .locations-suggestions {
  border-color: rgba(88, 134, 163, 0.38);
  background: rgba(9, 20, 29, 0.92);
}

:root[data-theme='dark'] .locations-suggestion {
  color: #e8f4fc;
}

:root[data-theme='dark'] .locations-suggestion + .locations-suggestion {
  border-top-color: rgba(88, 134, 163, 0.32);
}

:root[data-theme='dark'] .locations-suggestion:hover {
  background: rgba(46, 116, 163, 0.26);
}

:root[data-theme='dark'] .locations-suggestion-title {
  color: #f2f9ff;
}

:root[data-theme='dark'] .locations-suggestion-subtitle {
  color: #b7d1e2;
}

:root[data-theme='dark'] .locations-suggestion-coords {
  color: #96b8cf;
}

:root[data-theme='dark'] .locations-panel .helper-text {
  color: #b8d0df;
}

:root[data-theme='dark'] .locations-panel .helper-text.warning {
  color: #f0d197;
}

:root[data-theme='dark'] .locations-panel .helper-text.error {
  color: #f0a8a0;
}

:root[data-theme='dark'] .locations-table th,
:root[data-theme='dark'] .locations-table td {
  border-bottom-color: rgba(88, 134, 163, 0.32);
}

/* Dark mode legibility for Create Invoice modal */
:root[data-theme='dark'] .create-card label {
  color: #d9e9f4;
}

:root[data-theme='dark'] .create-card .form-section h4 {
  color: #edf7ff;
}

:root[data-theme='dark'] .create-card .create-stepper .step {
  color: #c2d8e7;
  border-color: rgba(74, 119, 148, 0.58);
  background: linear-gradient(140deg, rgba(14, 29, 41, 0.96), rgba(10, 22, 33, 0.94));
}

:root[data-theme='dark'] .create-card .create-stepper .step.active {
  color: #f4fbff;
  border-color: rgba(149, 207, 244, 0.5);
  background: linear-gradient(130deg, #255d7c, #3b86b0);
}

:root[data-theme='dark'] .create-card .upload-list li {
  border: 1px solid rgba(66, 105, 132, 0.62);
  background: rgba(11, 24, 35, 0.92);
  color: #dcecf6;
}

:root[data-theme='dark'] .create-card .upload-list li small {
  color: #aac3d4;
}

@media (max-width: 960px) {
  :root[data-theme='dark'] .view-tabs {
    width: 100%;
    overflow-x: auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .locations-collapsible,
  .locations-collapsible-inner,
  .locations-visibility-toggle::before {
    transition: none;
    animation: none;
  }
}

@media (max-width: 640px) {
  .locations-header-actions {
    width: 100%;
  }

  .locations-header-actions .btn {
    width: 100%;
  }

  .locations-maps-url-row,
  .locations-search-row {
    flex-direction: column;
    align-items: stretch;
  }

  .locations-maps-url-row .btn,
  .locations-search-row .btn {
    width: 100%;
  }

  :root[data-theme='dark'] .app-header {
    padding: 1rem 1rem 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,0FAA0F;EAC1F,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;WACS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,gGAAgG;AAClG;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qGAAqG;AACvG;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,kFAAkF;EAClF,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,kDAAkD;EAClD,cAAc;EACd,+EAA+E;AACjF;;AAEA;EACE,qBAAqB;EACrB,qFAAqF;EACrF,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,+GAA+G;EAC/G,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,8GAA8G;AAChH;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,wEAAwE;EACxE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0E;EAC1E,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0EAA0E;EAC1E,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,qBAAqB;EACrB,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,sCAAsC;EACtC,yFAAyF;AAC3F;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,0EAA0E;EAC1E,0CAA0C;EAC1C,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;EAC9C,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gFAAgF;EAChF,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA,iCAAiC,0BAA0B,EAAE;AAC7D,gCAAgC,0BAA0B,EAAE;AAC5D,mCAAmC,0BAA0B,EAAE;AAC/D,8BAA8B,0BAA0B,EAAE;AAC1D,kCAAkC,0BAA0B,EAAE;AAC9D,iCAAiC,0BAA0B,EAAE;AAC7D,kCAAkC,0BAA0B,EAAE;AAC9D,iCAAiC,0BAA0B,EAAE;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,6EAA6E;EAC7E,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,6EAA6E;AAC/E;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,iDAAiD;EACnD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;EAChD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;EACxB;;EAEA,0CAA0C,kBAAkB,EAAE;EAC9D,0CAA0C,qBAAqB,EAAE;EACjE,0CAA0C,sBAAsB,EAAE;EAClE,0CAA0C,6BAA6B,EAAE;EACzE,0CAA0C,iBAAiB,EAAE;EAC7D,0CAA0C,gBAAgB,EAAE;EAC5D,0CAA0C,iBAAiB,EAAE;EAC7D,0CAA0C,gBAAgB,EAAE;;EAE5D;IACE,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;AAEF;IACI,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE,2EAA2E;EAC3E,gFAAgF;EAChF,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB;;;qDAGmD;EACnD,kCAAkC;AACpC;;AAEA;EACE;;;0FAGsF;AACxF;;AAEA;EACE,kCAAkC;EAClC;;8DAE0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;;;uCAGqC;EACrC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;;;gFAG8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,uBAAuB;EACvB;;8DAE0D;EAC1D,8CAA8C;AAChD;;AAEA;;;;;;;EAOE,mCAAmC;EACnC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uGAAuG;AACzG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8EAA8E;EAC9E,cAAc;EACd,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,0EAAsE;EACtE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,8BAA8B;EAC9B,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;EAaE,kCAAkC;EAClC;;8DAE0D;EAC1D,8CAA8C;AAChD;;AAEA,8CAA8C;AAC9C;;;;;;;;;;;;;;EAcE,2CAA2C;EAC3C;;8DAE0D;EAC1D,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;EAWE,uCAAuC;EACvC;;8DAE0D;AAC5D;;AAEA;EACE;;8DAE0D;EAC1D,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;EAGE,2CAA2C;EAC3C;;8DAE0D;AAC5D;;AAEA;;;;EAIE;;8DAE0D;EAC1D,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,yFAAyF;AAC3F;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;;;EAGE,8BAA8B;EAC9B;;8DAE0D;AAC5D;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;;;EAME,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;;;;;EASE,oEAAoE;AACtE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oCAAoC;AACpC;EACE,2EAA2E;EAC3E,gFAAgF;EAChF,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB;;;kEAGgE;EAChE,kCAAkC;AACpC;;AAEA;EACE;;;0FAG2F;AAC7F;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;;;;;;;EAQE,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;;;uCAGqC;EACrC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;;;+EAG6E;AAC/E;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uGAAuG;AACzG;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,2CAA2C;EAC3C,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,0EAA2E;EAC3E,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mFAAmF;EACnF,cAAc;EACd,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qDAAqD;EACrD,cAAc;EACd,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;EAaE,qBAAqB;EACrB,kCAAkC;EAClC;;8DAE+D;EAC/D,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;;;;;;;;;;;;;;EAcE,yCAAyC;EACzC;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;;;;;;;;;;;;EAYE,qCAAqC;EACrC;;8DAE+D;AACjE;;AAEA;EACE;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;;;;;;EAME,8BAA8B;EAC9B,mFAAmF;AACrF;;AAEA;;EAEE,qDAAqD;EACrD,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;;;;;;;;;;;;EAaE,wCAAwC;EACxC;;8DAE+D;AACjE;;AAEA;;;;;;EAME;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,mFAAmF;EACnF,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;;;EAGE,8BAA8B;EAC9B;;8DAE+D;AACjE;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,sCAAsC;EACtC,kFAAkF;EAClF,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kFAAkF;EAClF,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;;;;;;;;;;;;;;;;;;;EAmBE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qDAAqD;EACrD,cAAc;AAChB;;AAEA;;;EAGE,kCAAkC;EAClC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;;;EAIE,qCAAqC;EACrC,mFAAmF;EACnF,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;;EAEE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;;EAEE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA,iDAAiD,mCAAmC,EAAE;AACtF,iDAAiD,kCAAkC,EAAE;AACrF,iDAAiD,kCAAkC,EAAE;AACrF,iDAAiD,kCAAkC,EAAE;AACrF,iDAAiD,kCAAkC,EAAE;AACrF,iDAAiD,mCAAmC,EAAE;;AAEtF;;EAEE,sCAAsC;EACtC,cAAc;EACd,oCAAoC;AACtC;;AAEA,4DAA4D;AAC5D;EACE,2CAA2C;EAC3C,oFAAoF;EACpF,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,oFAAoF;AACtF;;AAEA;;;;;EAKE,yCAAyC;EACzC;;8DAE+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC;;8DAE+D;AACjE;;AAEA;EACE,sCAAsC;EACtC;;8DAE+D;AACjE;;AAEA;EACE,uCAAuC;EACvC;;8DAE+D;AACjE;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC;;8DAE+D;AACjE;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;EACE,sCAAsC;EACtC,mFAAmF;AACrF;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC;;8DAE+D;AACjE;;AAEA;EACE;;8DAE+D;AACjE;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;;;EAIE,uCAAuC;EACvC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,qDAAqD;EACrD,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;EACpB,wFAAwF;EACxF,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;EACpB,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qEAAqE;AACvE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,yFAAyF;EACzF,cAAc;EACd,wBAAwB;EACxB,qFAAqF;EACrF;;;wBAGsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,sCAAsC;AACxC;;AAEA;;;;EAIE,aAAa;EACb,sCAAsC;EACtC,sFAAsF;AACxF;;AAEA;;;;EAIE,mBAAmB;EACnB,sCAAsC;EACtC,qCAAqC;EACrC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mFAAmF;AACrF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;;;;EAIE,uCAAuC;EACvC,kFAAkF;EAClF,cAAc;EACd,kFAAkF;AACpF;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;;;;EAIE,uCAAuC;EACvC,uFAAuF;AACzF;;AAEA;;;;EAIE,sCAAsC;EACtC,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA,kDAAkD;AAClD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mFAAmF;AACrF;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: #101828;\n  background-color: #f5f7fb;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  background: #f5f7fb;\n}\n\n.auth-shell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: radial-gradient(circle at top, rgba(79, 70, 229, 0.08), transparent),\n    #f5f7fb;\n}\n\n.login-card {\n  width: min(480px, 100%);\n  background: white;\n  border-radius: 1.5rem;\n  padding: 2.5rem;\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-card label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-weight: 600;\n}\n\n.login-card input {\n  border-radius: 0.85rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.85rem 1rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.auth-footnote {\n  border-top: 1px solid #f1f5f9;\n  margin-top: 0.5rem;\n  padding-top: 0.75rem;\n  color: #475467;\n  font-size: 0.85rem;\n}\n\n.auth-footnote strong {\n  color: #101828;\n}\n\n.app-shell {\n  min-height: 100vh;\n  padding: 2.5rem clamp(1.25rem, 4vw, 4rem) 3rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-size: 0.75rem;\n  color: #4f46e5;\n  font-weight: 600;\n  margin: 0 0 0.5rem;\n}\n\n.app-header h1 {\n  margin: 0;\n  font-size: clamp(1.9rem, 3vw, 2.8rem);\n}\n\n.subtitle {\n  margin-top: 0.5rem;\n  max-width: 720px;\n  color: #5f6c89;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.btn {\n  border: none;\n  border-radius: 999px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn.compact {\n  padding: 0.45rem 1rem;\n  font-size: 0.82rem;\n}\n\n.theme-toggle-corner {\n  position: fixed;\n  top: 0.75rem;\n  right: 0.75rem;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid rgba(23, 42, 58, 0.22);\n  background: rgba(255, 255, 255, 0.7);\n  color: #35546a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 110;\n  opacity: 0.3;\n  backdrop-filter: blur(5px);\n  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.theme-toggle-corner:hover,\n.theme-toggle-corner:focus-visible {\n  opacity: 0.95;\n  transform: translateY(-1px);\n  border-color: rgba(23, 42, 58, 0.45);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.2);\n}\n\n.theme-toggle-corner span {\n  font-size: 0.9rem;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.btn.primary {\n  background: linear-gradient(120deg, #4f46e5, #7c3aed);\n  color: white;\n  box-shadow: 0 10px 20px rgba(79, 70, 229, 0.2);\n}\n\n.btn.ghost {\n  background: transparent;\n  color: #4f46e5;\n  border: 1px solid rgba(79, 70, 229, 0.3);\n}\n\n.btn.secondary {\n  background: rgba(79, 70, 229, 0.08);\n  color: #312e81;\n  border: 1px solid rgba(79, 70, 229, 0.2);\n  box-shadow: 0 6px 15px rgba(79, 70, 229, 0.15);\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 1rem;\n}\n\n.filters {\n  background: white;\n  border-radius: 1rem;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n}\n\n.view-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.pill-group {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.pill {\n  border-radius: 999px;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: transparent;\n  padding: 0.45rem 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pill.active {\n  background: #4f46e5;\n  color: white;\n  border-color: transparent;\n  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.25);\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 1rem;\n}\n\n.summary-card {\n  background: white;\n  border-radius: 1rem;\n  padding: 1.25rem;\n  box-shadow: 0 10px 35px rgba(15, 23, 42, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: default;\n}\n\n.summary-card.active {\n  border: 1px solid #4f46e5;\n  box-shadow: 0 12px 30px rgba(79, 70, 229, 0.25);\n  transform: translateY(-4px);\n}\n\n.summary-card.clickable {\n  cursor: pointer;\n}\n\n.summary-card:focus {\n  outline: 2px solid #4f46e5;\n}\n\n.summary-card .label {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.7rem;\n  color: #94a3b8;\n  margin: 0 0 0.25rem;\n}\n\n.summary-card h2 {\n  margin: 0;\n  font-size: 1.75rem;\n}\n\n.summary-card span {\n  color: #475467;\n  font-size: 0.9rem;\n}\n\n.content-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n  gap: 1.5rem;\n}\n\n.content-grid.pulse-collapsed {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.65);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 3rem 1rem;\n  z-index: 50;\n  overflow-y: auto;\n}\n\n.overlay.activity-overlay {\n  z-index: 60;\n}\n\n.overlay.upload-overlay {\n  z-index: 70;\n}\n\n.overlay.notes-overlay {\n  z-index: 80;\n}\n\n.airtable-modal {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.5rem;\n  width: min(1100px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n.modal-header p {\n  margin: 0.35rem 0 0;\n  color: #475467;\n}\n\n.airtable-frame {\n  border-radius: 1rem;\n  overflow: hidden;\n  background: white;\n}\n\n.airtable-embed {\n  display: block;\n  width: 100%;\n  border: 1px solid #ccc;\n  background: transparent;\n}\n\n.automation-upload-card {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  width: min(640px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);\n}\n\n.activity-modal {\n  background: white;\n  border-radius: 1.25rem;\n  padding: 1.25rem 1.5rem;\n  width: min(960px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.35);\n}\n\n.activity-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.activity-modal-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.activity-modal-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.85rem;\n  align-items: stretch;\n  width: 100%;\n}\n\n.activity-modal-row > * {\n  flex: 1 1 min(280px, 100%);\n}\n\n.activity-modal-row .client-cell,\n.activity-modal-row .activity-responsable {\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 0.85rem 1rem;\n  background: #f8fafc;\n  min-height: 100%;\n}\n\n.activity-modal-row .activity-chip.condensed {\n  width: 100%;\n}\n\n.activity-chip.condensed .btn {\n  margin-top: 0.4rem;\n  align-self: flex-start;\n}\n\n@media (orientation: landscape) and (min-width: 1100px) {\n  .activity-modal-row {\n    flex-wrap: wrap;\n  }\n  .activity-modal-row .client-cell,\n  .activity-modal-row .activity-responsable {\n    flex: 1 1 240px;\n  }\n  .activity-modal-row .activity-chip.condensed {\n    flex: 1 1 200px;\n  }\n}\n\n.activity-detail {\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  background: #f8fafc;\n  padding: 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: #0f172a;\n}\n\n.whatsapp-modal {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  width: min(640px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.35);\n}\n\n.automation-upload-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.automation-upload-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-weight: 600;\n}\n\n.automation-upload-grid input[type=\"file\"] {\n  border: 1px dashed #cbd5f5;\n  border-radius: 0.85rem;\n  padding: 0.65rem;\n  background: #f8fafc;\n  font-family: inherit;\n}\n\n.file-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-top: 0.25rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #312e81;\n  font-size: 0.8rem;\n}\n\n.tax-upload-dialog {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  width: min(720px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.35);\n}\n\n.tax-upload-dialog-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.tax-upload-stepper {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.tax-upload-step {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-radius: 1rem;\n  border: 1px solid #e4e7ec;\n  background: #f9fafb;\n  font-size: 0.85rem;\n  color: #475467;\n}\n\n.tax-upload-step span {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  background: #e0e7ff;\n  color: #4338ca;\n}\n\n.tax-upload-step.active {\n  border-color: #6366f1;\n  background: #eef2ff;\n  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.2);\n}\n\n.tax-upload-step.active span {\n  background: #4338ca;\n  color: #fff;\n}\n\n.tax-upload-step-panel {\n  display: block;\n  width: 100%;\n}\n\n.tax-upload-step-panel.is-hidden {\n  display: none;\n}\n\n.tax-note-summary {\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #eef2ff 100%);\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.tax-note-summary-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  margin-bottom: 0.35rem;\n}\n\n.tax-note-summary-grid {\n  list-style: none;\n  margin: 0.5rem 0 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.65rem;\n}\n\n.tax-note-summary-grid li {\n  padding: 0.75rem 0.85rem;\n  border-radius: 0.85rem;\n  background: #fff;\n  border: 1px solid #e4e7ec;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.tax-note-summary-grid .label {\n  font-size: 0.8rem;\n  color: #6b7280;\n}\n\n.note-summary-raw {\n  margin: 0.35rem 0 0;\n  padding: 0.75rem 0.85rem;\n  background: #fff;\n  border-radius: 0.85rem;\n  border: 1px dashed #cbd5e1;\n  color: #334155;\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n}\n\n.tax-locked-card {\n  border: 1px dashed #f59e0b;\n  background: #fff7ed;\n  border-radius: 1rem;\n  padding: 0.85rem 0.95rem;\n  margin-bottom: 1rem;\n}\n\n.tax-upload-step-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.tax-upload-step-panel-header .link-btn {\n  font-size: 0.9rem;\n  padding: 0;\n}\n\n.tax-legacy-upload-card {\n  border: 1px solid #dbe3f0;\n  border-radius: 1rem;\n  padding: 0.95rem;\n  background: linear-gradient(145deg, #f8fbff, #f2f7ff);\n  display: grid;\n  gap: 0.85rem;\n}\n\n.tax-legacy-upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.tax-legacy-upload-header small {\n  display: block;\n  color: #475467;\n}\n\n.info-toggle.compact {\n  padding: 0.38rem 0.85rem;\n  font-size: 0.82rem;\n  white-space: nowrap;\n}\n\n@media (max-width: 760px) {\n  .tax-legacy-upload-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.tax-dropzone {\n  border: 1.5px dashed #cbd5f5;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  text-align: center;\n  background: #f8fafc;\n  position: relative;\n}\n\n.tax-dropzone input[type=\"file\"] {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.tax-dropzone.dragging {\n  border-color: #4f46e5;\n  background: rgba(79, 70, 229, 0.05);\n}\n\n.tax-dropzone span {\n  color: #4f46e5;\n  font-weight: 600;\n}\n\n.tax-upload-file-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  background: #f9fafb;\n}\n\n.tax-upload-file-list li {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e4e7ec;\n  font-size: 0.9rem;\n}\n\n.tax-upload-file-list li:last-child {\n  border-bottom: none;\n}\n\n.tax-requirements {\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 1rem;\n  background: #fff;\n}\n\n.tax-requirements ul {\n  margin: 0.5rem 0 0;\n  padding-left: 1.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: #475467;\n}\n\n.notes-modal {\n  background: #fff;\n  border-radius: 1.5rem;\n  width: min(520px, 100%);\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.3);\n}\n\n.notes-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.note-requirements {\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 0.85rem 1rem;\n  background: #f8fafc;\n}\n\n.note-requirements h4 {\n  margin: 0 0 0.35rem;\n  font-size: 0.85rem;\n  color: #0f172a;\n}\n\n.note-requirements ul {\n  margin: 0;\n  padding-left: 1rem;\n  color: #475467;\n  font-size: 0.85rem;\n}\n\n.notes-modal textarea {\n  min-height: 140px;\n  border-radius: 1rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.9rem;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.notes-modal textarea[readonly] {\n  background: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.notes-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.note-status {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  margin: 0.35rem 0 0;\n}\n\n.note-status.saving {\n  color: #2563eb;\n}\n\n.note-status.saved {\n  color: #15803d;\n}\n\n.note-status.error,\n.note-status.note-status-error {\n  color: #b91c1c;\n}\n\n.tax-metadata-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.85rem;\n}\n\n.tax-metadata-grid label {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.85rem 0.95rem 0.9rem;\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  background: linear-gradient(145deg, #f8fafc, #eef2ff);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.65);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: #111827;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease, background 0.25s ease;\n}\n\n.tax-metadata-grid label:focus-within {\n  border-color: #4338ca;\n  background: linear-gradient(145deg, #eef2ff, #f8fafc);\n  box-shadow: 0 10px 28px rgba(67, 56, 202, 0.18), 0 0 0 4px rgba(67, 56, 202, 0.12);\n  transform: translateY(-1px);\n}\n\n.tax-metadata-grid input {\n  border-radius: 0.85rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.7rem 0.9rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  background: linear-gradient(180deg, #ffffff, #f8fafc);\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);\n  color: #0f172a;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.25s ease;\n}\n\n.tax-metadata-grid input:hover {\n  border-color: #cbd5e1;\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06), 0 4px 10px rgba(15, 23, 42, 0.04);\n  background: linear-gradient(180deg, #ffffff, #f1f5f9);\n}\n\n.tax-metadata-grid input::placeholder {\n  color: #94a3b8;\n}\n\n.tax-metadata-grid input:focus,\n.tax-metadata-grid select:focus {\n  outline: none;\n  border-color: #4338ca;\n  box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.15);\n  background: #fff;\n}\n\n.tax-metadata-grid input[readonly],\n.tax-metadata-grid input:disabled,\n.tax-metadata-grid select:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.tax-metadata-grid select {\n  border-radius: 0.85rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  background: #fff;\n}\n\n.tax-email-preview {\n  margin-top: 0.75rem;\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.email-recipient-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.email-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.6rem;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #312e81;\n  font-size: 0.8rem;\n}\n\n.email-recipient-input {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.email-recipient-input input[type=\"email\"] {\n  flex: 1;\n  border-radius: 0.75rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.6rem 0.8rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n\n.email-preview-textarea {\n  width: 100%;\n  min-height: 180px;\n  border-radius: 0.85rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.75rem 0.9rem;\n  font-size: 0.9rem;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  resize: vertical;\n  background: #fff;\n  color: #0f172a;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.create-card {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 2rem;\n  width: min(780px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);\n}\n\n.create-card label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-weight: 600;\n  color: #101828;\n}\n\n.create-card input,\n.create-card select,\n.create-card textarea {\n  max-width: 100%;\n  border-radius: 0.75rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.phone-input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.phone-lada-select {\n  min-width: 88px;\n  flex-shrink: 0;\n}\n\n.phone-number-input {\n  flex: 1;\n}\n\n.upload-field input[type=\"file\"] {\n  border: 1px dashed #cbd5f5;\n  background: #fff;\n  padding: 0.85rem;\n  cursor: pointer;\n}\n\n.upload-list {\n  list-style: none;\n  margin: 0.5rem 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.upload-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f1f5f9;\n  border-radius: 0.65rem;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.85rem;\n}\n\n.upload-list li small {\n  color: #475467;\n}\n\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.form-header h3 {\n  margin: 0;\n}\n\n.form-header p {\n  margin: 0.35rem 0 0;\n  color: #475467;\n}\n\n.create-stepper {\n  display: flex;\n  gap: 0.75rem;\n  font-size: 0.85rem;\n}\n\n.create-stepper .step {\n  flex: 1;\n  padding: 0.6rem 0.75rem;\n  text-align: center;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475467;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n}\n\n.create-stepper .step.active {\n  background: #4f46e5;\n  border-color: #4f46e5;\n  color: white;\n}\n\n.form-section {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 1.25rem;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.info-box {\n  background: #eef2ff;\n  border: 1px dashed #c7d2fe;\n  border-radius: 1rem;\n  padding: 0.85rem 1rem;\n  color: #312e81;\n  font-size: 0.9rem;\n}\n\n.info-box ul {\n  margin: 0.35rem 0 0;\n  padding-left: 1.2rem;\n}\n\n.info-box li {\n  margin-bottom: 0.25rem;\n}\n\n.info-box.notice {\n  background: #ecfccb;\n  border-color: #bef264;\n  color: #365314;\n}\n\n.form-section h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: #0f172a;\n}\n\n.form-grid {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.form-grid.two {\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n\n.form-grid.two > * {\n  min-width: 0;\n}\n\n.full-width {\n  grid-column: 1 / -1;\n}\n\n.search-combobox {\n  position: relative;\n}\n\n.search-combobox input {\n  width: 100%;\n  border-radius: 0.75rem;\n  border: 1px solid #e2e8f0;\n  padding: 0.75rem 1rem;\n  font-family: inherit;\n  font-size: 0.95rem;\n}\n\n.search-combobox.open input {\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  border-color: #c7d2fe;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.combobox-options {\n  position: absolute;\n  top: calc(100% + 2px);\n  width: 100%;\n  max-height: 220px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0.25rem 0;\n  list-style: none;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.15);\n  z-index: 10;\n}\n\n.combobox-options li {\n  padding: 0.55rem 0.85rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.combobox-options li:hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.board,\n.side-panel section {\n  background: white;\n  border-radius: 1.25rem;\n  padding: 1.5rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.section-header > * {\n  min-width: 0;\n}\n\n.section-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.table-filters {\n  margin-top: 1.25rem;\n  padding: 1rem 1.25rem;\n  border: 1px solid #eef2ff;\n  border-radius: 1rem;\n  background: #f8f9ff;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.filter-control {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475467;\n}\n\n.filter-control select,\n.filter-control input {\n  border-radius: 0.75rem;\n  border: 1px solid #e4e7ec;\n  padding: 0.6rem 0.75rem;\n  font-family: inherit;\n  font-size: 0.94rem;\n  background: white;\n}\n\n.search-control {\n  grid-column: span 2;\n}\n\n@media (max-width: 768px) {\n  .search-control {\n    grid-column: span 1;\n  }\n}\n\n.board-table {\n  margin-top: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  position: relative;\n}\n\n.table-head,\n.table-row {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 1rem;\n  font-size: 0.9rem;\n}\n\n.table-head {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.table-row {\n  padding: 1rem 1.25rem;\n  background: #f9fafb;\n  border-radius: 0.85rem;\n  align-items: center;\n}\n\n.table-row > * {\n  min-width: 0;\n}\n\n.board-table .table-row span,\n.board-table .table-row strong {\n  overflow-wrap: anywhere;\n}\n\n.table-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 0.75rem;\n  z-index: 2;\n}\n\n.helper-text {\n  margin: 0.5rem 0 0;\n  font-size: 0.85rem;\n  color: #475467;\n}\n\n.helper-text.folder-url {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  border-radius: 0.85rem;\n  border: 1px solid #f6d9a7;\n  background: #fef7e7;\n  color: #7a4a00;\n  font-weight: 600;\n}\n\n.helper-text.folder-url .folder-url-link {\n  color: #7a4a00;\n  font-weight: 600;\n  text-decoration: underline;\n  overflow-wrap: anywhere;\n}\n\n.helper-text.folder-url .folder-url-label {\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #9a5b00;\n}\n\n.loader {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.loader-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #4f46e5;\n  animation: pulse 1s infinite ease-in-out;\n}\n\n.loader-dot:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.loader-dot:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes pulse {\n  0%, 80%, 100% {\n    opacity: 0.2;\n    transform: translateY(0);\n  }\n  30% {\n    opacity: 1;\n    transform: translateY(-4px);\n  }\n}\n\n.helper-text.error {\n  color: #b42318;\n}\n\n.helper-text.warning {\n  color: #b45309;\n}\n\n.helper-text.success {\n  color: #027a48;\n}\n\n.approved-view {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n}\n\n.approved-view header {\n  margin-bottom: 1rem;\n}\n\n.approved-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.approved-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 1rem 1.5rem;\n  background: #fdfdfd;\n  flex-wrap: wrap;\n}\n\n.approved-card h4 {\n  margin: 0 0 0.35rem;\n}\n\n.approved-card p {\n  margin: 0;\n  color: #475467;\n}\n\n.approved-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.attendance-view {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.attendance-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.attendance-header h2 {\n  margin: 0.25rem 0;\n}\n\n.attendance-header p {\n  margin: 0;\n  color: #475467;\n  max-width: 760px;\n}\n\n.attendance-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.attendance-filters {\n  margin-top: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 1rem;\n}\n\n.attendance-filters .filter-control {\n  flex: 1 1 180px;\n  min-width: 180px;\n}\n\n.attendance-filters .search-control {\n  flex: 2 1 280px;\n}\n\n.attendance-filters .center-filter-group {\n  flex: 1 1 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.attendance-filters .center-filter-group > span {\n  white-space: nowrap;\n}\n\n.attendance-filters .center-filter-options {\n  margin-top: 0;\n  flex: 1 1 auto;\n}\n\n.attendance-export-panel {\n  border: 1px solid #e2e8f0;\n  border-radius: 1.25rem;\n  padding: 1.25rem;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.attendance-export-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.attendance-export-header h3 {\n  margin: 0 0 0.25rem;\n}\n\n.attendance-export-header p {\n  margin: 0;\n  color: #64748b;\n}\n\n.attendance-export-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.attendance-export-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.attendance-export-item {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1.6fr) auto auto;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: 1rem;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.attendance-export-item.ready {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.attendance-export-item.missing {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n\n.attendance-export-check input {\n  width: 18px;\n  height: 18px;\n}\n\n.attendance-export-info strong {\n  display: block;\n}\n\n.attendance-export-info span {\n  display: block;\n  color: #64748b;\n  font-size: 0.85rem;\n}\n\n.attendance-export-status {\n  font-weight: 600;\n  font-size: 0.85rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n}\n\n.attendance-export-status.ready {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #86efac;\n}\n\n.attendance-export-status.missing {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.center-filter-group {\n  align-items: flex-start;\n}\n\n.center-filter-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.35rem;\n}\n\n.center-chip {\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  padding: 0.35rem 0.8rem;\n  background: #ffffff;\n  color: #475467;\n  font-weight: 600;\n  font-size: 0.78rem;\n  cursor: pointer;\n  opacity: 0.55;\n  filter: saturate(0.6);\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease, filter 0.2s ease;\n}\n\n.center-chip.active {\n  border-color: #0f172a;\n  color: #0f172a;\n  background: #e2e8f0;\n  opacity: 1;\n  filter: saturate(1);\n}\n\n.center-chip.center-cuu-ac-servicios-2020-sc {\n  background: #ecfeff;\n  border-color: #67e8f9;\n  color: #0e7490;\n}\n\n.center-chip.center-luz-elena-najera-sanchez {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n  color: #4338ca;\n}\n\n.center-chip.center-argelia-fernandez-de-haro {\n  background: #fef9c3;\n  border-color: #fde047;\n  color: #854d0e;\n}\n\n.attendance-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 0.75rem;\n}\n\n.attendance-summary-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 1rem;\n  padding: 1rem;\n  background: #f8fafc;\n}\n\n.attendance-summary-card h3 {\n  margin: 0.1rem 0 0;\n  font-size: 1.65rem;\n}\n\n.attendance-table-wrap {\n  overflow-x: auto;\n}\n\n.attendance-table {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  min-width: 980px;\n}\n\n.attendance-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.attendance-group-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.95rem;\n  border: 1px solid #e2e8f0;\n  background: #f1f5f9;\n}\n\n.attendance-group-toggle {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid #cbd5f5;\n  background: #ffffff;\n  color: #1e293b;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.attendance-group-info strong {\n  display: block;\n}\n\n.attendance-group-info small {\n  display: block;\n  color: #64748b;\n}\n\n.attendance-group-meta {\n  margin-left: auto;\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  font-size: 0.82rem;\n  color: #475467;\n  font-weight: 600;\n}\n\n.attendance-table-head,\n.attendance-table-row {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.4fr) repeat(7, minmax(90px, 1fr));\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.attendance-table-head {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.72rem;\n  color: #94a3b8;\n  padding: 0 0.25rem;\n}\n\n.attendance-table-row {\n  border: 1px solid #e4e7ec;\n  border-radius: 0.95rem;\n  padding: 0.85rem 1rem;\n  background: #fdfdfd;\n  font-size: 0.9rem;\n}\n\n.attendance-table-row strong {\n  display: block;\n}\n\n.attendance-table-row small {\n  color: #667085;\n  display: block;\n  margin-top: 0.2rem;\n}\n\n.attendance-chip {\n  border-radius: 999px;\n  padding: 0.25rem 0.6rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-align: center;\n  border: 1px solid transparent;\n}\n\n.attendance-chip.state.cerrada {\n  background: #ecfdf3;\n  border-color: #abefc6;\n  color: #067647;\n}\n\n.attendance-chip.state.abierta {\n  background: #eef4ff;\n  border-color: #c7d7fe;\n  color: #3538cd;\n}\n\n.attendance-chip.state.incompleta {\n  background: #fff8e8;\n  border-color: #f9dbaf;\n  color: #b54708;\n}\n\n.attendance-chip.validation.valida {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n  color: #166534;\n}\n\n.attendance-chip.validation.fuera-de-horario,\n.attendance-chip.validation.duplicado,\n.attendance-chip.validation.token-invalido,\n.attendance-chip.validation.usuario-inactivo {\n  background: #fff4ed;\n  border-color: #ffd6ae;\n  color: #c2410c;\n}\n\n.attendance-overlay {\n  align-items: flex-start;\n}\n\n.attendance-missing-modal {\n  background: #ffffff;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  width: min(980px, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.35);\n}\n\n.attendance-modal-badge {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  background: #0f172a;\n  color: #ffffff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n}\n\n.attendance-missing-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 420px;\n  overflow-y: auto;\n  padding-right: 0.25rem;\n}\n\n.attendance-missing-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border-radius: 0.9rem;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.attendance-missing-row.complete {\n  background: #f8fafc;\n}\n\n.attendance-missing-row strong {\n  display: block;\n}\n\n.attendance-missing-row small {\n  color: #64748b;\n}\n\n.attendance-missing-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.attendance-missing-actions select {\n  min-width: 160px;\n}\n\n.attendance-missing-status {\n  font-weight: 600;\n  color: #16a34a;\n}\n\n.attendance-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 1rem;\n  color: #475467;\n}\n\n.whatsapp-preview {\n  width: 100%;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 0.9rem;\n  padding: 0.9rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.whatsapp-bubble {\n  background: white;\n  border-radius: 0.8rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba(17, 94, 89, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: #065f46;\n  font-size: 0.9rem;\n}\n\n.whatsapp-bubble a {\n  color: #15803d;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.whatsapp-bubble em {\n  color: #b45309;\n}\n\n.control-overview {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(165deg, #ffffff 0%, #f9fbff 55%, #f0f5ff 100%);\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  isolation: isolate;\n}\n\n.control-overview::before {\n  content: '';\n  position: absolute;\n  top: -120px;\n  right: -120px;\n  width: 360px;\n  height: 360px;\n  border-radius: 999px;\n  background: radial-gradient(circle, rgba(99, 102, 241, 0.18), rgba(59, 130, 246, 0.02));\n  z-index: -1;\n}\n\n.overview-animate {\n  opacity: 0;\n  transform: translateY(16px);\n  animation: overview-fade-up 520ms cubic-bezier(0.18, 0.7, 0.2, 1) forwards;\n  animation-delay: var(--stagger-delay, 0ms);\n}\n\n@keyframes overview-fade-up {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.control-header h2 {\n  margin: 0.25rem 0;\n}\n\n.control-header p {\n  margin: 0.35rem 0 0;\n  color: #475467;\n  max-width: 720px;\n}\n\n.overview-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));\n  gap: 0.85rem;\n}\n\n.overview-metric-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(4px);\n  padding: 0.95rem 1rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.overview-metric-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.1);\n}\n\n.overview-metric-card .label {\n  margin: 0;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n}\n\n.overview-metric-card strong {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 1.7rem;\n  line-height: 1.05;\n  color: #111827;\n}\n\n.overview-metric-card span {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.88rem;\n  color: #334155;\n}\n\n.overview-metric-card small {\n  display: block;\n  margin-top: 0.4rem;\n  color: #475569;\n  font-size: 0.78rem;\n}\n\n.overview-metric-card.tone-success {\n  border-color: rgba(22, 163, 74, 0.25);\n  background: linear-gradient(135deg, rgba(236, 253, 245, 0.95), rgba(240, 253, 250, 0.75));\n}\n\n.overview-metric-card.tone-warning {\n  border-color: rgba(245, 158, 11, 0.25);\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.95), rgba(255, 247, 237, 0.72));\n}\n\n.overview-metric-card.tone-danger {\n  border-color: rgba(239, 68, 68, 0.28);\n  background: linear-gradient(135deg, rgba(254, 242, 242, 0.95), rgba(254, 226, 226, 0.72));\n}\n\n.overview-table-panel,\n.overview-performance-panel,\n.overview-board-panel {\n  border: 1px solid #e2e8f0;\n  border-radius: 1.15rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.07);\n}\n\n.overview-panel-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.85rem;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.overview-panel-header h3 {\n  margin: 0;\n}\n\n.overview-panel-header p {\n  margin: 0.3rem 0 0;\n  color: #475467;\n  font-size: 0.9rem;\n}\n\n.overview-table-wrap {\n  overflow-x: auto;\n}\n\n.overview-table {\n  width: 100%;\n  min-width: 700px;\n  border-collapse: collapse;\n}\n\n.overview-table th,\n.overview-table td {\n  text-align: left;\n  padding: 0.72rem 0.62rem;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: middle;\n}\n\n.overview-table th {\n  color: #64748b;\n  font-size: 0.76rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.overview-table td {\n  font-size: 0.89rem;\n  color: #1f2937;\n}\n\n.overview-table tbody tr:hover {\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.overview-module-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.overview-module-cell strong {\n  display: block;\n}\n\n.overview-module-cell small {\n  display: block;\n  margin-top: 0.18rem;\n  color: #64748b;\n  font-size: 0.79rem;\n}\n\n.status-dot {\n  width: 0.62rem;\n  height: 0.62rem;\n  border-radius: 999px;\n  box-shadow: 0 0 0 5px rgba(148, 163, 184, 0.16);\n  flex: 0 0 auto;\n}\n\n.status-dot.success {\n  background: #16a34a;\n  box-shadow: 0 0 0 5px rgba(22, 163, 74, 0.18);\n}\n\n.status-dot.warning {\n  background: #f59e0b;\n  box-shadow: 0 0 0 5px rgba(245, 158, 11, 0.18);\n}\n\n.status-dot.danger {\n  background: #ef4444;\n  box-shadow: 0 0 0 5px rgba(239, 68, 68, 0.18);\n}\n\n.status-dot.neutral {\n  background: #64748b;\n  box-shadow: 0 0 0 5px rgba(148, 163, 184, 0.18);\n}\n\n.overview-performance-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 0.85rem;\n}\n\n.overview-performance-item {\n  border: 1px solid #e2e8f0;\n  border-radius: 0.95rem;\n  padding: 0.85rem 0.95rem;\n  background: #fff;\n  animation: overview-fade-up 520ms cubic-bezier(0.18, 0.7, 0.2, 1) forwards;\n  animation-delay: var(--stagger-delay, 0ms);\n  opacity: 0;\n  transform: translateY(16px);\n}\n\n.overview-performance-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n.overview-performance-head strong {\n  color: #0f172a;\n}\n\n.overview-performance-head span {\n  color: #334155;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.overview-performance-item p {\n  margin: 0.45rem 0 0.55rem;\n  color: #64748b;\n  font-size: 0.84rem;\n}\n\n.overview-progress-track {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 0.58rem;\n  border-radius: 999px;\n  background: #e2e8f0;\n}\n\n.overview-progress-fill {\n  display: block;\n  height: 100%;\n  width: 0;\n  border-radius: inherit;\n  animation: overview-progress-grow 700ms ease forwards;\n  animation-delay: 130ms;\n}\n\n@keyframes overview-progress-grow {\n  to {\n    width: var(--progress-width, 0%);\n  }\n}\n\n.overview-progress-fill.tone-success {\n  background: linear-gradient(90deg, #16a34a, #22c55e);\n}\n\n.overview-progress-fill.tone-warning {\n  background: linear-gradient(90deg, #f59e0b, #fbbf24);\n}\n\n.overview-progress-fill.tone-danger {\n  background: linear-gradient(90deg, #ef4444, #fb7185);\n}\n\n.overview-progress-fill.tone-neutral {\n  background: linear-gradient(90deg, #334155, #64748b);\n}\n\n.control-board-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.control-board-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 1.25rem;\n  padding: 1.25rem;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.control-board-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(79, 70, 229, 0.28);\n  box-shadow: 0 18px 35px rgba(79, 70, 229, 0.16);\n}\n\n.control-board-card.disabled {\n  opacity: 0.75;\n  transform: none;\n}\n\n.control-board-card.disabled:hover {\n  transform: none;\n  border-color: #e2e8f0;\n  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);\n}\n\n.control-board-body h3 {\n  margin: 0 0 0.35rem;\n}\n\n.control-board-body p {\n  margin: 0;\n  color: #475467;\n}\n\n.control-board-body ul {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.control-board-body li {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #475467;\n}\n\n.control-board-body li strong {\n  font-size: 1.1rem;\n  color: #111827;\n}\n\n.control-board-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.tax-view {\n  background: white;\n  border-radius: 1.5rem;\n  padding: 1.75rem;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.tax-header h2 {\n  margin: 0.15rem 0;\n}\n\n.tax-header p {\n  margin: 0.35rem 0 0;\n  color: #475467;\n  max-width: 720px;\n}\n\n.tax-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.tax-subtabs {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.tax-controls {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.tax-month-control {\n  flex: 1;\n  min-width: 240px;\n}\n\n.month-selector {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.month-pill {\n  border: 1px solid #d4d4d8;\n  border-radius: 0.65rem;\n  padding: 0.4rem 0.9rem;\n  background: #f8fafc;\n  font-weight: 600;\n  cursor: pointer;\n  color: #0f172a;\n}\n\n.month-pill.active {\n  background: #4f46e5;\n  color: white;\n  border-color: transparent;\n  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.25);\n}\n\n.tax-year-select {\n  min-width: 140px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.tax-year-select select {\n  border: 1px solid #d4d4d8;\n  border-radius: 0.65rem;\n  padding: 0.45rem 0.75rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  background: #fff;\n}\n\n.tax-search {\n  flex: 1;\n  min-width: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.tax-search input {\n  border: 1px solid #d4d4d8;\n  border-radius: 0.65rem;\n  padding: 0.45rem 0.75rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  background: #fff;\n}\n\n.tax-info-toggle {\n  min-width: 180px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.info-toggle {\n  border-radius: 999px;\n  border: 1px dashed #c7d2fe;\n  padding: 0.45rem 1.1rem;\n  font-weight: 600;\n  background: rgba(79, 70, 229, 0.08);\n  color: #4f46e5;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.info-toggle.active {\n  background: #4f46e5;\n  color: #fff;\n  border-color: transparent;\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.3);\n}\n\n.tax-info-toggle small {\n  color: #475467;\n  font-size: 0.78rem;\n}\n\n.tax-summary-card {\n  border-radius: 1rem;\n  padding: 1.25rem;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.tax-summary-card strong {\n  font-size: 2rem;\n}\n\n.tax-summary-card span {\n  color: #475467;\n}\n\n.tax-summary-card.active {\n  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.25);\n  border-color: #4f46e5;\n}\n\n.tax-summary-card.success {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.tax-summary-card.warning {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n\n.tax-summary-card.danger {\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.tax-board-grid {\n  display: grid;\n  grid-template-columns: minmax(240px, 0.8fr) minmax(0, 2fr);\n  gap: 1.5rem;\n}\n\n.tax-upload-grid {\n  grid-template-columns: minmax(0, 1.85fr) minmax(260px, 0.9fr);\n  align-items: flex-start;\n}\n\n.tax-board-grid.info-collapsed {\n  grid-template-columns: 1fr;\n}\n\n.tax-main-panel,\n.tax-side-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.tax-checklist {\n  border: 1px solid #e2e8f0;\n  border-radius: 1.25rem;\n  background: #f8fafc;\n  padding: 1.25rem;\n}\n\n.tax-checklist h3 {\n  margin: 0 0 0.75rem;\n}\n\n.tax-checklist ul {\n  margin: 0;\n  padding-left: 1.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  color: #475467;\n}\n\n.tax-status-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  justify-content: flex-end;\n}\n\n.tax-table-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.tax-table-card {\n  border-radius: 1.25rem;\n  border: 1px solid #e4e7ec;\n  padding: 1.5rem;\n  background: #fff;\n  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.07);\n}\n\n.tax-upload-table-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.tax-upload-table-card .tax-table {\n  flex: 1;\n}\n\n.tax-table-card .section-header p {\n  margin-top: 0.35rem;\n  color: #475467;\n}\n\n.tax-table {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.tax-upload-table {\n  overflow-x: auto;\n  padding-bottom: 0.25rem;\n}\n\n.tax-upload-table .tax-table-head,\n.tax-upload-table .tax-table-row {\n  min-width: 1020px;\n}\n\n.activity-table {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  margin-top: 1rem;\n  padding: 1rem;\n  border-radius: 1.25rem;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.activity-head,\n.activity-row {\n  display: grid;\n  grid-template-columns: var(--activity-grid, 1.4fr repeat(4, minmax(0, 1fr)) 1fr);\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.activity-head {\n  text-transform: uppercase;\n  font-size: 0.72rem;\n  color: #94a3b8;\n  letter-spacing: 0.08em;\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 0.9rem;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #e2e8f0;\n}\n\n.activity-row {\n  background: #fff;\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 1rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);\n  gap: 0.85rem;\n}\n\n.client-cell {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.client-cell strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.client-cell small {\n  color: #94a3b8;\n  font-size: 0.78rem;\n}\n\n.activity-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.activity-cell.disabled-cell {\n  opacity: 0.4;\n}\n\n\n.activity-chip {\n  border: 1px solid #e4e7ec;\n  border-radius: 0.95rem;\n  padding: 0.55rem 0.85rem;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-height: 72px;\n  box-shadow: inset 0 1px 0 rgba(15, 23, 42, 0.02);\n}\n\n.activity-chip strong {\n  font-size: 0.9rem;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activity-chip small {\n  color: #475467;\n  font-size: 0.78rem;\n}\n\n.activity-chip.condensed {\n  min-height: auto;\n  padding: 0.45rem 0.65rem;\n}\n\n.activity-chip.muted {\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n  color: #94a3b8;\n}\n\n.activity-chip.done {\n  background: rgba(22, 163, 74, 0.12);\n  border-color: rgba(22, 163, 74, 0.4);\n  color: #15803d;\n}\n\n.activity-chip.ontrack {\n  background: rgba(34, 197, 94, 0.12);\n  border-color: rgba(34, 197, 94, 0.4);\n  color: #15803d;\n}\n\n.activity-chip.dueSoon {\n  background: rgba(251, 146, 60, 0.15);\n  border-color: rgba(251, 146, 60, 0.4);\n  color: #b45309;\n}\n\n.activity-chip.late {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.45);\n  color: #b91c1c;\n}\n\n.activity-chip.pending {\n  background: rgba(250, 204, 21, 0.18);\n  border-color: rgba(250, 204, 21, 0.4);\n  color: #92400e;\n}\n\n.activity-chip.na {\n  background: rgba(148, 163, 184, 0.18);\n  border-color: rgba(148, 163, 184, 0.35);\n  color: #475467;\n}\n\n.activity-responsable {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  align-items: flex-start;\n}\n\n.activity-responsable strong {\n  color: #0f172a;\n}\n\n.activity-responsable small {\n  color: #94a3b8;\n}\n\n.chip-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.activity-legend-inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  justify-content: flex-end;\n}\n\n.activity-legend-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 999px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  color: #0f172a;\n  font-size: 0.82rem;\n}\n\n.tax-table-head,\n.tax-table-row {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 0.75rem;\n  font-size: 0.9rem;\n}\n\n.tax-table-empty {\n  border: 1px dashed #d4d4d8;\n  border-radius: 1rem;\n  padding: 1rem;\n  text-align: center;\n  background: #fafafa;\n  margin-top: 0.5rem;\n}\n\n.tax-table-head {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.tax-table-row {\n  padding: 0.9rem 1rem;\n  border-radius: 1rem;\n  background: #f9fafb;\n  align-items: center;\n}\n\n.tax-upload-table .tax-table-head,\n.tax-upload-table .tax-table-row {\n  grid-template-columns: 1.5fr 1.25fr 0.9fr 1.2fr 0.5fr 0.95fr 0.7fr 0.45fr;\n}\n\n.tax-upload-row {\n  background: #fff;\n  border: 1px solid #e4e7ec;\n  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.04);\n  border-left: 4px solid transparent;\n}\n\n.tax-upload-row.status-pending { border-left-color: #f97316; }\n.tax-upload-row.status-review { border-left-color: #3b82f6; }\n.tax-upload-row.status-scheduled { border-left-color: #8b5cf6; }\n.tax-upload-row.status-sent { border-left-color: #16a34a; }\n.tax-upload-row.status-rejected { border-left-color: #dc2626; }\n.tax-upload-row.status-waiting { border-left-color: #f59e0b; }\n.tax-upload-row.status-received { border-left-color: #0ea5e9; }\n.tax-upload-row.status-planned { border-left-color: #94a3b8; }\n\n.tax-upload-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.tax-upload-cell strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.tax-upload-cell span {\n  color: #475467;\n  font-size: 0.8rem;\n}\n\n.tax-upload-cell small {\n  color: #94a3b8;\n  font-size: 0.75rem;\n}\n\n.note-preview-cell {\n  min-width: 0;\n}\n\n.note-json-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.5rem 0.9rem;\n}\n\n.note-json-list li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n  font-size: 0.82rem;\n  color: #334155;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.65rem;\n  padding: 0.45rem 0.55rem;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.note-json-list li strong {\n  font-weight: 700;\n  font-size: 0.74rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.note-json-list li span {\n  color: #0f172a;\n}\n\n.note-text.is-clamped {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.note-preview-toggle {\n  align-self: flex-start;\n  font-size: 0.75rem;\n  margin-top: 0.15rem;\n}\n\n.note-preview-cell small {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n@media (max-width: 1200px) {\n  .note-json-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n.note-preview-cell.no-content {\n  min-height: 0;\n}\n\n.tax-upload-cell.responsable-cell {\n  justify-content: center;\n}\n\n.client-pill {\n  border: none;\n  background: #e2e8f0;\n  border-radius: 999px;\n  padding: 0.3rem 0.85rem;\n  cursor: pointer;\n  font: inherit;\n  color: #0f172a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.client-pill strong {\n  font-size: 0.95rem;\n}\n\n.client-pill:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);\n}\n\n.client-pill.accent-a { background: #eef2ff; color: #3730a3; }\n.client-pill.accent-b { background: #ecfccb; color: #365314; }\n.client-pill.accent-c { background: #fee2e2; color: #881337; }\n.client-pill.accent-d { background: #fef3c7; color: #92400e; }\n.client-pill.accent-e { background: #cffafe; color: #115e59; }\n.client-pill.accent-f { background: #ede9fe; color: #5b21b6; }\n\n.service-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 999px;\n  background: rgba(79, 70, 229, 0.08);\n  color: #4338ca;\n  font-size: 0.75rem;\n  margin-top: 0.35rem;\n  font-weight: 600;\n  width: fit-content;\n}\n\n.tax-upload-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.tax-notes-toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tax-status-indicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 0.95rem;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  min-height: 64px;\n}\n\n.tax-status-indicator.ontrack {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.tax-status-indicator.dueSoon {\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n\n.tax-status-indicator.late {\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.tax-status-indicator.default {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n}\n\n.note-icon-button {\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 999px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475467;\n  transition: transform 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.note-icon-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.note-icon-button:hover {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n  color: #4f46e5;\n  transform: translateY(-1px);\n}\n\n.note-icon-button.active {\n  background: rgba(79, 70, 229, 0.15);\n  border-color: #4f46e5;\n  color: #4338ca;\n}\n\n.icon-btn {\n  border: none;\n  background: transparent;\n  padding: 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475467;\n}\n\n.icon-btn.note {\n  border: 1px solid #e4e7ec;\n  border-radius: 999px;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n}\n\n.icon-btn.note svg {\n  width: 14px;\n  height: 14px;\n}\n\n.icon-btn.note:hover {\n  border-color: #4f46e5;\n  color: #4338ca;\n  background: rgba(79, 70, 229, 0.08);\n}\n\n.tax-status-chip {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: inline-flex;\n}\n\n.tax-status-chip.ontrack {\n  background: #15803d;\n  box-shadow: 0 0 0 4px rgba(21, 128, 61, 0.2);\n}\n\n.tax-status-chip.dueSoon {\n  background: #b45309;\n  box-shadow: 0 0 0 4px rgba(180, 83, 9, 0.2);\n}\n\n.tax-status-chip.late {\n  background: #b91c1c;\n  box-shadow: 0 0 0 4px rgba(185, 28, 28, 0.2);\n}\n\n.tax-status-chip.default {\n  background: #94a3b8;\n  box-shadow: 0 0 0 4px rgba(148, 163, 184, 0.2);\n}\n\n.traffic-chip {\n  border-radius: 0.9rem;\n  border: 1px solid #e2e8f0;\n  padding: 0.5rem 0.9rem;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n  min-width: 120px;\n  background: #f8fafc;\n}\n\n.traffic-chip strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.traffic-chip small {\n  color: #475467;\n  font-size: 0.78rem;\n}\n\n.traffic-chip.ontrack {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.traffic-chip.dueSoon {\n  border-color: #fde68a;\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.traffic-chip.late {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.requirement-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 0.35rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.requirement-list li {\n  background: #f1f5f9;\n  border-radius: 0.65rem;\n  padding: 0.15rem 0.6rem;\n  font-size: 0.72rem;\n  color: #475467;\n}\n\n.tax-legend {\n  border-radius: 1.25rem;\n  border: 1px solid #e4e7ec;\n  background: #fff;\n  padding: 1.25rem;\n  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.05);\n}\n\n.tax-legend h3 {\n  margin: 0;\n}\n\n.tax-legend ul {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.tax-legend li {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.status-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.status-dot.pending {\n  background: #f97316;\n}\n\n.status-dot.review {\n  background: #3b82f6;\n}\n\n.status-dot.scheduled {\n  background: #8b5cf6;\n}\n\n.status-dot.sent {\n  background: #16a34a;\n}\n\n.status-dot.rejected {\n  background: #dc2626;\n}\n\n.status-dot.ontrack {\n  background: #16a34a;\n}\n\n.status-dot.pending {\n  background: #f59e0b;\n}\n\n.status-dot.dueSoon {\n  background: #f97316;\n}\n\n.status-dot.late {\n  background: #dc2626;\n}\n\n.status-dot.done {\n  background: #15803d;\n}\n\n.status-dot.na {\n  background: #cbd5e1;\n}\n\n.tax-legend p {\n  margin: 0.1rem 0 0;\n  color: #475467;\n  font-size: 0.85rem;\n}\n\n.chip {\n  border-radius: 999px;\n  padding: 0.35rem 0.9rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.chip.enviada {\n  background: rgba(99, 102, 241, 0.15);\n  color: #4338ca;\n}\n\n.chip.aprobada {\n  background: rgba(34, 197, 94, 0.15);\n  color: #15803d;\n}\n\n.chip.procesada {\n  background: rgba(59, 130, 246, 0.15);\n  color: #1d4ed8;\n}\n\n.chip.pendiente {\n  background: rgba(249, 115, 22, 0.18);\n  color: #c2410c;\n}\n\n.table-row.link-row {\n  text-decoration: none;\n  color: inherit;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.table-row.link-row:hover {\n  background: #eef2ff;\n  box-shadow: 0 12px 24px rgba(79, 70, 229, 0.15);\n  transform: translateY(-2px);\n  cursor: pointer;\n}\n\n.side-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.logs .section-header p {\n  margin: 0.35rem 0 0;\n  color: #475467;\n}\n\n.logs-list {\n  margin-top: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.log-item {\n  border: 1px solid #e4e7ec;\n  border-radius: 1rem;\n  padding: 1.25rem;\n  background: #ffffff;\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.log-item:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.12);\n  transform: translateY(-1px);\n}\n\n.log-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.35rem;\n}\n\n.badge {\n  border-radius: 999px;\n  padding: 0.25rem 0.8rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.badge.ok {\n  background: rgba(34, 197, 94, 0.18);\n  color: #0f9d58;\n}\n\n.badge.error {\n  background: rgba(239, 68, 68, 0.18);\n  color: #b91c1c;\n}\n\n.badge.advertencia {\n  background: rgba(250, 204, 21, 0.3);\n  color: #b45309;\n}\n\n.badge.activo {\n  background: rgba(59, 130, 246, 0.12);\n  color: #1d4ed8;\n}\n\n.log-duration {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475467;\n}\n\n.log-title {\n  margin: 0;\n  font-size: 1rem;\n}\n\n.log-title a {\n  color: #0f172a;\n  text-decoration: none;\n}\n\n.log-title a:hover {\n  text-decoration: underline;\n}\n\n.log-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.log-footer small {\n  margin: 0;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.log-trigger {\n  border-radius: 999px;\n  border: 1px solid rgba(79, 70, 229, 0.2);\n  padding: 0.2rem 0.85rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #4338ca;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  background: rgba(99, 102, 241, 0.08);\n}\n\n.log-item p {\n  margin: 0.35rem 0 0.15rem;\n  color: #475467;\n}\n\n.log-item small {\n  color: #98a2b3;\n}\n\n.log-message {\n  margin: 0;\n  color: #475467;\n  font-size: 0.95rem;\n}\n\n.reminders ul {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.reminders li {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.9rem 1rem;\n  border-radius: 0.9rem;\n  background: #f8fafc;\n}\n\n.badge-set {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  color: #475467;\n}\n\n.link-btn {\n  border: none;\n  background: none;\n  color: #4f46e5;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn:focus-visible,\n.link-btn:focus-visible,\n.summary-card:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n.session-dropdown {\n  position: relative;\n}\n\n.session-trigger {\n  border: 1px solid rgba(79, 70, 229, 0.28);\n  background: rgba(79, 70, 229, 0.08);\n  color: #312e81;\n  border-radius: 999px;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0.55rem 0.65rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.session-trigger:hover,\n.session-trigger.open {\n  transform: translateY(-1px);\n  border-color: rgba(79, 70, 229, 0.45);\n  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.18);\n}\n\n.session-trigger:focus-visible,\n.session-menu-link:focus-visible,\n.session-menu-action:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n.header-icon {\n  width: 1.08rem;\n  height: 1.08rem;\n  flex-shrink: 0;\n}\n\n.session-chevron {\n  width: 0.95rem;\n  height: 0.95rem;\n  transition: transform 0.2s ease;\n}\n\n.session-trigger.open .session-chevron {\n  transform: rotate(180deg);\n}\n\n.session-menu {\n  position: absolute;\n  top: calc(100% + 0.55rem);\n  right: 0;\n  min-width: 260px;\n  max-width: min(320px, calc(100vw - 2rem));\n  padding: 0.55rem;\n  border-radius: 0.95rem;\n  border: 1px solid rgba(79, 70, 229, 0.2);\n  background: #ffffff;\n  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.2);\n  z-index: 40;\n}\n\n.session-menu-email {\n  margin: 0;\n  padding: 0.5rem 0.65rem 0.65rem;\n  border-bottom: 1px solid #eef2ff;\n  color: #10283b;\n  font-size: 0.86rem;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.session-menu-links {\n  margin-top: 0.35rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.session-menu-links:empty {\n  display: none;\n}\n\n.session-menu-link,\n.session-menu-action {\n  width: 100%;\n  border: none;\n  border-radius: 0.7rem;\n  background: transparent;\n  color: #1f3444;\n  text-align: left;\n  font-size: 0.88rem;\n  font-weight: 600;\n  padding: 0.55rem 0.65rem;\n  cursor: pointer;\n}\n\n.session-menu-link:hover,\n.session-menu-action:hover {\n  background: rgba(79, 70, 229, 0.12);\n  color: #312e81;\n}\n\n.session-menu-action {\n  margin-top: 0.35rem;\n}\n\n.header-icon-btn {\n  min-width: 44px;\n  width: 44px;\n  min-height: 44px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header-icon-btn .header-icon {\n  width: 1.15rem;\n  height: 1.15rem;\n}\n\n.header-icon-btn.is-loading .header-icon {\n  animation: header-icon-spin 0.9s linear infinite;\n}\n\n@keyframes header-icon-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.data-pill {\n  padding: 0.35rem 0.9rem;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.data-pill.live {\n  background: rgba(34, 197, 94, 0.2);\n  color: #0f9d58;\n}\n\n.data-pill.mock {\n  background: rgba(59, 130, 246, 0.2);\n  color: #1d4ed8;\n}\n\n@media (max-width: 1200px) {\n  .tax-upload-table .tax-table-head,\n  .tax-upload-table .tax-table-row {\n    min-width: 900px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .activity-table {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .activity-head {\n    display: none;\n  }\n\n  .activity-row {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1.25rem;\n  }\n\n  .activity-row .client-cell {\n    width: 100%;\n    background: #eef2ff;\n    border-radius: 0.95rem;\n    padding: 0.85rem 1rem;\n    border: 1px solid #e0e7ff;\n    box-shadow: inset 0 1px 0 rgba(79, 70, 229, 0.08);\n  }\n\n  .activity-row .client-cell strong {\n    font-size: 1rem;\n  }\n\n  .activity-row .activity-cell {\n    border: 1px solid #e2e8f0;\n    border-radius: 0.9rem;\n    padding: 0.85rem;\n    background: #fff;\n    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);\n  }\n\n  .activity-row .activity-cell.disabled-cell {\n    opacity: 0.65;\n  }\n\n  .activity-row .activity-cell .btn.ghost {\n    width: 100%;\n  }\n\n  .activity-row .activity-chip {\n    min-height: auto;\n  }\n\n  .activity-row .activity-responsable {\n    width: 100%;\n    border-top: 1px dashed #e2e8f0;\n    padding-top: 0.75rem;\n  }\n}\n\n\n@media (max-width: 960px) {\n  .app-header {\n    flex-direction: column;\n  }\n\n  .header-actions {\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .session-menu {\n    right: auto;\n    left: 0;\n  }\n\n  .content-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .filters {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .table-head,\n  .table-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .table-row {\n    font-size: 0.85rem;\n  }\n\n  .create-card {\n    padding: 1.5rem;\n  }\n\n  .login-card {\n    padding: 2rem;\n  }\n\n  .tax-board-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tax-controls {\n    flex-direction: column;\n  }\n\n  .control-board-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .overview-panel-header {\n    flex-direction: column;\n  }\n\n  .overview-table {\n    min-width: 620px;\n  }\n\n  .overview-performance-list {\n    grid-template-columns: 1fr;\n  }\n\n  .attendance-header {\n    flex-direction: column;\n  }\n\n  .attendance-export-item {\n    grid-template-columns: 1fr;\n    align-items: flex-start;\n  }\n\n  .attendance-export-status {\n    justify-self: flex-start;\n  }\n\n  .attendance-export-item .btn {\n    width: 100%;\n  }\n\n  .attendance-missing-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .attendance-missing-actions {\n    width: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .app-shell {\n    padding: 1.75rem 1rem 2.25rem;\n    gap: 1.5rem;\n  }\n\n  .app-header h1 {\n    font-size: 1.65rem;\n  }\n\n  .session-menu {\n    min-width: 210px;\n    max-width: calc(100vw - 2.5rem);\n  }\n\n  .filters {\n    padding: 1rem;\n  }\n\n  .control-overview {\n    padding: 1.15rem;\n    border-radius: 1.2rem;\n  }\n\n  .overview-table-panel,\n  .overview-performance-panel,\n  .overview-board-panel {\n    padding: 0.85rem;\n  }\n\n  .overview-metric-card strong {\n    font-size: 1.4rem;\n  }\n\n  .overlay {\n    padding: 1.5rem 0.75rem;\n  }\n\n  .create-card {\n    width: 100%;\n    padding: 1.25rem;\n    border-radius: 1.25rem;\n  }\n\n  .form-grid.two {\n    grid-template-columns: 1fr;\n  }\n\n  .form-actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .activity-table {\n    padding: 0.25rem;\n  }\n\n  .activity-row {\n    padding: 1rem;\n  }\n\n  .activity-row .activity-cell {\n    padding: 0.65rem 0.75rem;\n  }\n\n  .activity-chip {\n    padding: 0.5rem 0.6rem;\n  }\n\n  .activity-chip strong {\n    font-size: 0.85rem;\n  }\n\n  .activity-chip small {\n    font-size: 0.72rem;\n  }\n\n  .activity-row .client-cell {\n    padding: 0.75rem 0.85rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .tax-upload-table {\n    overflow-x: visible;\n  }\n\n  .tax-upload-table .tax-table-head {\n    display: none;\n  }\n\n  .tax-upload-table .tax-table-row {\n    min-width: 0;\n    grid-template-columns: 1fr;\n    padding: 1.25rem;\n    gap: 0.85rem;\n  }\n\n  .tax-upload-row {\n    gap: 0.85rem;\n  }\n\n  .tax-upload-row > * {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    width: 100%;\n  }\n\n  .tax-upload-row > *:not(.traffic-chip):not(.tax-upload-actions):not(.tax-notes-toggle):not(.note-preview-cell.no-content) {\n    background: #f8fafc;\n    border-radius: 0.85rem;\n    padding: 0.75rem 0.85rem;\n  }\n\n  .tax-upload-row > *::before {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: #94a3b8;\n    margin-bottom: 0.15rem;\n  }\n\n  .tax-upload-row > :nth-child(1)::before { content: 'Cliente'; }\n  .tax-upload-row > :nth-child(2)::before { content: 'Obligación'; }\n  .tax-upload-row > :nth-child(3)::before { content: 'Responsable'; }\n  .tax-upload-row > :nth-child(4)::before { content: 'Requisitos y notas'; }\n  .tax-upload-row > :nth-child(5)::before { content: 'Estado'; }\n  .tax-upload-row > :nth-child(6)::before { content: 'Vence'; }\n  .tax-upload-row > :nth-child(7)::before { content: 'Acción'; }\n  .tax-upload-row > :nth-child(8)::before { content: 'Notas'; }\n\n  .tax-upload-row > :nth-child(5) {\n    align-items: flex-start;\n  }\n\n  .tax-upload-row > :nth-child(6),\n  .traffic-chip {\n    width: 100%;\n  }\n\n  .tax-upload-row > :nth-child(7) {\n    padding: 0;\n  }\n\n  .tax-upload-row > :nth-child(8) {\n    padding: 0;\n  }\n\n  .tax-upload-row > .note-preview-cell.no-content::before {\n    display: none;\n  }\n\n  .tax-upload-row > .tax-upload-actions {\n    align-items: flex-start;\n  }\n\n  .tax-upload-row > .tax-notes-toggle {\n    align-items: flex-start;\n  }\n\n  .tax-upload-actions .btn {\n    width: 100%;\n  }\n\n  .tax-info-toggle {\n    width: 100%;\n  }\n\n.info-toggle {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n/* Corporate Elegant Theme Layer */\n:root {\n  --ci-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;\n  --ci-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;\n  --ci-canvas: #edf2f5;\n  --ci-canvas-deep: #e4ebf0;\n  --ci-surface: #ffffff;\n  --ci-surface-soft: #f8fbfd;\n  --ci-border: #cfdae3;\n  --ci-border-strong: #bccdda;\n  --ci-text: #172a3a;\n  --ci-muted: #5d6f80;\n  --ci-accent: #1f4f68;\n  --ci-accent-strong: #153648;\n  --ci-accent-soft: #d8e7f1;\n  --ci-gold: #b4955e;\n  --ci-success: #1f7a4f;\n  --ci-warning: #ab7a14;\n  --ci-danger: #b24b3e;\n}\n\n:root {\n  font-family: var(--ci-font-body);\n  color: var(--ci-text);\n  background-color: var(--ci-canvas);\n}\n\n::selection {\n  background: rgba(31, 79, 104, 0.2);\n  color: #0f2b3d;\n}\n\nbody {\n  color: var(--ci-text);\n  background:\n    radial-gradient(circle at 8% 7%, rgba(31, 79, 104, 0.11), transparent 45%),\n    radial-gradient(circle at 85% 14%, rgba(180, 149, 94, 0.16), transparent 40%),\n    linear-gradient(180deg, #f2f6f8 0%, #eaf0f4 100%);\n  background-color: var(--ci-canvas);\n}\n\n.auth-shell {\n  background:\n    radial-gradient(circle at 84% 16%, rgba(21, 54, 72, 0.24), transparent 42%),\n    linear-gradient(165deg, rgba(244, 248, 251, 0.98), rgba(229, 237, 242, 0.95)),\n    url('./assets/corporate-ambient.svg') no-repeat top -140px right -160px / 760px auto;\n}\n\n.login-card {\n  border: 1px solid var(--ci-border);\n  background:\n    linear-gradient(165deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 253, 0.96)),\n    url('./assets/corporate-lattice.svg') center/340px 340px;\n}\n\n.app-shell {\n  position: relative;\n  isolation: isolate;\n}\n\n.app-shell::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  min-height: 100%;\n  pointer-events: none;\n  z-index: -2;\n  background:\n    radial-gradient(circle at 88% 14%, rgba(21, 54, 72, 0.14), transparent 42%),\n    url('./assets/corporate-ambient.svg') no-repeat top -130px right clamp(-360px, -14vw, -120px) /\n      clamp(1020px, 118vw, 1720px) auto;\n  opacity: 0.95;\n}\n\n.app-shell::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  min-height: 100%;\n  pointer-events: none;\n  z-index: -1;\n  background:\n    radial-gradient(circle at 6% 85%, rgba(180, 149, 94, 0.13), transparent 42%),\n    radial-gradient(circle at 92% 70%, rgba(31, 79, 104, 0.09), transparent 35%),\n    radial-gradient(circle at 56% 118%, rgba(21, 54, 72, 0.08), transparent 46%);\n}\n\n.app-header {\n  position: relative;\n  border: 1px solid var(--ci-border);\n  border-radius: 1.3rem;\n  padding: 1.2rem 1.35rem;\n  background:\n    linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),\n    url('./assets/corporate-lattice.svg') center/420px 420px;\n  box-shadow: 0 18px 34px rgba(22, 43, 57, 0.12);\n}\n\n.app-header h1,\n.control-header h2,\n.section-header h3,\n.tax-header h2,\n.overview-panel-header h3,\n.form-header h3,\n.approved-view h3 {\n  font-family: var(--ci-font-display);\n  letter-spacing: 0.01em;\n  color: #10283b;\n}\n\n.eyebrow {\n  color: var(--ci-accent);\n}\n\n.subtitle,\n.control-header p,\n.section-header p,\n.overview-panel-header p,\n.helper-text {\n  color: var(--ci-muted);\n}\n\n.header-actions {\n  align-items: center;\n}\n\n.btn {\n  position: relative;\n  overflow: hidden;\n  letter-spacing: 0.01em;\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;\n}\n\n.btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.btn.primary {\n  background: linear-gradient(130deg, var(--ci-accent-strong), var(--ci-accent));\n  color: #f5f9fc;\n  border: 1px solid rgba(18, 51, 71, 0.45);\n  box-shadow: 0 12px 22px rgba(21, 54, 72, 0.3);\n}\n\n.btn.primary::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: url('./assets/corporate-sheen.svg') center/cover no-repeat;\n  opacity: 0.7;\n}\n\n.btn.ghost {\n  background: rgba(255, 255, 255, 0.78);\n  color: var(--ci-accent-strong);\n  border-color: rgba(21, 54, 72, 0.28);\n}\n\n.btn.secondary {\n  background: linear-gradient(145deg, #f2f8fc, #e5eff5);\n  color: var(--ci-accent-strong);\n  border-color: rgba(21, 54, 72, 0.2);\n  box-shadow: 0 9px 16px rgba(18, 51, 71, 0.13);\n}\n\n.view-tabs {\n  padding: 0.28rem;\n  border: 1px solid rgba(21, 54, 72, 0.12);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.68);\n  backdrop-filter: blur(4px);\n  width: fit-content;\n}\n\n.pill {\n  border-color: rgba(21, 54, 72, 0.16);\n  color: #274358;\n  background: rgba(248, 252, 255, 0.72);\n}\n\n.pill.active {\n  border-color: rgba(16, 42, 59, 0.45);\n  background: linear-gradient(130deg, #173a50, #245c78);\n  box-shadow: 0 8px 18px rgba(21, 54, 72, 0.27);\n}\n\n.filters,\n.summary-card,\n.board,\n.side-panel section,\n.approved-view,\n.tax-view,\n.control-overview,\n.tax-summary-card,\n.airtable-modal,\n.automation-upload-card,\n.activity-modal,\n.whatsapp-modal,\n.tax-upload-dialog {\n  border: 1px solid var(--ci-border);\n  background:\n    linear-gradient(160deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),\n    url('./assets/corporate-lattice.svg') center/380px 380px;\n  box-shadow: 0 16px 34px rgba(20, 40, 56, 0.11);\n}\n\n/* Resource coverage across all module views */\n.attendance-view,\n.attendance-export-panel,\n.attendance-group,\n.attendance-missing-modal,\n.notes-modal,\n.tax-main-panel,\n.tax-side-panel,\n.tax-checklist,\n.tax-legend,\n.tax-table-card,\n.tax-upload-table-card,\n.tax-note-summary,\n.create-card,\n.form-section {\n  border: 1px solid rgba(188, 205, 218, 0.62);\n  background:\n    linear-gradient(155deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 252, 0.94)),\n    url('./assets/corporate-lattice.svg') center/360px 360px;\n  box-shadow: 0 14px 28px rgba(20, 40, 56, 0.1);\n}\n\n.approved-card,\n.attendance-summary-card,\n.attendance-missing-row,\n.activity-row,\n.tax-upload-file-list li,\n.whatsapp-bubble,\n.whatsapp-preview,\n.info-box,\n.tax-locked-card,\n.note-summary-raw,\n.tax-note-summary-grid li {\n  border-color: rgba(188, 205, 218, 0.62);\n  background:\n    linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 253, 0.94)),\n    url('./assets/corporate-lattice.svg') center/320px 320px;\n}\n\n.tax-upload-row {\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(246, 250, 252, 0.95)),\n    url('./assets/corporate-lattice.svg') center/320px 320px;\n  box-shadow: 0 12px 25px rgba(18, 51, 71, 0.12);\n}\n\n.summary-card.active {\n  border-color: rgba(21, 54, 72, 0.44);\n  box-shadow: 0 16px 28px rgba(21, 54, 72, 0.26);\n}\n\n.summary-card .label {\n  color: #70859a;\n}\n\n.summary-card span {\n  color: var(--ci-muted);\n}\n\n.table-filters,\n.attendance-filters,\n.tax-status-filters {\n  border-color: var(--ci-border);\n  background: linear-gradient(145deg, #f8fbfd, #eef4f8);\n}\n\n.table-head,\n.attendance-table-head,\n.tax-table-head,\n.overview-table th {\n  color: #70859a;\n}\n\n.table-row,\n.attendance-table-row,\n.tax-table-row {\n  border: 1px solid rgba(188, 205, 218, 0.58);\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 253, 0.95)),\n    url('./assets/corporate-lattice.svg') center/320px 320px;\n}\n\n.table-row.link-row:hover,\n.attendance-table-row:hover,\n.tax-table-row:hover,\n.overview-table tbody tr:hover {\n  background:\n    linear-gradient(145deg, rgba(227, 239, 247, 0.98), rgba(238, 245, 250, 0.96)),\n    url('./assets/corporate-lattice.svg') center/320px 320px;\n  box-shadow: 0 12px 22px rgba(18, 51, 71, 0.16);\n}\n\n.loader-dot {\n  background: var(--ci-accent);\n}\n\n.session-trigger {\n  background: rgba(217, 231, 241, 0.8);\n  border: 1px solid rgba(21, 54, 72, 0.2);\n  color: #153648;\n}\n\n.session-menu {\n  border: 1px solid rgba(21, 54, 72, 0.2);\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(245, 250, 253, 0.96));\n}\n\n.data-pill {\n  border: 1px solid rgba(21, 54, 72, 0.2);\n}\n\n.data-pill.live {\n  background: rgba(18, 128, 86, 0.12);\n  color: #0f6f4a;\n}\n\n.data-pill.mock {\n  background: rgba(180, 149, 94, 0.16);\n  color: #7a5f2d;\n}\n\n.badge.ok {\n  background: rgba(31, 122, 79, 0.16);\n  color: #1f7a4f;\n}\n\n.badge.error {\n  background: rgba(178, 75, 62, 0.16);\n  color: #9f3f32;\n}\n\n.badge.advertencia {\n  background: rgba(171, 122, 20, 0.2);\n  color: #8d6510;\n}\n\n.badge.activo {\n  background: rgba(31, 79, 104, 0.16);\n  color: #184862;\n}\n\n.control-overview::before {\n  background: radial-gradient(circle, rgba(31, 79, 104, 0.2), rgba(31, 79, 104, 0.02));\n}\n\n.overview-table-panel,\n.overview-performance-panel,\n.overview-board-panel {\n  border-color: var(--ci-border);\n  background:\n    linear-gradient(160deg, rgba(255, 255, 255, 0.96), rgba(246, 250, 252, 0.94)),\n    url('./assets/corporate-lattice.svg') center/360px 360px;\n}\n\n.overview-module-cell small,\n.overview-performance-item p {\n  color: var(--ci-muted);\n}\n\n.status-dot.success {\n  background: var(--ci-success);\n  box-shadow: 0 0 0 5px rgba(31, 122, 79, 0.18);\n}\n\n.status-dot.warning {\n  background: var(--ci-warning);\n  box-shadow: 0 0 0 5px rgba(171, 122, 20, 0.2);\n}\n\n.status-dot.danger {\n  background: var(--ci-danger);\n  box-shadow: 0 0 0 5px rgba(178, 75, 62, 0.2);\n}\n\n.overview-progress-fill.tone-success {\n  background: linear-gradient(90deg, #176b46, #2c8f61);\n}\n\n.overview-progress-fill.tone-warning {\n  background: linear-gradient(90deg, #9c6f10, #c5942f);\n}\n\n.overview-progress-fill.tone-danger {\n  background: linear-gradient(90deg, #9d3e32, #c05b4f);\n}\n\n.overview-progress-fill.tone-neutral {\n  background: linear-gradient(90deg, #2f4f64, #4f7188);\n}\n\ninput,\nselect,\ntextarea {\n  border-color: var(--ci-border);\n}\n\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible,\n.btn:focus-visible,\n.pill:focus-visible,\n.link-btn:focus-visible {\n  outline: 2px solid rgba(31, 79, 104, 0.45);\n  outline-offset: 2px;\n}\n\n@keyframes corporate-rise {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.app-header,\n.view-tabs,\n.filters,\n.summary-grid,\n.board,\n.side-panel section,\n.approved-view,\n.tax-view,\n.control-overview {\n  animation: corporate-rise 420ms cubic-bezier(0.2, 0.78, 0.2, 1) both;\n}\n\n.view-tabs {\n  animation-delay: 60ms;\n}\n\n.filters {\n  animation-delay: 110ms;\n}\n\n.summary-grid {\n  animation-delay: 160ms;\n}\n\n@media (max-width: 960px) {\n  .view-tabs {\n    width: 100%;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .app-header {\n    padding: 1rem 1rem 1.1rem;\n  }\n}\n\n/* Dark Mode Overhaul (toggleable) */\n:root[data-theme='dark'] {\n  --ci-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;\n  --ci-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;\n  --ci-canvas: #08121a;\n  --ci-canvas-deep: #0d1a24;\n  --ci-surface: #101c27;\n  --ci-surface-soft: #162535;\n  --ci-border: #284256;\n  --ci-border-strong: #35566d;\n  --ci-text: #e5f0f8;\n  --ci-muted: #9db6c9;\n  --ci-accent: #5da7d8;\n  --ci-accent-strong: #2c6f95;\n  --ci-accent-soft: rgba(102, 169, 211, 0.2);\n  --ci-gold: #cba86b;\n  --ci-success: #4ac78c;\n  --ci-warning: #e2b25f;\n  --ci-danger: #e48679;\n}\n\n:root[data-theme='dark'] ::selection {\n  background: rgba(102, 169, 211, 0.35);\n  color: #f5fbff;\n}\n\n:root[data-theme='dark'] body {\n  color: var(--ci-text);\n  background:\n    radial-gradient(circle at 84% 12%, rgba(93, 167, 216, 0.2), transparent 46%),\n    radial-gradient(circle at 12% 82%, rgba(203, 168, 107, 0.16), transparent 44%),\n    linear-gradient(180deg, #061018 0%, #0b1720 45%, #0c1a24 100%);\n  background-color: var(--ci-canvas);\n}\n\n:root[data-theme='dark'] .auth-shell {\n  background:\n    radial-gradient(circle at 85% 16%, rgba(93, 167, 216, 0.17), transparent 40%),\n    linear-gradient(165deg, rgba(7, 20, 30, 0.98), rgba(9, 24, 36, 0.96)),\n    url('./assets/corporate-ambient-dark.svg') no-repeat top -170px right -170px / 780px auto;\n}\n\n:root[data-theme='dark'] .login-card {\n  color: var(--ci-text);\n  border: 1px solid var(--ci-border);\n  background:\n    linear-gradient(165deg, rgba(15, 28, 40, 0.97), rgba(12, 24, 35, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/360px 360px;\n  box-shadow: 0 28px 56px rgba(2, 8, 14, 0.55);\n}\n\n:root[data-theme='dark'] .login-card input {\n  color: var(--ci-text);\n  background: rgba(8, 18, 27, 0.9);\n  border-color: var(--ci-border);\n}\n\n:root[data-theme='dark'] .auth-footnote strong,\n:root[data-theme='dark'] .form-header h3,\n:root[data-theme='dark'] .control-header h2,\n:root[data-theme='dark'] .section-header h3,\n:root[data-theme='dark'] .tax-header h2,\n:root[data-theme='dark'] .overview-panel-header h3,\n:root[data-theme='dark'] .approved-view h3,\n:root[data-theme='dark'] .app-header h1 {\n  color: #f0f7fc;\n  font-family: var(--ci-font-display);\n}\n\n:root[data-theme='dark'] .auth-footnote,\n:root[data-theme='dark'] .subtitle,\n:root[data-theme='dark'] .control-header p,\n:root[data-theme='dark'] .section-header p,\n:root[data-theme='dark'] .overview-panel-header p,\n:root[data-theme='dark'] .helper-text {\n  color: var(--ci-muted);\n}\n\n:root[data-theme='dark'] .app-shell {\n  position: relative;\n  isolation: isolate;\n}\n\n:root[data-theme='dark'] .app-shell::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  min-height: 100%;\n  pointer-events: none;\n  z-index: -2;\n  background:\n    radial-gradient(circle at 84% 14%, rgba(93, 167, 216, 0.2), transparent 46%),\n    url('./assets/corporate-ambient-dark.svg') no-repeat top -170px right clamp(-390px, -15vw, -140px) /\n      clamp(1080px, 126vw, 1780px) auto;\n  opacity: 0.92;\n}\n\n:root[data-theme='dark'] .app-shell::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  min-height: 100%;\n  pointer-events: none;\n  z-index: -1;\n  background:\n    radial-gradient(circle at 10% 90%, rgba(203, 168, 107, 0.11), transparent 45%),\n    radial-gradient(circle at 96% 72%, rgba(93, 167, 216, 0.14), transparent 38%),\n    radial-gradient(circle at 52% 118%, rgba(23, 54, 72, 0.2), transparent 48%);\n}\n\n:root[data-theme='dark'] .app-header {\n  border: 1px solid var(--ci-border);\n  border-radius: 1.25rem;\n  padding: 1.15rem 1.3rem;\n  background:\n    linear-gradient(135deg, rgba(16, 29, 41, 0.96), rgba(13, 25, 36, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/420px 420px;\n  box-shadow: 0 18px 36px rgba(2, 8, 14, 0.52);\n}\n\n:root[data-theme='dark'] .eyebrow {\n  color: #8fc4e6;\n}\n\n:root[data-theme='dark'] .btn {\n  color: var(--ci-text);\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;\n}\n\n:root[data-theme='dark'] .theme-toggle-corner {\n  border-color: rgba(126, 179, 212, 0.36);\n  background: rgba(9, 24, 35, 0.75);\n  color: #a8d0ea;\n  opacity: 0.24;\n}\n\n:root[data-theme='dark'] .theme-toggle-corner:hover,\n:root[data-theme='dark'] .theme-toggle-corner:focus-visible {\n  opacity: 0.88;\n  border-color: rgba(156, 202, 231, 0.62);\n  box-shadow: 0 10px 20px rgba(4, 12, 19, 0.52);\n}\n\n:root[data-theme='dark'] .btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n:root[data-theme='dark'] .btn.primary {\n  background: linear-gradient(130deg, #1f4f6c, #347ba5);\n  border: 1px solid rgba(122, 188, 231, 0.35);\n  color: #f2f9ff;\n  box-shadow: 0 14px 24px rgba(6, 21, 32, 0.5);\n}\n\n:root[data-theme='dark'] .btn.primary::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: url('./assets/corporate-sheen-dark.svg') center/cover no-repeat;\n  opacity: 0.82;\n}\n\n:root[data-theme='dark'] .btn.ghost {\n  background: rgba(14, 31, 43, 0.85);\n  color: #b4d6eb;\n  border: 1px solid rgba(102, 169, 211, 0.34);\n}\n\n:root[data-theme='dark'] .btn.secondary {\n  background: linear-gradient(145deg, rgba(25, 45, 60, 0.95), rgba(17, 33, 45, 0.93));\n  color: #d6eaf8;\n  border-color: rgba(102, 169, 211, 0.28);\n  box-shadow: 0 10px 18px rgba(4, 13, 20, 0.46);\n}\n\n:root[data-theme='dark'] .view-tabs {\n  padding: 0.32rem;\n  border: 1px solid rgba(102, 169, 211, 0.24);\n  border-radius: 999px;\n  background: rgba(10, 22, 32, 0.82);\n  backdrop-filter: blur(6px);\n  width: fit-content;\n}\n\n:root[data-theme='dark'] .pill {\n  border-color: rgba(102, 169, 211, 0.2);\n  background: rgba(17, 33, 47, 0.92);\n  color: #b8d4e6;\n}\n\n:root[data-theme='dark'] .pill.active {\n  border-color: rgba(176, 214, 238, 0.36);\n  background: linear-gradient(130deg, #225673, #317ca7);\n  color: #f4fbff;\n  box-shadow: 0 10px 18px rgba(6, 20, 30, 0.48);\n}\n\n:root[data-theme='dark'] .filters,\n:root[data-theme='dark'] .summary-card,\n:root[data-theme='dark'] .board,\n:root[data-theme='dark'] .side-panel section,\n:root[data-theme='dark'] .approved-view,\n:root[data-theme='dark'] .tax-view,\n:root[data-theme='dark'] .control-overview,\n:root[data-theme='dark'] .tax-summary-card,\n:root[data-theme='dark'] .airtable-modal,\n:root[data-theme='dark'] .automation-upload-card,\n:root[data-theme='dark'] .activity-modal,\n:root[data-theme='dark'] .whatsapp-modal,\n:root[data-theme='dark'] .tax-upload-dialog {\n  color: var(--ci-text);\n  border: 1px solid var(--ci-border);\n  background:\n    linear-gradient(160deg, rgba(16, 28, 40, 0.97), rgba(12, 24, 35, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/390px 390px;\n  box-shadow: 0 18px 34px rgba(2, 8, 14, 0.5);\n}\n\n/* Resource coverage across all module views (dark) */\n:root[data-theme='dark'] .attendance-view,\n:root[data-theme='dark'] .attendance-export-panel,\n:root[data-theme='dark'] .attendance-group,\n:root[data-theme='dark'] .attendance-missing-modal,\n:root[data-theme='dark'] .notes-modal,\n:root[data-theme='dark'] .tax-main-panel,\n:root[data-theme='dark'] .tax-side-panel,\n:root[data-theme='dark'] .tax-checklist,\n:root[data-theme='dark'] .tax-legend,\n:root[data-theme='dark'] .tax-table-card,\n:root[data-theme='dark'] .tax-upload-table-card,\n:root[data-theme='dark'] .tax-note-summary,\n:root[data-theme='dark'] .create-card,\n:root[data-theme='dark'] .form-section {\n  border: 1px solid rgba(53, 86, 109, 0.76);\n  background:\n    linear-gradient(160deg, rgba(18, 32, 45, 0.97), rgba(12, 24, 35, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/360px 360px;\n  box-shadow: 0 16px 30px rgba(2, 8, 14, 0.52);\n}\n\n:root[data-theme='dark'] .approved-card,\n:root[data-theme='dark'] .attendance-summary-card,\n:root[data-theme='dark'] .attendance-missing-row,\n:root[data-theme='dark'] .activity-row,\n:root[data-theme='dark'] .tax-legacy-upload-card,\n:root[data-theme='dark'] .tax-upload-file-list li,\n:root[data-theme='dark'] .whatsapp-bubble,\n:root[data-theme='dark'] .whatsapp-preview,\n:root[data-theme='dark'] .info-box,\n:root[data-theme='dark'] .tax-locked-card,\n:root[data-theme='dark'] .note-summary-raw,\n:root[data-theme='dark'] .tax-note-summary-grid li {\n  border-color: rgba(53, 86, 109, 0.76);\n  background:\n    linear-gradient(150deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .tax-upload-row {\n  background:\n    linear-gradient(145deg, rgba(19, 35, 49, 0.98), rgba(13, 28, 40, 0.96)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);\n}\n\n:root[data-theme='dark'] .summary-card .label,\n:root[data-theme='dark'] .table-head,\n:root[data-theme='dark'] .attendance-table-head,\n:root[data-theme='dark'] .tax-table-head,\n:root[data-theme='dark'] .tax-legacy-upload-header small,\n:root[data-theme='dark'] .overview-table th {\n  color: #8ea8ba;\n}\n\n:root[data-theme='dark'] .summary-card span,\n:root[data-theme='dark'] .table-row,\n:root[data-theme='dark'] .tax-table-row,\n:root[data-theme='dark'] .attendance-table-row,\n:root[data-theme='dark'] .overview-table td,\n:root[data-theme='dark'] .approved-card p,\n:root[data-theme='dark'] .log-message,\n:root[data-theme='dark'] .log-footer small,\n:root[data-theme='dark'] .form-header p {\n  color: #c7d9e6;\n}\n\n:root[data-theme='dark'] .summary-card.active {\n  border-color: rgba(117, 182, 223, 0.5);\n  box-shadow: 0 16px 28px rgba(7, 24, 37, 0.52);\n}\n\n:root[data-theme='dark'] .table-filters,\n:root[data-theme='dark'] .attendance-filters,\n:root[data-theme='dark'] .tax-status-filters,\n:root[data-theme='dark'] .form-section,\n:root[data-theme='dark'] .create-stepper .step,\n:root[data-theme='dark'] .tax-upload-step {\n  border-color: var(--ci-border);\n  background: linear-gradient(145deg, rgba(14, 29, 41, 0.95), rgba(11, 24, 35, 0.94));\n}\n\n:root[data-theme='dark'] .create-stepper .step.active,\n:root[data-theme='dark'] .tax-upload-step.active {\n  background: linear-gradient(130deg, #225773, #317ca7);\n  border-color: rgba(141, 203, 241, 0.4);\n  color: #f4fbff;\n}\n\n:root[data-theme='dark'] .table-row,\n:root[data-theme='dark'] .tax-table-row,\n:root[data-theme='dark'] .attendance-table-row,\n:root[data-theme='dark'] .approved-card,\n:root[data-theme='dark'] .log-item,\n:root[data-theme='dark'] .tax-note-summary-grid li,\n:root[data-theme='dark'] .note-summary-raw,\n:root[data-theme='dark'] .activity-detail,\n:root[data-theme='dark'] .attendance-summary-card,\n:root[data-theme='dark'] .activity-row .activity-cell,\n:root[data-theme='dark'] .client-pill,\n:root[data-theme='dark'] .tax-table-card,\n:root[data-theme='dark'] .tax-upload-table-card {\n  border: 1px solid rgba(53, 86, 109, 0.7);\n  background:\n    linear-gradient(145deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .table-row.link-row:hover,\n:root[data-theme='dark'] .tax-table-row:hover,\n:root[data-theme='dark'] .attendance-table-row:hover,\n:root[data-theme='dark'] .overview-table tbody tr:hover,\n:root[data-theme='dark'] .control-board-card:hover,\n:root[data-theme='dark'] .log-item:hover {\n  background:\n    linear-gradient(145deg, rgba(28, 50, 68, 0.98), rgba(20, 39, 54, 0.96)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n  box-shadow: 0 14px 24px rgba(4, 13, 20, 0.5);\n}\n\n:root[data-theme='dark'] .table-loading {\n  background: rgba(8, 17, 25, 0.86);\n}\n\n:root[data-theme='dark'] .session-trigger {\n  background: rgba(16, 35, 49, 0.9);\n  border: 1px solid rgba(93, 167, 216, 0.28);\n  color: #d6e8f4;\n}\n\n:root[data-theme='dark'] .session-trigger:hover,\n:root[data-theme='dark'] .session-trigger.open {\n  border-color: rgba(131, 196, 236, 0.54);\n  box-shadow: 0 10px 20px rgba(2, 11, 17, 0.5);\n}\n\n:root[data-theme='dark'] .session-menu {\n  border: 1px solid rgba(70, 125, 160, 0.55);\n  background: linear-gradient(145deg, rgba(14, 28, 40, 0.98), rgba(10, 22, 33, 0.96));\n  box-shadow: 0 16px 34px rgba(1, 8, 13, 0.64);\n}\n\n:root[data-theme='dark'] .session-menu-email {\n  border-bottom-color: rgba(79, 132, 166, 0.38);\n  color: #d6e8f4;\n}\n\n:root[data-theme='dark'] .session-menu-link,\n:root[data-theme='dark'] .session-menu-action {\n  color: #d6e8f4;\n}\n\n:root[data-theme='dark'] .session-menu-link:hover,\n:root[data-theme='dark'] .session-menu-action:hover {\n  background: rgba(93, 167, 216, 0.22);\n  color: #f0f8ff;\n}\n\n:root[data-theme='dark'] .data-pill {\n  border: 1px solid rgba(93, 167, 216, 0.3);\n}\n\n:root[data-theme='dark'] .data-pill.live {\n  background: rgba(74, 199, 140, 0.16);\n  color: #8ce4b7;\n}\n\n:root[data-theme='dark'] .data-pill.mock {\n  background: rgba(203, 168, 107, 0.18);\n  color: #e6c58e;\n}\n\n:root[data-theme='dark'] .badge.ok {\n  background: rgba(74, 199, 140, 0.2);\n  color: #95e7bf;\n}\n\n:root[data-theme='dark'] .badge.error {\n  background: rgba(228, 134, 121, 0.2);\n  color: #f0aba2;\n}\n\n:root[data-theme='dark'] .badge.advertencia {\n  background: rgba(226, 178, 95, 0.24);\n  color: #f4cb85;\n}\n\n:root[data-theme='dark'] .badge.activo {\n  background: rgba(93, 167, 216, 0.24);\n  color: #a9d4ef;\n}\n\n:root[data-theme='dark'] .control-overview::before {\n  background: radial-gradient(circle, rgba(93, 167, 216, 0.22), rgba(93, 167, 216, 0.03));\n}\n\n:root[data-theme='dark'] .overview-table-panel,\n:root[data-theme='dark'] .overview-performance-panel,\n:root[data-theme='dark'] .overview-board-panel {\n  border-color: var(--ci-border);\n  background:\n    linear-gradient(160deg, rgba(17, 31, 44, 0.96), rgba(12, 24, 35, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/360px 360px;\n}\n\n:root[data-theme='dark'] .overview-module-cell small,\n:root[data-theme='dark'] .overview-performance-item p,\n:root[data-theme='dark'] .control-board-body p,\n:root[data-theme='dark'] .attendance-summary-card p {\n  color: var(--ci-muted);\n}\n\n:root[data-theme='dark'] .status-dot.success {\n  background: var(--ci-success);\n  box-shadow: 0 0 0 5px rgba(74, 199, 140, 0.2);\n}\n\n:root[data-theme='dark'] .status-dot.warning {\n  background: var(--ci-warning);\n  box-shadow: 0 0 0 5px rgba(226, 178, 95, 0.24);\n}\n\n:root[data-theme='dark'] .status-dot.danger {\n  background: var(--ci-danger);\n  box-shadow: 0 0 0 5px rgba(228, 134, 121, 0.24);\n}\n\n:root[data-theme='dark'] .status-dot.neutral {\n  background: #7ea5bf;\n  box-shadow: 0 0 0 5px rgba(126, 165, 191, 0.22);\n}\n\n:root[data-theme='dark'] .overview-progress-track {\n  background: #1a3448;\n}\n\n:root[data-theme='dark'] .overview-progress-fill.tone-success {\n  background: linear-gradient(90deg, #2f9f6c, #52c992);\n}\n\n:root[data-theme='dark'] .overview-progress-fill.tone-warning {\n  background: linear-gradient(90deg, #a57729, #e2b25f);\n}\n\n:root[data-theme='dark'] .overview-progress-fill.tone-danger {\n  background: linear-gradient(90deg, #b76054, #e48679);\n}\n\n:root[data-theme='dark'] .overview-progress-fill.tone-neutral {\n  background: linear-gradient(90deg, #487490, #6ca0c2);\n}\n\n:root[data-theme='dark'] .link-btn {\n  color: #8ec5e7;\n}\n\n:root[data-theme='dark'] input,\n:root[data-theme='dark'] select,\n:root[data-theme='dark'] textarea,\n:root[data-theme='dark'] .filter-control select,\n:root[data-theme='dark'] .filter-control input,\n:root[data-theme='dark'] .search-combobox input,\n:root[data-theme='dark'] .login-card input,\n:root[data-theme='dark'] .tax-dropzone,\n:root[data-theme='dark'] .tax-upload-file-list,\n:root[data-theme='dark'] .tax-upload-file-list li {\n  color: #e2eef6;\n  border-color: var(--ci-border);\n  background-color: rgba(9, 20, 30, 0.92);\n}\n\n:root[data-theme='dark'] select option {\n  color: #e2eef6;\n  background: #102131;\n}\n\n:root[data-theme='dark'] input::placeholder,\n:root[data-theme='dark'] textarea::placeholder {\n  color: #7f9ab0;\n}\n\n:root[data-theme='dark'] .info-box,\n:root[data-theme='dark'] .tax-locked-card,\n:root[data-theme='dark'] .whatsapp-preview,\n:root[data-theme='dark'] .whatsapp-bubble,\n:root[data-theme='dark'] .note-summary-raw,\n:root[data-theme='dark'] .helper-text.folder-url {\n  border-color: rgba(203, 168, 107, 0.4);\n  background: linear-gradient(145deg, rgba(46, 38, 23, 0.9), rgba(37, 30, 18, 0.88));\n  color: #f3d8ab;\n}\n\n:root[data-theme='dark'] .info-box.notice {\n  border-color: rgba(74, 199, 140, 0.36);\n  background: linear-gradient(145deg, rgba(19, 52, 40, 0.9), rgba(14, 43, 33, 0.88));\n  color: #9de6c2;\n}\n\n:root[data-theme='dark'] .combobox-options {\n  background: #122332;\n  border-color: var(--ci-border);\n}\n\n:root[data-theme='dark'] .combobox-options li {\n  color: #d7e7f2;\n}\n\n:root[data-theme='dark'] .combobox-options li:hover {\n  background: rgba(93, 167, 216, 0.2);\n  color: #eff8ff;\n}\n\n:root[data-theme='dark'] .loader-dot {\n  background: #6eb4df;\n}\n\n:root[data-theme='dark'] .btn:focus-visible,\n:root[data-theme='dark'] .link-btn:focus-visible,\n:root[data-theme='dark'] .summary-card:focus-visible,\n:root[data-theme='dark'] .pill:focus-visible,\n:root[data-theme='dark'] input:focus-visible,\n:root[data-theme='dark'] select:focus-visible,\n:root[data-theme='dark'] textarea:focus-visible {\n  outline: 2px solid rgba(118, 189, 233, 0.65);\n  outline-offset: 2px;\n}\n\n/* Dark mode contrast hardening across all views */\n:root[data-theme='dark'] .control-board-body h3,\n:root[data-theme='dark'] .control-board-body li strong,\n:root[data-theme='dark'] .overview-module-cell strong,\n:root[data-theme='dark'] .overview-performance-head strong,\n:root[data-theme='dark'] .overview-performance-head span,\n:root[data-theme='dark'] .approved-card h4,\n:root[data-theme='dark'] .attendance-group-info strong,\n:root[data-theme='dark'] .attendance-table-row strong,\n:root[data-theme='dark'] .attendance-modal-badge,\n:root[data-theme='dark'] .tax-upload-cell strong,\n:root[data-theme='dark'] .activity-chip strong,\n:root[data-theme='dark'] .activity-responsable strong,\n:root[data-theme='dark'] .tax-checklist h3,\n:root[data-theme='dark'] .tax-legend h3,\n:root[data-theme='dark'] .traffic-chip strong,\n:root[data-theme='dark'] .note-json-list li span,\n:root[data-theme='dark'] .tax-upload-step-panel-header h4,\n:root[data-theme='dark'] .tax-year-select label,\n:root[data-theme='dark'] .tax-search label {\n  color: #ecf6fd;\n}\n\n:root[data-theme='dark'] .control-board-body p,\n:root[data-theme='dark'] .control-board-body li,\n:root[data-theme='dark'] .approved-card p,\n:root[data-theme='dark'] .attendance-table-row small,\n:root[data-theme='dark'] .attendance-group-info small,\n:root[data-theme='dark'] .attendance-group-meta,\n:root[data-theme='dark'] .tax-upload-cell span,\n:root[data-theme='dark'] .tax-upload-cell small,\n:root[data-theme='dark'] .activity-chip small,\n:root[data-theme='dark'] .activity-responsable small,\n:root[data-theme='dark'] .tax-checklist ul,\n:root[data-theme='dark'] .note-json-list li,\n:root[data-theme='dark'] .note-json-list li strong,\n:root[data-theme='dark'] .tax-upload-row > *::before,\n:root[data-theme='dark'] .tax-table-empty,\n:root[data-theme='dark'] .tax-table-card .section-header p,\n:root[data-theme='dark'] .attendance-header p,\n:root[data-theme='dark'] .attendance-export-info span {\n  color: #b6ccdc;\n}\n\n:root[data-theme='dark'] .log-title a {\n  color: #eaf5fd;\n}\n\n:root[data-theme='dark'] .month-pill {\n  border-color: rgba(98, 150, 182, 0.42);\n  background: rgba(15, 30, 42, 0.88);\n  color: #cde3f2;\n}\n\n:root[data-theme='dark'] .month-pill.active {\n  border-color: rgba(149, 207, 244, 0.46);\n  background: linear-gradient(130deg, #255d7c, #3b86b0);\n  color: #f5fbff;\n}\n\n:root[data-theme='dark'] .tax-year-select select,\n:root[data-theme='dark'] .tax-search input,\n:root[data-theme='dark'] .attendance-group-toggle {\n  background: rgba(10, 22, 32, 0.92);\n  border-color: rgba(74, 119, 148, 0.64);\n  color: #d8eaf5;\n}\n\n:root[data-theme='dark'] .tax-status-indicator,\n:root[data-theme='dark'] .traffic-chip,\n:root[data-theme='dark'] .note-icon-button,\n:root[data-theme='dark'] .icon-btn.note {\n  border-color: rgba(53, 86, 109, 0.72);\n  background: linear-gradient(145deg, rgba(18, 33, 46, 0.96), rgba(12, 26, 37, 0.93));\n  color: #c6dcec;\n}\n\n:root[data-theme='dark'] .tax-status-indicator.ontrack,\n:root[data-theme='dark'] .traffic-chip.ontrack {\n  border-color: rgba(74, 199, 140, 0.46);\n  background: rgba(34, 95, 69, 0.45);\n}\n\n:root[data-theme='dark'] .tax-status-indicator.dueSoon,\n:root[data-theme='dark'] .traffic-chip.dueSoon {\n  border-color: rgba(226, 178, 95, 0.48);\n  background: rgba(108, 78, 23, 0.45);\n}\n\n:root[data-theme='dark'] .tax-status-indicator.late,\n:root[data-theme='dark'] .traffic-chip.late {\n  border-color: rgba(228, 134, 121, 0.5);\n  background: rgba(104, 42, 35, 0.48);\n}\n\n:root[data-theme='dark'] .tax-status-indicator.default,\n:root[data-theme='dark'] .traffic-chip.default {\n  border-color: rgba(126, 165, 191, 0.42);\n  background: rgba(34, 57, 74, 0.48);\n}\n\n:root[data-theme='dark'] .service-pill {\n  background: rgba(68, 138, 184, 0.22);\n  color: #b8ddf3;\n}\n\n:root[data-theme='dark'] .client-pill {\n  background: rgba(30, 51, 67, 0.92);\n  color: #d4e7f3;\n  border: 1px solid rgba(74, 119, 148, 0.58);\n}\n\n:root[data-theme='dark'] .client-pill.accent-a,\n:root[data-theme='dark'] .client-pill.accent-b,\n:root[data-theme='dark'] .client-pill.accent-c,\n:root[data-theme='dark'] .client-pill.accent-d,\n:root[data-theme='dark'] .client-pill.accent-e,\n:root[data-theme='dark'] .client-pill.accent-f {\n  color: #d4e7f3;\n}\n\n:root[data-theme='dark'] .client-pill.accent-a { background: rgba(46, 75, 106, 0.85); }\n:root[data-theme='dark'] .client-pill.accent-b { background: rgba(41, 79, 67, 0.85); }\n:root[data-theme='dark'] .client-pill.accent-c { background: rgba(96, 50, 60, 0.85); }\n:root[data-theme='dark'] .client-pill.accent-d { background: rgba(97, 72, 39, 0.85); }\n:root[data-theme='dark'] .client-pill.accent-e { background: rgba(38, 86, 94, 0.85); }\n:root[data-theme='dark'] .client-pill.accent-f { background: rgba(65, 56, 107, 0.85); }\n\n:root[data-theme='dark'] .note-icon-button:hover,\n:root[data-theme='dark'] .icon-btn.note:hover {\n  border-color: rgba(132, 188, 223, 0.6);\n  color: #d9eefb;\n  background: rgba(66, 121, 157, 0.34);\n}\n\n/* Dark mode contrast hardening v2 (overview + attendance) */\n:root[data-theme='dark'] .btn:not(.primary):not(.ghost):not(.secondary) {\n  border: 1px solid rgba(108, 170, 207, 0.42);\n  background: linear-gradient(132deg, rgba(37, 78, 106, 0.92), rgba(25, 54, 74, 0.94));\n  color: #e9f6ff;\n  box-shadow: 0 10px 18px rgba(4, 13, 20, 0.42);\n}\n\n:root[data-theme='dark'] .btn:not(.primary):not(.ghost):not(.secondary):hover:not(:disabled) {\n  border-color: rgba(145, 205, 240, 0.56);\n  background: linear-gradient(132deg, rgba(46, 93, 124, 0.94), rgba(31, 67, 91, 0.96));\n}\n\n:root[data-theme='dark'] .overview-metric-card,\n:root[data-theme='dark'] .overview-performance-item,\n:root[data-theme='dark'] .control-board-card,\n:root[data-theme='dark'] .attendance-export-item,\n:root[data-theme='dark'] .attendance-group-header {\n  border: 1px solid rgba(58, 96, 123, 0.78);\n  background:\n    linear-gradient(150deg, rgba(18, 34, 47, 0.98), rgba(12, 26, 37, 0.96)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);\n}\n\n:root[data-theme='dark'] .overview-metric-card .label {\n  color: #a7c2d5;\n}\n\n:root[data-theme='dark'] .overview-metric-card strong {\n  color: #f2f9ff;\n}\n\n:root[data-theme='dark'] .overview-metric-card span {\n  color: #d5e7f3;\n}\n\n:root[data-theme='dark'] .overview-metric-card small {\n  color: #bfd5e4;\n}\n\n:root[data-theme='dark'] .overview-metric-card.tone-success {\n  border-color: rgba(74, 199, 140, 0.5);\n  background:\n    linear-gradient(145deg, rgba(18, 59, 44, 0.9), rgba(15, 38, 30, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .overview-metric-card.tone-warning {\n  border-color: rgba(226, 178, 95, 0.54);\n  background:\n    linear-gradient(145deg, rgba(77, 57, 20, 0.88), rgba(48, 35, 14, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .overview-metric-card.tone-danger {\n  border-color: rgba(228, 134, 121, 0.56);\n  background:\n    linear-gradient(145deg, rgba(86, 38, 37, 0.88), rgba(49, 22, 24, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .overview-performance-head strong,\n:root[data-theme='dark'] .overview-performance-head span,\n:root[data-theme='dark'] .attendance-export-info strong,\n:root[data-theme='dark'] .attendance-group-info strong {\n  color: #eef8ff;\n}\n\n:root[data-theme='dark'] .control-board-card.disabled {\n  opacity: 0.78;\n  border-color: rgba(59, 91, 115, 0.62);\n  background:\n    linear-gradient(145deg, rgba(17, 29, 40, 0.96), rgba(12, 23, 33, 0.94)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .control-board-card.disabled:hover {\n  border-color: rgba(59, 91, 115, 0.62);\n  box-shadow: 0 12px 24px rgba(4, 13, 20, 0.5);\n}\n\n:root[data-theme='dark'] .attendance-export-item.ready {\n  border-color: rgba(74, 199, 140, 0.5);\n  background: linear-gradient(145deg, rgba(22, 67, 49, 0.88), rgba(15, 40, 31, 0.94));\n}\n\n:root[data-theme='dark'] .attendance-export-item.missing {\n  border-color: rgba(226, 178, 95, 0.52);\n  background: linear-gradient(145deg, rgba(91, 64, 20, 0.88), rgba(50, 36, 14, 0.94));\n}\n\n:root[data-theme='dark'] .attendance-export-status {\n  border-color: rgba(89, 138, 170, 0.55);\n  background: rgba(20, 44, 61, 0.8);\n  color: #d5e8f5;\n}\n\n:root[data-theme='dark'] .attendance-export-status.ready {\n  border-color: rgba(86, 214, 158, 0.58);\n  background: rgba(32, 92, 65, 0.58);\n  color: #c3f3dc;\n}\n\n:root[data-theme='dark'] .attendance-export-status.missing {\n  border-color: rgba(230, 182, 95, 0.58);\n  background: rgba(106, 77, 26, 0.6);\n  color: #ffe0a4;\n}\n\n:root[data-theme='dark'] .attendance-export-check input {\n  accent-color: #5da7d8;\n  background-color: #102131;\n  border-color: rgba(95, 151, 186, 0.6);\n}\n\n:root[data-theme='dark'] .attendance-group .attendance-table-row {\n  border-color: rgba(58, 96, 123, 0.74);\n  background:\n    linear-gradient(145deg, rgba(19, 35, 49, 0.97), rgba(13, 28, 40, 0.95)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .attendance-group .attendance-table-row:hover {\n  background:\n    linear-gradient(145deg, rgba(28, 50, 68, 0.98), rgba(20, 39, 54, 0.96)),\n    url('./assets/corporate-lattice-dark.svg') center/320px 320px;\n}\n\n:root[data-theme='dark'] .attendance-chip {\n  border-color: rgba(73, 116, 144, 0.62);\n  background: rgba(22, 44, 61, 0.72);\n  color: #dbeaf4;\n}\n\n:root[data-theme='dark'] .attendance-chip.state.cerrada,\n:root[data-theme='dark'] .attendance-chip.validation.valida {\n  border-color: rgba(74, 199, 140, 0.58);\n  background: rgba(32, 92, 65, 0.58);\n  color: #b9efcf;\n}\n\n:root[data-theme='dark'] .attendance-chip.state.abierta {\n  border-color: rgba(122, 172, 212, 0.6);\n  background: rgba(46, 84, 117, 0.62);\n  color: #cce7fa;\n}\n\n:root[data-theme='dark'] .attendance-chip.state.incompleta {\n  border-color: rgba(226, 178, 95, 0.62);\n  background: rgba(106, 77, 26, 0.62);\n  color: #ffe0a4;\n}\n\n:root[data-theme='dark'] .attendance-chip.validation.fuera-de-horario,\n:root[data-theme='dark'] .attendance-chip.validation.duplicado,\n:root[data-theme='dark'] .attendance-chip.validation.token-invalido,\n:root[data-theme='dark'] .attendance-chip.validation.usuario-inactivo {\n  border-color: rgba(228, 134, 121, 0.62);\n  background: rgba(104, 42, 35, 0.64);\n  color: #ffd0c8;\n}\n\n:root[data-theme='dark'] .center-chip {\n  border-color: rgba(69, 108, 134, 0.72);\n  background: rgba(12, 25, 36, 0.9);\n  color: #c4daea;\n  opacity: 0.78;\n  filter: none;\n}\n\n:root[data-theme='dark'] .center-chip.active {\n  border-color: rgba(152, 214, 245, 0.48);\n  background: linear-gradient(130deg, #255d7c, #367ca3);\n  color: #f4fbff;\n  opacity: 1;\n}\n\n:root[data-theme='dark'] .center-chip.center-cuu-ac-servicios-2020-sc {\n  background: rgba(34, 92, 114, 0.68);\n  border-color: rgba(110, 203, 228, 0.56);\n  color: #d0f2fa;\n}\n\n:root[data-theme='dark'] .center-chip.center-luz-elena-najera-sanchez {\n  background: rgba(54, 68, 130, 0.68);\n  border-color: rgba(150, 169, 240, 0.6);\n  color: #dce4ff;\n}\n\n:root[data-theme='dark'] .center-chip.center-argelia-fernandez-de-haro {\n  background: rgba(98, 74, 31, 0.68);\n  border-color: rgba(232, 197, 110, 0.58);\n  color: #ffebc1;\n}\n\n.db-shortcuts-panel {\n  margin-top: 1rem;\n  border: 1px solid rgba(58, 93, 117, 0.22);\n  border-radius: 18px;\n  padding: 1rem 1.1rem;\n  background: linear-gradient(135deg, rgba(242, 248, 252, 0.95), rgba(229, 240, 247, 0.9));\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.db-shortcuts-view {\n  margin-top: 0.9rem;\n}\n\n.db-shortcuts-panel h3 {\n  margin: 0.2rem 0 0.25rem;\n}\n\n.db-shortcuts-panel p {\n  margin: 0;\n}\n\n.db-shortcuts-actions {\n  display: flex;\n  gap: 0.65rem;\n  flex-wrap: wrap;\n}\n\n.locations-panel {\n  margin-bottom: 1rem;\n  border: 1px solid rgba(58, 93, 117, 0.22);\n  border-radius: 20px;\n  padding: 1rem 1.1rem;\n  background: linear-gradient(145deg, rgba(246, 250, 253, 0.95), rgba(236, 245, 251, 0.92));\n}\n\n.locations-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.8rem;\n  flex-wrap: wrap;\n}\n\n.locations-header h3 {\n  margin: 0.2rem 0 0.3rem;\n}\n\n.locations-header p {\n  margin: 0;\n}\n\n.locations-form-grid {\n  margin-top: 0.9rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.7rem;\n}\n\n.locations-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex-wrap: wrap;\n}\n\n.locations-visibility-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.locations-visibility-toggle::before {\n  content: '';\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: rgba(76, 99, 115, 0.8);\n  box-shadow: 0 0 0 1px rgba(54, 75, 92, 0.2);\n  transition: background 0.25s ease, box-shadow 0.25s ease;\n}\n\n.locations-visibility-toggle.active::before {\n  background: rgba(39, 151, 91, 0.9);\n  box-shadow: 0 0 0 4px rgba(39, 151, 91, 0.16);\n  animation: locations-status-pulse 1.65s ease-in-out infinite;\n}\n\n.locations-collapsed-note {\n  margin-top: 0.6rem;\n}\n\n.locations-collapsible {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.42s cubic-bezier(0.2, 0.85, 0.22, 1);\n}\n\n.locations-collapsible.is-open {\n  grid-template-rows: 1fr;\n}\n\n.locations-collapsible-inner {\n  min-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(-8px);\n  transition: opacity 0.26s ease, transform 0.42s cubic-bezier(0.2, 0.85, 0.22, 1);\n}\n\n.locations-collapsible.is-open .locations-collapsible-inner {\n  opacity: 1;\n  transform: translateY(0);\n  visibility: visible;\n}\n\n.locations-collapsible.is-closed .locations-collapsible-inner {\n  pointer-events: none;\n  visibility: hidden;\n}\n\n@keyframes locations-status-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 4px rgba(39, 151, 91, 0.16);\n  }\n  50% {\n    box-shadow: 0 0 0 7px rgba(39, 151, 91, 0.08);\n  }\n}\n\n.locations-search {\n  grid-column: 1 / -1;\n}\n\n.locations-maps-url {\n  grid-column: 1 / -1;\n}\n\n.locations-maps-url-primary {\n  border: 1px solid rgba(31, 106, 158, 0.2);\n  border-radius: 16px;\n  background: rgba(228, 243, 252, 0.54);\n  padding: 0.78rem;\n}\n\n.locations-maps-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.locations-maps-header label {\n  margin: 0;\n  font-weight: 700;\n}\n\n.locations-maps-url label {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.locations-maps-url-row {\n  display: flex;\n  gap: 0.55rem;\n  align-items: center;\n}\n\n.locations-maps-url-row input[type='text'] {\n  flex: 1;\n}\n\n.locations-search label {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.locations-search-row {\n  display: flex;\n  gap: 0.55rem;\n  align-items: center;\n}\n\n.locations-search-row input[type='search'] {\n  flex: 1;\n}\n\n.locations-form-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.36rem;\n  color: #1f455d;\n  font-weight: 620;\n}\n\n.locations-maps-url-row input[type='text'],\n.locations-search-row input[type='search'],\n.locations-form-grid input:not([type='checkbox']),\n.locations-form-grid textarea {\n  width: 100%;\n  min-height: 2.7rem;\n  border: 1px solid rgba(56, 90, 111, 0.28);\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(245, 250, 254, 0.98));\n  color: #153245;\n  padding: 0.62rem 0.78rem;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82), 0 1px 2px rgba(20, 56, 78, 0.08);\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    background 0.2s ease;\n}\n\n.locations-form-grid input[type='number'] {\n  font-variant-numeric: tabular-nums;\n}\n\n.locations-form-grid textarea {\n  min-height: 88px;\n  line-height: 1.45;\n}\n\n.locations-maps-url-row input[type='text']::placeholder,\n.locations-search-row input[type='search']::placeholder,\n.locations-form-grid input:not([type='checkbox'])::placeholder,\n.locations-form-grid textarea::placeholder {\n  color: rgba(66, 101, 123, 0.78);\n}\n\n.locations-maps-url-row input[type='text']:hover:not(:disabled),\n.locations-search-row input[type='search']:hover:not(:disabled),\n.locations-form-grid input:not([type='checkbox']):hover:not(:disabled),\n.locations-form-grid textarea:hover:not(:disabled) {\n  border-color: rgba(36, 100, 140, 0.42);\n}\n\n.locations-maps-url-row input[type='text']:focus-visible,\n.locations-search-row input[type='search']:focus-visible,\n.locations-form-grid input:not([type='checkbox']):focus-visible,\n.locations-form-grid textarea:focus-visible {\n  outline: none;\n  border-color: rgba(25, 117, 185, 0.72);\n  box-shadow: 0 0 0 3px rgba(25, 117, 185, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.92);\n}\n\n.locations-maps-url-row input[type='text']:disabled,\n.locations-search-row input[type='search']:disabled,\n.locations-form-grid input:not([type='checkbox']):disabled,\n.locations-form-grid textarea:disabled {\n  cursor: not-allowed;\n  border-color: rgba(88, 116, 136, 0.24);\n  background: rgba(236, 244, 250, 0.86);\n  color: rgba(54, 80, 97, 0.74);\n  box-shadow: none;\n}\n\n.locations-suggestions {\n  margin-top: 0.45rem;\n  border: 1px solid rgba(63, 95, 117, 0.18);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.88);\n  overflow: hidden;\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.locations-suggestion {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0.58rem 0.68rem;\n  text-align: left;\n  cursor: pointer;\n  display: grid;\n  gap: 0.2rem;\n}\n\n.locations-suggestion + .locations-suggestion {\n  border-top: 1px solid rgba(63, 95, 117, 0.14);\n}\n\n.locations-suggestion:hover {\n  background: rgba(99, 163, 214, 0.13);\n}\n\n.locations-suggestion:focus-visible {\n  outline: 2px solid rgba(25, 117, 185, 0.65);\n  outline-offset: -2px;\n}\n\n.locations-suggestion-title {\n  font-weight: 600;\n}\n\n.locations-suggestion-subtitle {\n  font-size: 0.89rem;\n  opacity: 0.9;\n}\n\n.locations-suggestion-coords {\n  font-size: 0.78rem;\n  opacity: 0.75;\n}\n\n.locations-notes {\n  grid-column: 1 / -1;\n}\n\n.locations-form-grid textarea {\n  width: 100%;\n  resize: vertical;\n  min-height: 70px;\n}\n\n.checkbox-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.locations-form-actions {\n  grid-column: 1 / -1;\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.locations-table-wrap {\n  margin-top: 0.9rem;\n  overflow-x: auto;\n}\n\n.locations-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 680px;\n}\n\n.locations-table th,\n.locations-table td {\n  text-align: left;\n  padding: 0.55rem 0.65rem;\n  border-bottom: 1px solid rgba(63, 95, 117, 0.16);\n}\n\n.locations-actions {\n  display: flex;\n  gap: 0.45rem;\n}\n\n:root[data-theme='dark'] .db-shortcuts-panel {\n  border-color: rgba(78, 122, 151, 0.5);\n  background: linear-gradient(145deg, rgba(18, 37, 52, 0.95), rgba(12, 29, 41, 0.93));\n}\n\n:root[data-theme='dark'] .db-shortcuts-panel h3,\n:root[data-theme='dark'] .locations-header h3 {\n  color: #ebf6ff;\n}\n\n:root[data-theme='dark'] .db-shortcuts-panel p,\n:root[data-theme='dark'] .locations-header p {\n  color: #c3d9e9;\n}\n\n:root[data-theme='dark'] .locations-panel {\n  border-color: rgba(78, 122, 151, 0.5);\n  background: linear-gradient(145deg, rgba(18, 37, 52, 0.95), rgba(12, 29, 41, 0.93));\n}\n\n:root[data-theme='dark'] .locations-panel label,\n:root[data-theme='dark'] .locations-panel .checkbox-inline span {\n  color: #d6e8f5;\n}\n\n:root[data-theme='dark'] .locations-form-grid label {\n  color: #d8e9f6;\n}\n\n:root[data-theme='dark'] .locations-visibility-toggle::before {\n  background: rgba(133, 160, 180, 0.82);\n  box-shadow: 0 0 0 1px rgba(84, 118, 142, 0.45);\n}\n\n:root[data-theme='dark'] .locations-visibility-toggle.active::before {\n  background: rgba(69, 210, 132, 0.92);\n  box-shadow: 0 0 0 4px rgba(69, 210, 132, 0.2);\n}\n\n:root[data-theme='dark'] .locations-maps-url-primary {\n  border-color: rgba(104, 173, 216, 0.36);\n  background: rgba(11, 31, 45, 0.88);\n}\n\n:root[data-theme='dark'] .locations-maps-url-row input[type='text'],\n:root[data-theme='dark'] .locations-search-row input[type='search'],\n:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']),\n:root[data-theme='dark'] .locations-form-grid textarea {\n  border-color: rgba(110, 156, 186, 0.42);\n  background: linear-gradient(180deg, rgba(8, 21, 31, 0.96), rgba(10, 26, 37, 0.94));\n  color: #e9f5fd;\n  box-shadow: inset 0 1px 0 rgba(146, 189, 214, 0.12), 0 1px 2px rgba(0, 0, 0, 0.22);\n}\n\n:root[data-theme='dark'] .locations-maps-url-row input[type='text']::placeholder,\n:root[data-theme='dark'] .locations-search-row input[type='search']::placeholder,\n:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox'])::placeholder,\n:root[data-theme='dark'] .locations-form-grid textarea::placeholder {\n  color: rgba(176, 206, 226, 0.74);\n}\n\n:root[data-theme='dark'] .locations-maps-url-row input[type='text']:hover:not(:disabled),\n:root[data-theme='dark'] .locations-search-row input[type='search']:hover:not(:disabled),\n:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):hover:not(:disabled),\n:root[data-theme='dark'] .locations-form-grid textarea:hover:not(:disabled) {\n  border-color: rgba(128, 191, 226, 0.58);\n}\n\n:root[data-theme='dark'] .locations-maps-url-row input[type='text']:focus-visible,\n:root[data-theme='dark'] .locations-search-row input[type='search']:focus-visible,\n:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):focus-visible,\n:root[data-theme='dark'] .locations-form-grid textarea:focus-visible {\n  border-color: rgba(120, 198, 238, 0.86);\n  box-shadow: 0 0 0 3px rgba(98, 175, 217, 0.26), inset 0 1px 0 rgba(146, 189, 214, 0.16);\n}\n\n:root[data-theme='dark'] .locations-maps-url-row input[type='text']:disabled,\n:root[data-theme='dark'] .locations-search-row input[type='search']:disabled,\n:root[data-theme='dark'] .locations-form-grid input:not([type='checkbox']):disabled,\n:root[data-theme='dark'] .locations-form-grid textarea:disabled {\n  border-color: rgba(81, 118, 142, 0.36);\n  background: rgba(12, 26, 37, 0.74);\n  color: rgba(167, 192, 210, 0.74);\n  box-shadow: none;\n}\n\n:root[data-theme='dark'] .locations-suggestions {\n  border-color: rgba(88, 134, 163, 0.38);\n  background: rgba(9, 20, 29, 0.92);\n}\n\n:root[data-theme='dark'] .locations-suggestion {\n  color: #e8f4fc;\n}\n\n:root[data-theme='dark'] .locations-suggestion + .locations-suggestion {\n  border-top-color: rgba(88, 134, 163, 0.32);\n}\n\n:root[data-theme='dark'] .locations-suggestion:hover {\n  background: rgba(46, 116, 163, 0.26);\n}\n\n:root[data-theme='dark'] .locations-suggestion-title {\n  color: #f2f9ff;\n}\n\n:root[data-theme='dark'] .locations-suggestion-subtitle {\n  color: #b7d1e2;\n}\n\n:root[data-theme='dark'] .locations-suggestion-coords {\n  color: #96b8cf;\n}\n\n:root[data-theme='dark'] .locations-panel .helper-text {\n  color: #b8d0df;\n}\n\n:root[data-theme='dark'] .locations-panel .helper-text.warning {\n  color: #f0d197;\n}\n\n:root[data-theme='dark'] .locations-panel .helper-text.error {\n  color: #f0a8a0;\n}\n\n:root[data-theme='dark'] .locations-table th,\n:root[data-theme='dark'] .locations-table td {\n  border-bottom-color: rgba(88, 134, 163, 0.32);\n}\n\n/* Dark mode legibility for Create Invoice modal */\n:root[data-theme='dark'] .create-card label {\n  color: #d9e9f4;\n}\n\n:root[data-theme='dark'] .create-card .form-section h4 {\n  color: #edf7ff;\n}\n\n:root[data-theme='dark'] .create-card .create-stepper .step {\n  color: #c2d8e7;\n  border-color: rgba(74, 119, 148, 0.58);\n  background: linear-gradient(140deg, rgba(14, 29, 41, 0.96), rgba(10, 22, 33, 0.94));\n}\n\n:root[data-theme='dark'] .create-card .create-stepper .step.active {\n  color: #f4fbff;\n  border-color: rgba(149, 207, 244, 0.5);\n  background: linear-gradient(130deg, #255d7c, #3b86b0);\n}\n\n:root[data-theme='dark'] .create-card .upload-list li {\n  border: 1px solid rgba(66, 105, 132, 0.62);\n  background: rgba(11, 24, 35, 0.92);\n  color: #dcecf6;\n}\n\n:root[data-theme='dark'] .create-card .upload-list li small {\n  color: #aac3d4;\n}\n\n@media (max-width: 960px) {\n  :root[data-theme='dark'] .view-tabs {\n    width: 100%;\n    overflow-x: auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .locations-collapsible,\n  .locations-collapsible-inner,\n  .locations-visibility-toggle::before {\n    transition: none;\n    animation: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .locations-header-actions {\n    width: 100%;\n  }\n\n  .locations-header-actions .btn {\n    width: 100%;\n  }\n\n  .locations-maps-url-row,\n  .locations-search-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .locations-maps-url-row .btn,\n  .locations-search-row .btn {\n    width: 100%;\n  }\n\n  :root[data-theme='dark'] .app-header {\n    padding: 1rem 1rem 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
